var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMandala7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.2406 56.12C61.6129 55.9688 61.0519 55.6165 60.6437 55.1161C60.1199 55.4938 59.4867 55.6891 58.8414 55.6723C58.2907 56.0094 57.6445 56.1567 57.0023 56.0919C56.8988 56.7294 56.5891 57.3149 56.1211 57.7599C55.9699 58.3876 55.6176 58.9486 55.1172 59.3568C55.4949 59.8806 55.6902 60.5138 55.6734 61.1591C56.0105 61.7098 56.1578 62.356 56.093 62.9982C56.7305 63.1017 57.316 63.4114 57.761 63.8794C58.3887 64.0306 58.9497 64.3829 59.3579 64.8833C59.8817 64.5056 60.5149 64.3103 61.1602 64.3271C61.7109 63.99 62.3571 63.8427 62.9993 63.9075C63.1028 63.27 63.4125 62.6845 63.8805 62.2395C64.0317 61.6118 64.384 61.0508 64.8844 60.6426C64.5067 60.1188 64.3114 59.4856 64.3282 58.8403C63.9911 58.2896 63.8438 57.6434 63.9086 57.0012C63.2711 56.8977 62.6856 56.588 62.2406 56.12ZM60.5742 55.6442C60.9781 56.0458 61.477 56.338 62.0246 56.4942C62.4336 56.8903 62.9367 57.1762 63.4863 57.3255C63.4879 57.8946 63.6336 58.4544 63.9106 58.9521C63.9195 59.5216 64.0731 60.0794 64.3566 60.5732C63.9551 60.9771 63.6625 61.4759 63.5063 62.0236C63.1102 62.4325 62.8242 62.9357 62.6754 63.4853C62.1059 63.4868 61.5461 63.6325 61.0484 63.9095C60.4789 63.9185 59.9214 64.072 59.4273 64.3556C59.0238 63.954 58.5246 63.6614 57.9769 63.5052C57.5679 63.1091 57.0652 62.8231 56.5152 62.6743C56.5136 62.1048 56.3679 61.545 56.091 61.0473C56.082 60.4778 55.9285 59.9203 55.6453 59.4262C56.0468 59.0227 56.339 58.5235 56.4953 57.9758C56.8914 57.5668 57.1773 57.0641 57.3265 56.5141C57.8957 56.5126 58.4554 56.3668 58.9531 56.0899C59.5227 56.0809 60.0804 55.9274 60.5742 55.6442Z",
    fill: "url(#paint0_linear_1835_25046)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0616 52.965C64.0291 52.1411 64.0823 51.3158 64.2202 50.5025C64.2549 50.2982 63.9815 50.1837 63.8369 50.3052C62.9557 51.0443 62.012 51.7052 61.0163 52.281C60.2038 51.4673 59.4631 50.5845 58.8033 49.6423C58.7483 49.5677 58.6541 49.5321 58.5631 49.5517C58.4721 49.5716 58.4014 49.6427 58.3823 49.7337C58.3049 50.5552 58.1428 51.3661 57.8979 52.1536C57.292 51.5938 56.7459 50.9727 56.2686 50.3001C56.2065 50.231 56.1092 50.2048 56.0209 50.2329C55.9322 50.2614 55.8686 50.3392 55.858 50.4317C55.7576 51.5774 55.5576 52.7122 55.2608 53.8231C54.1108 53.8224 52.9628 53.7216 51.8303 53.5224C51.6443 53.4892 51.4646 53.7255 51.5971 53.8849C52.1232 54.52 52.5818 55.2083 52.9655 55.9384C52.1416 55.9708 51.3163 55.9177 50.503 55.7798C50.2987 55.745 50.1842 56.0184 50.3057 56.163C51.0447 57.0442 51.7057 57.988 52.2815 58.9837C51.4678 59.7962 50.585 60.5368 49.6428 61.1966C49.5682 61.252 49.5326 61.3458 49.5522 61.4368C49.5721 61.5278 49.6432 61.5985 49.7342 61.6177C50.5557 61.695 51.3666 61.8571 52.1541 62.102C51.5943 62.7079 50.9732 63.254 50.3006 63.7313C50.2315 63.7935 50.2053 63.8907 50.2334 63.979C50.2619 64.0677 50.3397 64.1313 50.4322 64.1419C51.5779 64.2423 52.7127 64.4423 53.8236 64.7392C53.8229 65.8892 53.7221 67.0372 53.5229 68.1697C53.4897 68.3556 53.726 68.5353 53.8854 68.4029C54.5205 67.8767 55.2088 67.4181 55.9389 67.0345C55.9713 67.8583 55.9182 68.6837 55.7803 69.497C55.7455 69.7013 56.0189 69.8157 56.1635 69.6942C57.0447 68.9552 57.9885 68.2942 58.9842 67.7184C59.7967 68.5321 60.5373 69.4149 61.1971 70.3571C61.2525 70.4317 61.3463 70.4673 61.4373 70.4478C61.5283 70.4278 61.599 70.3567 61.6182 70.2657C61.6955 69.4442 61.8576 68.6333 62.1025 67.8458C62.7084 68.4056 63.2545 69.0267 63.7318 69.6993C63.7939 69.7685 63.8912 69.7946 63.9795 69.7665C64.0682 69.738 64.1318 69.6603 64.1424 69.5677C64.2428 68.422 64.4428 67.2872 64.7397 66.1763C65.8897 66.1771 67.0377 66.2778 68.1702 66.4771C68.3561 66.5103 68.5358 66.2739 68.4034 66.1146C67.8772 65.4794 67.4186 64.7912 67.035 64.0611C67.8588 64.0287 68.6842 64.0818 69.4975 64.2197C69.7018 64.2544 69.8162 63.981 69.6947 63.8365C68.9557 62.9552 68.2947 62.0115 67.7189 61.0158C68.5326 60.2033 69.4154 59.4627 70.3576 58.8029C70.4322 58.7474 70.4678 58.6536 70.4483 58.5626C70.4283 58.4716 70.3572 58.4009 70.2662 58.3818C69.4447 58.3044 68.6338 58.1423 67.8463 57.8974C68.4061 57.2915 69.0272 56.7454 69.6998 56.2681C69.769 56.206 69.7951 56.1087 69.767 56.0204C69.7385 55.9318 69.6608 55.8681 69.5682 55.8575C68.4225 55.7571 67.2877 55.5572 66.1768 55.2603C66.1776 54.1103 66.2783 52.9623 66.4776 51.8298C66.5108 51.6438 66.2744 51.4641 66.1151 51.5966C65.4799 52.1227 64.7917 52.5813 64.0616 52.965ZM60.9436 52.8318C64.9916 50.622 63.2428 49.974 63.6233 53.7236C67.0631 52.1775 65.6249 50.9728 65.7354 55.5986C70.16 56.8986 69.3819 55.2036 66.9999 58.124C70.5257 59.4631 70.3604 57.5939 67.1674 60.9431C69.3772 64.9911 70.0252 63.2423 66.2756 63.6228C67.8217 67.0626 69.0264 65.6244 64.4006 65.7349C63.1006 70.1595 64.7956 69.3814 61.8752 66.9994C60.5361 70.5252 62.4053 70.3599 59.0561 67.167C55.0081 69.3767 56.7569 70.0247 56.3764 66.2751C52.9366 67.8212 54.3748 69.0259 54.2643 64.4001C49.8397 63.1001 50.6178 64.7951 52.9998 61.8748C49.474 60.5357 49.6393 62.4048 52.8323 59.0557C50.6225 55.0077 49.9745 56.7565 53.7241 56.376C52.178 52.9362 50.9733 54.3743 55.5991 54.2638C56.8991 49.8392 55.2041 50.6173 58.1245 52.9993C59.4636 49.4739 57.5948 49.6391 60.944 52.8322L60.9436 52.8318Z",
    fill: "url(#paint1_linear_1835_25046)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7266 18.906C83.0289 19.1931 82.4309 19.6787 82.0071 20.3029C81.5833 20.9271 81.3524 21.6623 81.343 22.417C81.1544 22.6022 80.9614 22.7838 80.7586 22.958C79.3262 20.2803 75.891 20.2518 75.4348 20.058C74.672 19.7338 74.645 18.5057 72.7848 18.1592C71.5371 17.9268 71.5203 18.6061 70.1602 17.5147C68.8891 16.5432 67.2258 16.2487 65.6981 16.7237C64.3461 15.8674 62.6626 15.7217 61.1836 16.3331C59.5676 17.044 59.7551 16.3756 58.4816 16.2764C56.6351 16.1327 56.18 17.319 55.4304 17.4244C55 17.485 51.5874 16.6604 49.5374 18.8478C49.387 18.6271 49.2472 18.4013 49.1132 18.1736C49.2992 17.4424 49.2663 16.6728 49.0187 15.9599C48.771 15.2474 48.3191 14.6232 47.7195 14.1654C47.4289 14.8619 47.3496 15.6283 47.4914 16.3693C47.6332 17.1103 47.9894 17.7935 48.5164 18.3334C48.514 18.5975 48.5058 18.8627 48.4859 19.1291C45.5797 18.2486 43.1304 20.6576 42.6707 20.8428C41.9019 21.153 41.0145 20.3034 39.4543 21.3741C38.4078 22.092 38.8762 22.5843 37.1426 22.7741L37.143 22.7744C35.5571 22.9866 34.1727 23.9541 33.4285 25.3705C31.8672 25.7209 30.5734 26.8084 29.9597 28.2865C29.3198 29.9318 28.9796 29.3267 28.0089 30.1572C26.6015 31.3611 27.1187 32.5217 26.6632 33.1263C26.4015 33.4736 23.4054 35.3036 23.5027 38.2997C23.2402 38.2501 22.982 38.1892 22.7261 38.1232C22.341 37.4744 21.7734 36.9533 21.0941 36.6244C20.4152 36.2959 19.6543 36.174 18.9066 36.2744C19.1937 36.972 19.6793 37.5701 20.3035 37.9939C20.9277 38.4177 21.6629 38.6486 22.4176 38.6579C22.6028 38.8466 22.7844 39.0396 22.9586 39.2423C20.2809 40.6747 20.2524 44.1099 20.0586 44.5661C19.7344 45.329 18.5063 45.356 18.1598 47.2161C17.9274 48.4638 18.6067 48.4806 17.5153 49.8407V49.8403C16.5438 51.1118 16.2493 52.7751 16.7243 54.3024C15.868 55.6544 15.7223 57.3383 16.3337 58.8172C17.0446 60.4332 16.3763 60.2457 16.277 61.5192C16.1333 63.3657 17.3196 63.8208 17.425 64.5704C17.4856 65.0009 16.661 68.4134 18.8484 70.4634C18.6277 70.6138 18.402 70.7537 18.1742 70.8877C17.443 70.7013 16.6734 70.7341 15.9605 70.9822C15.248 71.2299 14.6238 71.6818 14.166 72.2814C14.8625 72.572 15.6289 72.6513 16.3699 72.5095C17.1109 72.3677 17.7941 72.0111 18.334 71.4841C18.5981 71.4865 18.8633 71.4947 19.1297 71.5146C18.2492 74.4208 20.6582 76.8701 20.8434 77.3298C21.1536 78.0985 20.304 78.986 21.3747 80.5462C22.0926 81.5927 22.5849 81.1243 22.7747 82.8579H22.7751C22.9872 84.4434 23.9548 85.8282 25.3712 86.5724C25.7215 88.1337 26.8091 89.4275 28.2872 90.0412C29.9325 90.681 29.3274 91.0213 30.1579 91.992C31.3618 93.3994 32.5224 92.8822 33.127 93.3377C33.4742 93.5994 35.3043 96.5955 38.3004 96.4982C38.2507 96.7607 38.1898 97.0189 38.1238 97.2747C37.475 97.6599 36.9539 98.2275 36.625 98.9063C36.2965 99.5856 36.1746 100.347 36.275 101.094C36.9727 100.807 37.5707 100.321 37.9945 99.6969C38.4183 99.0727 38.6492 98.3379 38.6586 97.5832C38.8472 97.3981 39.0402 97.2164 39.2429 97.0418C40.6753 99.7195 44.1105 99.748 44.5667 99.9418C45.3296 100.266 45.3566 101.494 47.2167 101.841C48.4644 102.073 48.4812 101.394 49.8413 102.485H49.8409C51.1124 103.457 52.7757 103.752 54.3031 103.276C55.655 104.132 57.3389 104.278 58.8178 103.667C60.4338 102.956 60.2463 103.625 61.5198 103.724C63.3663 103.868 63.8214 102.681 64.571 102.576C65.0015 102.515 68.4141 103.34 70.4641 101.152C70.6144 101.373 70.7543 101.599 70.8883 101.827C70.7019 102.558 70.7347 103.327 70.9828 104.04C71.2305 104.753 71.6824 105.377 72.282 105.835C72.5726 105.138 72.6519 104.372 72.5101 103.631C72.3683 102.89 72.0117 102.207 71.4847 101.666C71.4871 101.402 71.4953 101.137 71.5152 100.871C74.4214 101.751 76.8707 99.3423 77.3304 99.1571C78.0991 98.8469 78.9866 99.6965 80.5468 98.6258C81.5933 97.9078 81.1249 97.4156 82.8585 97.2258V97.2254C84.444 97.0137 85.8288 96.0461 86.573 94.6297C88.1343 94.2789 89.4281 93.1914 90.0418 91.7137C90.6816 90.0684 91.0219 90.6735 91.9926 89.843C93.4 88.6391 92.8828 87.4785 93.3383 86.8739C93.6 86.5266 96.5961 84.6966 96.4988 81.7005C96.7613 81.7501 97.0195 81.8111 97.2753 81.8771C97.6605 82.5259 98.2281 83.047 98.9069 83.3755C99.5863 83.7044 100.347 83.8263 101.095 83.7259C100.808 83.0282 100.322 82.4302 99.6975 82.0064C99.0733 81.5826 98.3386 81.3517 97.5839 81.3423C97.3987 81.1536 97.217 80.9607 97.0424 80.7579C99.7201 79.3255 99.7486 75.8903 99.9424 75.4341C100.267 74.6712 101.495 74.6443 101.841 72.7841C102.074 71.5364 101.394 71.5196 102.486 70.1595C103.457 68.8884 103.752 67.2251 103.277 65.6974C104.133 64.3454 104.279 62.6619 103.668 61.1826C102.957 59.5666 103.625 59.7541 103.724 58.4806C103.868 56.6341 102.682 56.179 102.576 55.4294C102.516 54.999 103.341 51.5864 101.153 49.5364C101.374 49.386 101.6 49.2462 101.827 49.1122C102.558 49.2985 103.328 49.2657 104.041 49.0181C104.753 48.7704 105.377 48.3185 105.835 47.7189C105.139 47.4282 104.373 47.3489 103.632 47.4907C102.891 47.6325 102.207 47.9888 101.667 48.5157C101.403 48.5134 101.138 48.5052 100.871 48.4853C101.752 45.5791 99.3429 43.1298 99.1577 42.6701C98.8475 41.9013 99.6971 41.0139 98.6264 39.4537C97.9084 38.4072 97.4162 38.8756 97.2264 37.142L97.226 37.1424C97.0143 35.5565 96.0467 34.1721 94.6303 33.4279C94.2795 31.8662 93.192 30.5728 91.7143 29.9591C90.069 29.3192 90.6741 28.979 89.8436 28.0083C88.6397 26.6009 87.4791 27.118 86.8745 26.6626C86.5273 26.4008 84.6972 23.4048 81.7011 23.5021C81.7507 23.2396 81.8117 22.9814 81.8777 22.7255C82.5265 22.3403 83.0476 21.7728 83.3761 21.0935C83.705 20.4146 83.827 19.6537 83.7266 18.906ZM64.4726 26.0365C64.7913 25.26 65.2952 24.5736 65.9402 24.0369C66.2671 23.7967 66.671 23.6842 67.075 23.7217C67.4793 23.7588 67.8554 23.9428 68.1332 24.2385C69.1613 25.6694 64.6109 30.2619 66.1324 30.0799C65.8726 30.3791 65.6769 30.7283 65.5574 31.1061C65.3011 30.2893 64.7769 29.5831 64.0691 29.1014C63.2609 29.3834 62.5714 29.9299 62.1125 30.6526C62.0949 30.2569 61.9965 29.8686 61.823 29.5124C63.2574 30.087 60.0074 24.494 61.4023 23.3522H61.4019C61.7469 23.1385 62.1582 23.058 62.5578 23.1268C62.9578 23.1955 63.3188 23.4084 63.5723 23.7252C64.0567 24.4108 64.3657 25.2041 64.4727 26.0361L64.4726 26.0365ZM87.1786 39.1461C87.9532 38.8227 88.7946 38.6938 89.6306 38.77C90.0314 38.8313 90.3962 39.0375 90.6556 39.3496C90.9154 39.6614 91.0513 40.0578 91.0384 40.4633C90.7536 42.2024 84.2888 42.2317 85.4931 43.1789C85.0982 43.2067 84.7126 43.3157 84.3611 43.4981C84.7572 42.7395 84.8857 41.8692 84.7259 41.0282C83.9552 40.6563 83.081 40.5551 82.2458 40.7415C82.513 40.4493 82.7177 40.1051 82.847 39.7306C83.4552 41.1509 85.1118 34.8982 86.9052 35.0771C87.3005 35.1696 87.6478 35.4036 87.8821 35.7349C88.1165 36.0665 88.2212 36.472 88.1767 36.8751C88.0341 37.7024 87.6915 38.4816 87.1786 39.1461ZM93.9645 64.4725V64.4721C94.741 64.7909 95.4274 65.2948 95.9641 65.9397C96.2043 66.2667 96.3164 66.6706 96.2793 67.0745C96.2422 67.4788 96.0586 67.855 95.7625 68.1327C94.3316 69.1608 89.7391 64.6104 89.9211 66.1319H89.9215C89.6219 65.8722 89.2727 65.6765 88.8949 65.5569C89.7117 65.3007 90.4179 64.7765 90.8996 64.0686C90.6176 63.2604 90.0711 62.5709 89.3484 62.112C89.7445 62.0945 90.1324 61.996 90.4886 61.8226C89.914 63.257 95.507 60.007 96.6488 61.4019V61.4015C96.8625 61.7464 96.9429 62.1577 96.8742 62.5574C96.8054 62.9574 96.5925 63.3183 96.2757 63.5719C95.5906 64.0563 94.7968 64.3652 93.9648 64.4723L93.9645 64.4725ZM80.8555 87.1785C81.1789 87.9531 81.3078 88.7945 81.2317 89.6305C81.1703 90.0317 80.9641 90.3961 80.652 90.6559C80.3402 90.9153 79.9438 91.0512 79.5383 91.0383C77.7992 90.7536 77.7699 84.2887 76.8227 85.493V85.4934C76.7949 85.0981 76.6859 84.7126 76.5035 84.361C77.2621 84.7571 78.1324 84.8856 78.9734 84.7259C79.3453 83.9552 79.4465 83.0814 79.2601 82.2458C79.5523 82.5134 79.8965 82.718 80.271 82.8473C78.8507 83.4555 85.1034 85.1121 84.9245 86.9055C84.832 87.3005 84.598 87.6477 84.2667 87.8821C83.9351 88.1165 83.5296 88.2211 83.1265 88.1766C82.2992 88.034 81.52 87.6914 80.8555 87.1785ZM55.5295 93.9644V93.9648C55.2107 94.741 54.7068 95.4273 54.0619 95.964C53.7349 96.2042 53.331 96.3167 52.9271 96.2796C52.5232 96.2421 52.1466 96.0585 51.8689 95.7624C50.8408 94.3315 55.3912 89.739 53.8697 89.921V89.9214C54.1294 89.6222 54.3251 89.2726 54.4447 88.8948C54.7009 89.7116 55.2251 90.4178 55.933 90.8995C56.7412 90.6175 57.4307 90.071 57.8896 89.3483C57.9072 89.7444 58.0056 90.1323 58.179 90.4885C56.7446 89.9139 59.9946 95.5069 58.5997 96.6487H58.6001C58.2552 96.8624 57.8439 96.9429 57.4442 96.8741C57.0442 96.8054 56.6833 96.5925 56.4297 96.2761C55.9453 95.5905 55.6364 94.7968 55.5293 93.9648L55.5295 93.9644ZM32.8235 80.8554C32.0489 81.1789 31.2075 81.3078 30.3715 81.2316C29.9703 81.1703 29.6059 80.964 29.3461 80.6519C29.0867 80.3402 28.9508 79.9437 28.9637 79.5382C29.2484 77.7991 35.7133 77.7698 34.509 76.8226H34.5086C34.9039 76.7949 35.2894 76.6859 35.641 76.5035C35.2449 77.2621 35.1164 78.1324 35.2761 78.9734C36.0468 79.3452 36.9206 79.4464 37.7562 79.2601C37.4886 79.5523 37.284 79.8964 37.1547 80.271C36.5465 78.8507 34.8899 85.1034 33.0965 84.9245C32.7015 84.8319 32.3543 84.5979 32.1199 84.2667C31.8855 83.935 31.7808 83.5296 31.8254 83.1265C31.968 82.2991 32.3106 81.5199 32.8235 80.8554ZM26.0376 55.5294H26.0372C25.261 55.2107 24.5747 54.7068 24.038 54.0618C23.7978 53.7349 23.6853 53.331 23.7228 52.927C23.7599 52.5227 23.9435 52.1465 24.2396 51.8688C25.6705 50.8407 30.263 55.3911 30.081 53.8696H30.0806C30.3802 54.1294 30.7294 54.3251 31.1072 54.4446C30.2904 54.7009 29.5842 55.2251 29.1025 55.9329C29.3845 56.7411 29.931 57.4306 30.6537 57.8895C30.258 57.9071 29.8697 58.0055 29.5135 58.179C30.0881 56.7446 24.4951 59.9946 23.3533 58.5997V58.6001C23.1396 58.2551 23.0591 57.8438 23.1279 57.4442C23.1966 57.0442 23.4095 56.6832 23.7263 56.4297C24.4115 55.9453 25.2052 55.6363 26.0372 55.5293L26.0376 55.5294ZM39.1472 32.8234C38.8237 32.0488 38.6948 31.2074 38.771 30.3714C38.8323 29.9706 39.0386 29.6058 39.3507 29.3464C39.6624 29.0866 40.0589 28.9507 40.4644 28.9636C42.2035 29.2484 42.2328 35.7132 43.18 34.5089C43.2077 34.9038 43.3167 35.2894 43.4991 35.6409C42.7406 35.2448 41.8702 35.1163 41.0292 35.2761C40.6574 36.0468 40.5562 36.921 40.7425 37.7562C40.4503 37.489 40.1062 37.2843 39.7316 37.155C41.1519 36.5468 34.8992 34.8902 35.0781 33.0968C35.1707 32.7015 35.4047 32.3542 35.7359 32.1198C36.0676 31.8855 36.473 31.7808 36.8761 31.8253C37.7035 31.9679 38.4827 32.3105 39.1472 32.8234ZM68.3612 26.6605C69.162 26.8437 69.8339 27.3847 70.1839 28.1281C68.8284 28.3598 67.5491 28.9148 66.4542 29.7469C68.5812 26.1375 68.198 26.6171 68.3612 26.6605ZM42.3376 30.5144L42.3372 30.5148C43.0329 30.0781 43.8907 29.9855 44.6634 30.2636C43.8689 31.3855 43.3572 32.6831 43.1712 34.0452C42.1228 29.9893 42.1907 30.5991 42.3372 30.5143L42.3376 30.5144ZM26.6606 51.6414C26.8438 50.8406 27.3848 50.1687 28.1282 49.8187C28.3598 51.1742 28.9149 52.4535 29.747 53.5484C26.1376 51.4214 26.6173 51.8046 26.6607 51.6414H26.6606ZM30.5145 77.6654C30.0781 76.9697 29.9852 76.1119 30.2637 75.3392C31.3856 76.1338 32.6828 76.6454 34.0453 76.8318C29.9894 77.8798 30.5993 77.8119 30.5145 77.6654ZM51.6415 93.3424C50.8407 93.1592 50.1688 92.6182 49.8188 91.8748C51.1743 91.6432 52.4536 91.0881 53.5485 90.256C51.4215 93.8654 51.8047 93.3857 51.6415 93.3423V93.3424ZM77.6655 89.4885C76.9698 89.9249 76.112 90.0178 75.3393 89.7393C76.1338 88.6174 76.6455 87.3202 76.8319 85.9577C77.8799 90.0136 77.812 89.4037 77.6655 89.4885ZM93.3425 68.3615C93.1593 69.1623 92.6183 69.8342 91.8749 70.1842C91.6432 68.8287 91.0882 67.5494 90.2561 66.4545C93.8655 68.5815 93.3859 68.1983 93.3425 68.3615ZM89.4886 42.3375C89.9249 43.0332 90.0179 43.891 89.7394 44.6637C88.6175 43.8692 87.3203 43.3575 85.9578 43.1711C90.0136 42.1231 89.4038 42.191 89.4886 42.3375ZM84.7933 36.1371C81.9628 40.4957 83.3941 39.7824 83.0117 37.3879C82.8961 36.6645 82.6957 35.9578 82.514 35.2469H82.5136C83.3652 35.209 84.1929 35.5321 84.7933 36.1368L84.7933 36.1371ZM60.6573 25.5961C61.7378 30.6797 62.2456 29.1633 60.2819 27.7402C59.6885 27.3101 59.0471 26.9523 58.4159 26.5785H58.4163C58.9901 25.948 59.805 25.591 60.6573 25.5961ZM36.1373 35.2098C40.4959 38.0403 39.7826 36.609 37.3881 36.9914C36.6646 37.107 35.958 37.3074 35.2471 37.4891L35.2475 37.4895C35.2096 36.6379 35.5326 35.8102 36.1373 35.2098ZM25.5973 59.3458C30.6809 58.2653 29.1645 57.7575 27.7414 59.7212C27.3113 60.3146 26.9535 60.956 26.5797 61.5872V61.5868C25.9492 61.013 25.5922 60.1981 25.5973 59.3458ZM35.211 83.8658C38.0415 79.5072 36.6102 80.2205 36.9926 82.615C37.1082 83.3385 37.3086 84.0451 37.4902 84.756L37.4906 84.7556C36.6391 84.7935 35.8114 84.4705 35.211 83.8658ZM59.347 94.4058C58.2665 89.3222 57.7587 90.8386 59.7224 92.2617C60.3157 92.6918 60.9572 93.0496 61.5884 93.4234H61.588C61.0141 94.0539 60.1993 94.4109 59.347 94.4058ZM83.867 84.7921C79.5084 81.9616 80.2217 83.3929 82.6162 83.0105C83.3396 82.8949 84.0463 82.6945 84.7572 82.5129L84.7568 82.5125C84.7947 83.364 84.4717 84.1917 83.867 84.7921ZM94.407 60.6561C89.3234 61.7366 90.8398 62.2444 92.2629 60.2807C92.693 59.6874 93.0508 59.0459 93.4246 58.4147V58.4151C94.055 58.9889 94.4121 59.8038 94.407 60.6561ZM75.314 33.4801C71.5281 36.9805 69.5199 37.1266 66.5531 38.5C62.9172 40.1832 63.9258 41.7133 63.5027 39.7059C63.9331 39.8629 64.1156 38.4954 66.3531 37.6829V37.6825C69.9062 36.6974 73.1816 34.8989 75.9203 32.4298C75.1839 36.0392 75.264 39.7673 76.155 43.3418C76.5691 45.6801 75.4847 46.534 75.8281 46.8219C73.8824 47.4579 75.707 47.5614 75.3472 43.5774C75.0562 40.3563 74.1726 38.5212 75.314 33.4804L75.314 33.4801ZM89.582 52.0751C84.4297 51.8732 82.9066 50.5567 79.8375 49.4298C76.0762 48.0489 75.7078 49.8443 76.8281 48.1255C77.0214 48.5407 78.1176 47.7029 80.2742 48.7103V48.7107C83.4836 50.5263 87.0711 51.5709 90.7532 51.7615C87.6802 53.7927 85.1009 56.4857 83.2032 59.6431C81.8427 61.5892 80.472 61.4263 80.511 61.8728C78.6856 60.9466 79.9024 62.3099 82.4653 59.2384C84.5376 56.7548 85.2106 54.8325 89.5817 52.0751L89.582 52.0751ZM86.5226 75.3131C83.0222 71.5272 82.8761 69.519 81.5027 66.5522C79.8195 62.9163 78.2894 63.9249 80.2968 63.5018C80.1397 63.9323 81.5073 64.1147 82.3198 66.3522H82.3202C83.3053 69.9053 85.1038 73.1807 87.5729 75.9194C83.9635 75.1831 80.2354 75.2632 76.6609 76.1542C74.3226 76.5682 73.4687 75.4839 73.1808 75.8272C72.5448 73.8815 72.4413 75.7062 76.4253 75.3464C79.6464 75.0554 81.4815 74.1718 86.5223 75.3132L86.5226 75.3131ZM67.9276 89.5811C68.1295 84.4288 69.446 82.9057 70.5729 79.8366C71.9538 76.0753 70.1584 75.7069 71.8772 76.8272C71.4619 77.0206 72.2998 78.1167 71.2924 80.2733H71.292C69.4764 83.4827 68.4318 87.0702 68.2412 90.7523C66.21 87.6793 63.517 85.1 60.3596 83.2023C58.4135 81.8418 58.5764 80.4711 58.1299 80.5101C59.0561 78.6847 57.6928 79.9015 60.7643 82.4644C63.2479 84.5367 65.1702 85.2097 67.9276 89.5808L67.9276 89.5811ZM44.6896 86.5217C48.4755 83.0213 50.4837 82.8752 53.4505 81.5018C57.0864 79.8186 56.0778 78.2885 56.5009 80.2959C56.0704 80.1389 55.888 81.5064 53.6505 82.3189V82.3193C50.0974 83.3045 46.822 85.1029 44.0833 87.572C44.8196 83.9626 44.7395 80.2345 43.8485 76.66C43.4344 74.3217 44.5188 73.4678 44.1755 73.1799C46.1212 72.544 44.2965 72.4405 44.6563 76.4244C44.9473 79.6455 45.8309 81.4806 44.6895 86.5214L44.6896 86.5217ZM30.4216 67.9267C35.5739 68.1287 37.097 69.4451 40.1661 70.572C43.9274 71.9529 44.2958 70.1576 43.1755 71.8763C42.9821 71.4611 41.886 72.299 39.7294 71.2915V71.2912C36.52 69.4756 32.9325 68.431 29.2504 68.2404C32.3234 66.2092 34.9027 63.5162 36.8004 60.3588C38.1609 58.4127 39.5316 58.5756 39.4926 58.1291C41.318 59.0552 40.1012 57.6919 37.5383 60.7635C35.466 63.2471 34.793 65.1694 30.4219 67.9268L30.4216 67.9267ZM33.481 44.6887C36.9814 48.4746 37.1275 50.4828 38.5009 53.4496C40.1841 57.0855 41.7142 56.0769 39.7068 56.5C39.8638 56.0695 38.4963 55.8871 37.6838 53.6496H37.6834C36.6982 50.0965 34.8998 46.8211 32.4307 44.0824C36.0401 44.8187 39.7682 44.7387 43.3427 43.8476C45.681 43.4336 46.5349 44.518 46.8228 44.1746C47.4587 46.1203 47.5622 44.2957 43.5783 44.6555C40.3572 44.9465 38.5221 45.8301 33.4813 44.6887L33.481 44.6887ZM52.076 30.4207C51.874 35.573 50.5576 37.0961 49.4307 40.1652C48.0498 43.9265 49.8451 44.2949 48.1264 43.1746C48.5416 42.9813 47.7037 41.8851 48.7111 39.7285H48.7115C50.5271 36.5191 51.5717 32.9316 51.7623 29.2495C53.7935 32.3225 56.4865 34.9018 59.6439 36.7995C61.59 38.16 61.4271 39.5307 61.8736 39.4917C60.9475 41.3171 62.3107 40.1003 59.2392 37.5374C56.7556 35.4651 54.8333 34.7921 52.0759 30.421L52.076 30.4207ZM62.7654 39.0102C63.1029 40.67 63.2279 42.3661 63.1372 44.0575C62.6579 44.2485 62.2505 44.5856 61.9739 45.0212C61.8193 44.529 61.513 44.0977 61.0993 43.7892C61.9634 41.14 61.3966 41.5504 62.7654 39.0102ZM76.799 47.1125C75.8642 48.525 74.7533 49.8125 73.4935 50.9445C73.0193 50.7402 72.4927 50.691 71.9888 50.8031C72.2278 50.3457 72.3165 49.8246 72.2419 49.3136C74.7259 48.0511 74.0353 47.9409 76.7989 47.1124L76.799 47.1125ZM80.9931 62.7645C79.3333 63.102 77.6372 63.227 75.9458 63.1364C75.7548 62.6571 75.4177 62.2497 74.9821 61.9731C75.4743 61.8184 75.9056 61.5122 76.2141 61.0985C78.8633 61.9625 78.4529 61.3958 80.9931 62.7645ZM72.8908 76.7975C71.4783 75.8627 70.1908 74.7518 69.0588 73.492C69.2631 73.0178 69.3123 72.4912 69.2002 71.9877C69.6576 72.2264 70.1787 72.3151 70.6897 72.2404C71.9522 74.7244 72.0624 74.0338 72.8909 76.7975L72.8908 76.7975ZM57.2388 80.9916C56.9013 79.3318 56.7763 77.6357 56.8669 75.9443C57.3462 75.7533 57.7536 75.4162 58.0302 74.9806C58.1849 75.4728 58.4911 75.9041 58.9048 76.2126C58.0407 78.8618 58.6075 78.4514 57.2388 80.9916ZM43.2058 72.8893C44.1405 71.4768 45.2515 70.1893 46.5113 69.0573C46.9855 69.2616 47.5121 69.3108 48.0156 69.1987C47.7769 69.6562 47.6882 70.1772 47.7628 70.6882C45.2788 71.9507 45.9694 72.0609 43.2058 72.8894L43.2058 72.8893ZM39.0117 57.2373C40.6715 56.8998 42.3676 56.7748 44.059 56.8654C44.25 57.3447 44.5871 57.7522 45.0226 58.0287C44.5305 58.1834 44.0992 58.4897 43.7906 58.9034C41.1414 58.0393 41.5519 58.606 39.0117 57.2373ZM47.114 43.2033V43.2037C48.5265 44.1385 49.814 45.2494 50.946 46.5092C50.7417 46.9834 50.6925 47.51 50.8046 48.0135C50.3471 47.7748 49.826 47.6862 49.3151 47.7608C48.0526 45.2768 47.9424 45.9674 47.1139 43.2038L47.114 43.2033ZM63.953 29.9927C64.517 30.4743 64.8885 31.1435 64.9987 31.8771C65.112 32.6552 65.2713 32.5041 64.6381 32.4181C64.9018 32.0494 64.1889 31.079 63.8498 30.7759C63.444 30.981 62.5041 31.7341 62.6635 32.1583C62.0288 32.0771 62.1448 32.2634 62.4553 31.5423H62.455C62.751 30.8622 63.2831 30.3118 63.953 29.9927ZM84.015 41.5743L84.0146 41.5747C84.0732 42.3145 83.8626 43.0501 83.4216 43.647C82.9513 44.2771 83.1708 44.2829 82.7837 43.7747C83.2306 43.7005 83.413 42.5102 83.3876 42.0559C82.9556 41.9137 81.7587 41.7821 81.5712 42.1946C81.1798 41.6884 81.1298 41.9024 81.8595 41.6118L81.8599 41.6114C82.5501 41.3399 83.3154 41.327 84.0146 41.5751L84.015 41.5743ZM90.0107 63.9503L90.0103 63.9507C89.5286 64.5152 88.8595 64.8867 88.1259 64.9968C87.3478 65.1101 87.4989 65.2695 87.5849 64.6363C87.9536 64.8999 88.924 64.187 89.2271 63.848C89.022 63.4421 88.2689 62.5023 87.8447 62.6617C87.9259 62.0269 87.7396 62.1429 88.4607 62.4535V62.4531C89.1408 62.7492 89.6912 63.2812 90.0103 63.9511L90.0107 63.9503ZM78.4287 84.0123L78.4283 84.0127C77.6884 84.0713 76.9529 83.8608 76.356 83.4197C75.7259 82.9494 75.7201 83.169 76.2283 82.7819C76.3025 83.2287 77.4928 83.4111 77.9471 83.3858C78.0892 82.9537 78.2209 81.7569 77.8084 81.5694C78.3146 81.1779 78.1006 81.128 78.3912 81.8576L78.3916 81.858C78.6631 82.5483 78.6764 83.3135 78.4279 84.0127L78.4287 84.0123ZM56.0517 90.0084C55.4876 89.5268 55.1161 88.8576 55.006 88.124C54.8927 87.3459 54.7333 87.4971 55.3665 87.583C55.1029 87.9517 55.8157 88.9221 56.1548 89.2252C56.5607 89.0201 57.5005 88.267 57.3411 87.8428C57.9759 87.924 57.8599 87.7377 57.5493 88.4588H57.5497C57.2536 89.1389 56.7216 89.6893 56.0517 90.0084ZM35.9901 78.426C35.9315 77.6866 36.142 76.951 36.583 76.3541C37.0533 75.724 36.8338 75.7182 37.2209 76.2264C36.774 76.3006 36.5916 77.4909 36.617 77.9452C37.049 78.0874 38.2459 78.219 38.4334 77.8065C38.8248 78.3128 38.8748 78.0987 38.1451 78.3893L38.1447 78.3897C37.4545 78.6612 36.6893 78.6741 35.9901 78.426ZM29.9944 56.0504C30.476 55.4864 31.1452 55.1149 31.8788 55.0047C32.6569 54.8914 32.5057 54.7321 32.4198 55.3653C32.051 55.1016 31.0807 55.8145 30.7776 56.1535C30.9827 56.5594 31.7358 57.4993 32.16 57.3399C32.0787 57.9746 32.2651 57.8586 31.544 57.548V57.5484C30.8639 57.2523 30.3135 56.7203 29.9944 56.0504ZM41.5768 35.9888C42.3162 35.9302 43.0518 36.1408 43.6487 36.5818C44.2787 37.0521 44.2846 36.8326 43.7764 37.2197C43.7022 36.7728 42.5119 36.5904 42.0576 36.6158C41.9154 37.0478 41.7838 38.2447 42.1963 38.4322C41.69 38.8236 41.9041 38.8736 41.6135 38.1439L41.6131 38.1435C41.3416 37.4533 41.3287 36.688 41.5768 35.9888ZM63.7194 31.7595C64.2057 32.5365 64.1577 32.3451 63.6381 32.3767C63.1444 32.2123 63.0487 32.3841 63.7194 31.7599V31.7595ZM82.5994 42.6605C82.3939 43.5539 82.4951 43.3843 82.1056 43.0394C81.8732 42.5738 81.6834 42.6273 82.5994 42.6605ZM88.242 63.7185C87.465 64.2048 87.6564 64.1568 87.6248 63.6373C87.7896 63.1435 87.6178 63.0478 88.242 63.7185ZM77.341 82.5985C76.4476 82.3931 76.6172 82.4942 76.9621 82.1048C77.4277 81.8723 77.3742 81.6825 77.341 82.5985ZM56.283 88.2411C55.7966 87.4642 55.8447 87.6556 56.3642 87.6239C56.858 87.7888 56.9537 87.6169 56.283 88.2411ZM37.403 77.3401C37.6084 76.4468 37.5073 76.6163 37.8967 76.9612C38.1291 77.4268 38.319 77.3733 37.403 77.3401ZM31.7604 56.2821C32.5373 55.7958 32.3459 55.8438 32.3776 56.3634C32.2127 56.8571 32.3846 56.9528 31.7604 56.2821ZM42.6614 37.4021C43.5547 37.6076 43.3852 37.5064 43.0403 37.8959C42.5747 38.1283 42.6282 38.3181 42.6614 37.4021ZM63.5294 33.2087C64.5442 33.1599 65.5505 33.4173 66.4177 33.9474C67.2845 34.4779 67.972 35.2564 68.3911 36.1822C68.0911 36.3087 67.7887 36.4322 67.4848 36.5525C61.9973 38.7087 64.1465 40.9857 62.9325 37.742C60.9567 40.51 63.5259 38.8736 58.843 35.415C58.5801 35.2209 58.32 35.0232 58.0633 34.8228L58.0637 34.8224C58.7079 34.0365 59.5735 33.4626 60.5481 33.1747C61.5227 32.8868 62.5615 32.899 63.5294 33.2087ZM81.441 43.5497C82.1933 44.2329 82.723 45.1263 82.9609 46.1142C83.1992 47.1021 83.1347 48.1388 82.7761 49.09C82.4742 48.9674 82.1734 48.8412 81.8734 48.7111C76.4683 46.3556 76.3781 49.4853 77.8132 46.3334C74.4589 46.8936 77.4323 47.5533 76.5671 41.7963C76.5187 41.4729 76.4749 41.1494 76.4347 40.8264L76.4351 40.826C77.4464 40.726 78.4644 40.9319 79.357 41.4178C80.2499 41.9033 80.9758 42.6462 81.441 43.5497ZM86.7941 63.5277C86.8429 64.5425 86.5855 65.5488 86.0554 66.416C85.5249 67.2828 84.7464 67.9703 83.8206 68.3894C83.694 68.0894 83.5706 67.7871 83.4503 67.4832C81.2941 61.9957 79.0171 64.1449 82.2608 62.9309C79.4928 60.9551 81.1292 63.5242 84.5878 58.8414C84.7819 58.5785 84.9796 58.3183 85.18 58.0617L85.1804 58.0621C85.9663 58.7062 86.5402 59.5719 86.8281 60.5465C87.116 61.5211 87.1038 62.5598 86.7941 63.5277ZM76.4531 81.4387C75.7699 82.1911 74.8765 82.7207 73.8886 82.9586C72.9007 83.1969 71.864 83.1324 70.9128 82.7738C71.0354 82.4719 71.1616 82.1711 71.2917 81.8711C73.6472 76.466 70.5175 76.3758 73.6694 77.8109C73.1092 74.4566 72.4495 77.4301 78.2065 76.5648C78.5299 76.5164 78.8534 76.4726 79.1764 76.4324L79.1768 76.4328C79.2768 77.4441 79.0709 78.4621 78.585 79.3547C78.0994 80.2477 77.3566 80.9735 76.4531 81.4387ZM56.4751 86.7918C55.4603 86.8407 54.454 86.5832 53.5868 86.0532C52.72 85.5227 52.0325 84.7441 51.6134 83.8184C51.9134 83.6918 52.2157 83.5684 52.5196 83.448C58.0071 81.2918 55.8579 79.0148 57.0719 82.2585C59.0477 79.4905 56.4786 81.1269 61.1614 84.5855C61.4243 84.7797 61.6845 84.9773 61.9411 85.1777L61.9407 85.1781C61.2966 85.9641 60.4309 86.5379 59.4563 86.8258C58.4817 87.1137 57.443 87.1016 56.4751 86.7918ZM38.5641 76.4508C37.8117 75.7676 37.2821 74.8742 37.0442 73.8863C36.8059 72.8984 36.8703 71.8617 37.2289 70.9105C37.5309 71.0332 37.8317 71.1594 38.1317 71.2894C43.5368 73.6449 43.627 70.5152 42.1919 73.6671C45.5462 73.107 42.5727 72.4472 43.438 78.2042C43.4864 78.5277 43.5302 78.8511 43.5704 79.1741L43.57 79.1745C42.5587 79.2745 41.5407 79.0687 40.6481 78.5827C39.7551 78.0972 39.0293 77.3543 38.5641 76.4508ZM33.211 56.4728C33.1621 55.458 33.4196 54.4517 33.9496 53.5845C34.4801 52.7177 35.2586 52.0302 36.1844 51.6111C36.311 51.9111 36.4344 52.2135 36.5548 52.5174C38.711 58.0049 40.988 55.8557 37.7443 57.0697C40.5123 59.0455 38.8759 56.4763 35.4173 61.1592C35.2231 61.4221 35.0255 61.6822 34.8251 61.9389L34.8247 61.9385C34.0387 61.2943 33.4649 60.4287 33.177 59.4541C32.8891 58.4795 32.9012 57.4407 33.211 56.4728ZM43.552 38.5612C44.2352 37.8089 45.1286 37.2792 46.1165 37.0413C47.1044 36.803 48.1411 36.8675 49.0923 37.2261C48.9696 37.528 48.8434 37.8288 48.7134 38.1288C46.3579 43.5339 49.4876 43.6241 46.3357 42.189C46.8958 45.5433 47.5556 42.5699 41.7986 43.4351C41.4751 43.4835 41.1517 43.5273 40.8286 43.5675L40.8283 43.5671C40.7283 42.5558 40.9341 41.5378 41.4201 40.6452C41.9056 39.7523 42.6485 39.0264 43.552 38.5612ZM72.015 39.1936C70.6345 39.8253 69.1962 40.3213 67.7205 40.676C66.2787 41.2319 64.7357 42.4959 65.0326 44.2295C65.1154 44.7143 64.7978 43.7479 63.5611 43.942L63.5615 43.9416C63.747 43.0952 63.8064 42.226 63.7384 41.3623C65.7423 38.3834 69.6306 38.1889 72.5611 36.4455C74.992 34.9994 74.1572 34.6045 74.1213 37.3463C74.0768 40.7561 75.8525 44.2201 74.2748 47.4453V47.4457C73.4928 47.8188 72.7701 48.3051 72.1299 48.8887C71.9335 48.3735 71.512 47.9758 70.9858 47.8098C72.6745 47.325 73.1487 45.3762 72.8788 43.6539C72.4476 42.1988 72.1585 40.7051 72.0152 39.1937L72.015 39.1936ZM83.209 53.7816V53.782C81.7863 53.2523 80.4184 52.5863 79.1242 51.7933C77.7117 51.1671 75.7269 50.9695 74.7109 52.4054C74.4269 52.807 74.8855 51.8988 73.8738 51.1616H73.8742C74.6038 50.694 75.2605 50.1218 75.823 49.4632C79.3464 48.7738 82.2332 51.3855 85.5382 52.2249C88.2792 52.9214 87.9687 52.0515 86.0046 53.9651C83.562 56.3448 82.3683 60.0499 78.9718 61.2147C78.1554 60.9257 77.3003 60.7585 76.4347 60.7186C76.6604 60.2147 76.6433 59.6358 76.3886 59.1463C77.9257 59.9979 79.639 58.9549 80.6656 57.5463H80.666C81.3902 56.2123 82.2418 54.9514 83.209 53.7818L83.209 53.7816ZM80.809 72.0126C80.1773 70.6321 79.6813 69.1938 79.3266 67.7181C78.7707 66.2763 77.5067 64.7333 75.7731 65.0302C75.2883 65.113 76.2547 64.7955 76.0606 63.5587L76.061 63.5591C76.9074 63.7447 77.7766 63.804 78.6403 63.7361C81.6192 65.74 81.8137 69.6283 83.5571 72.5588C85.0032 74.9897 85.3981 74.1549 82.6563 74.119C79.2465 74.0744 75.7825 75.8502 72.5573 74.2725H72.5569C72.1838 73.4905 71.6975 72.7678 71.1139 72.1276C71.6291 71.9311 72.0268 71.5096 72.1928 70.9835C72.6776 72.6722 74.6264 73.1464 76.3487 72.8765C77.8038 72.4452 79.2975 72.1562 80.8089 72.0128L80.809 72.0126ZM66.221 83.2066C66.7507 81.7839 67.4167 80.416 68.2097 79.1218C68.8358 77.7093 69.0335 75.7245 67.5976 74.7085C67.196 74.4245 68.1042 74.8831 68.8414 73.8714V73.8718C69.309 74.6015 69.8812 75.2581 70.5398 75.8206C71.2292 79.344 68.6175 82.2308 67.7781 85.5358C67.0816 88.2768 67.9515 87.9663 66.0379 86.0022C63.6582 83.5596 59.9531 82.3659 58.7883 78.9694C59.0773 78.153 59.2445 77.2979 59.2844 76.4323C59.7883 76.6581 60.3672 76.6409 60.8567 76.3862C60.0051 77.9233 61.0481 79.6366 62.4567 80.6632V80.6636C63.7907 81.3878 65.0516 82.2394 66.2212 83.2066L66.221 83.2066ZM47.991 80.8066C49.3715 80.175 50.8098 79.6789 52.2855 79.3242C53.7273 78.7684 55.2703 77.5043 54.9734 75.7707C54.8906 75.286 55.2081 76.2524 56.4449 76.0582L56.4445 76.0586C56.2589 76.9051 56.1996 77.7742 56.2675 78.6379C54.2636 81.6168 50.3753 81.8113 47.4448 83.5547C45.0139 85.0008 45.8487 85.3957 45.8846 82.6539C45.9292 79.2441 44.1534 75.7801 45.7311 72.5549V72.5545C46.5131 72.1815 47.2358 71.6952 47.876 71.1115C48.0725 71.6268 48.494 72.0244 49.0201 72.1904C47.3314 72.6752 46.8572 74.6241 47.1271 76.3464C47.5584 77.8015 47.8474 79.2952 47.9908 80.8065L47.991 80.8066ZM36.797 66.2186C38.2197 66.7483 39.5876 67.4143 40.8818 68.2073C42.2943 68.8335 44.2791 69.0312 45.2951 67.5952C45.5791 67.1937 45.1205 68.1019 46.1322 68.839H46.1318C45.4021 69.3066 44.7455 69.8788 44.183 70.5374C40.6596 71.2269 37.7728 68.6151 34.4678 67.7757C31.7268 67.0792 32.0373 67.9492 34.0014 66.0355C36.444 63.6558 37.6377 59.9507 41.0342 58.7859C41.8506 59.075 42.7057 59.2422 43.5713 59.282C43.3455 59.7859 43.3627 60.3648 43.6174 60.8543C42.0803 60.0028 40.367 61.0457 39.3404 62.4543H39.34C38.6158 63.7883 37.7642 65.0492 36.797 66.2188L36.797 66.2186ZM39.197 47.9886C39.8286 49.3691 40.3247 50.8074 40.6794 52.2831C41.2352 53.7249 42.4993 55.2679 44.2329 54.971C44.7176 54.8882 43.7512 55.2058 43.9454 56.4425L43.945 56.4421C43.0985 56.2566 42.2294 56.1972 41.3657 56.2652C38.3868 54.2613 38.1923 50.373 36.4489 47.4425C35.0028 45.0116 34.6079 45.8464 37.3497 45.8823C40.7595 45.9268 44.2235 44.1511 47.4487 45.7288H47.4491C47.8221 46.5108 48.3084 47.2335 48.8921 47.8737C48.3768 48.0701 47.9792 48.4916 47.8132 49.0178C47.3284 47.3291 45.3796 46.8549 43.6573 47.1248C42.2022 47.556 40.7085 47.8451 39.1971 47.9884L39.197 47.9886ZM53.785 36.7946H53.7854C53.2557 38.2173 52.5897 39.5852 51.7967 40.8794C51.1705 42.2919 50.9728 44.2767 52.4088 45.2927C52.8103 45.5767 51.9021 45.1181 51.165 46.1298V46.1294C50.6974 45.3998 50.1252 44.7431 49.4666 44.1806C48.7771 40.6572 51.3889 37.7704 52.2283 34.4654C52.9248 31.7244 52.0548 32.0349 53.9685 33.999C56.3482 36.4416 60.0533 37.6353 61.2181 41.0318C60.929 41.8482 60.7618 42.7033 60.722 43.5689C60.2181 43.3432 59.6392 43.3603 59.1497 43.615C60.0012 42.0779 58.9583 40.3646 57.5497 39.338V39.3376C56.2157 38.6134 54.9548 37.7618 53.7852 36.7946L53.785 36.7946ZM61.7194 46.9646C62.5729 49.4126 66.2729 48.0501 61.3983 49.4021C56.9616 46.788 60.2167 49.1748 61.7198 46.9646H61.7194ZM70.4346 51.9962C69.3069 54.3306 72.8869 55.9837 68.4838 53.4931C67.1951 48.5072 67.8096 52.4963 70.435 51.9966L70.4346 51.9962ZM73.0393 61.7169C70.5913 62.5705 71.9538 66.2704 70.6018 61.3958C73.2163 56.9591 70.8295 60.2142 73.0397 61.7173L73.0393 61.7169ZM68.0077 70.4325C65.6733 69.3048 64.0202 72.8848 66.5108 68.4817C71.4971 67.1926 67.508 67.8071 68.0077 70.4325ZM58.287 73.0372C57.4335 70.5892 53.7335 71.9517 58.6081 70.5997C63.0452 73.2138 59.7901 70.8271 58.287 73.0372ZM49.5718 68.0052C50.6995 65.6708 47.1195 64.0177 51.5226 66.5083C52.8117 71.4946 52.1972 67.5056 49.5718 68.0052ZM46.9671 58.2845C49.4151 57.431 48.0526 53.731 49.4046 58.6056C46.7905 63.0427 49.1772 59.7876 46.9671 58.2845ZM51.9987 49.5693C54.3331 50.697 55.9862 47.117 53.4956 51.5201C48.5097 52.8092 52.4987 52.1947 51.9991 49.5693H51.9987ZM61.3264 49.9525C63.3049 49.6541 65.2096 48.9865 66.9412 47.9841C66.9376 49.9849 67.3119 51.9689 68.0439 53.831C69.6541 55.0189 71.4732 55.8939 73.4064 56.4095C71.9888 57.822 70.8509 59.4892 70.0517 61.324C70.3501 63.3025 71.0177 65.2072 72.0201 66.9388C70.0193 66.9353 68.0353 67.3095 66.1732 68.0415C64.9853 69.6517 64.1103 71.4708 63.5947 73.404C62.1822 71.9864 60.515 70.8485 58.6802 70.0493C56.7017 70.3478 54.797 71.0154 53.0654 72.0177C53.0689 70.0169 52.6947 68.0329 51.9627 66.1708C50.3525 64.9829 48.5334 64.1079 46.6002 63.5923C48.0178 62.1798 49.1557 60.5126 49.9549 58.6778C49.6564 56.6993 48.9888 54.7946 47.9865 53.063C49.9873 53.0665 51.9713 52.6923 53.8334 51.9603C55.0217 50.3501 55.8963 48.531 56.4119 46.5978C57.8244 48.0154 59.4916 49.1533 61.3264 49.9525ZM68.7901 44.7822C68.783 44.4295 68.6268 44.0963 68.3596 43.8658C68.2112 43.7361 67.985 43.9576 68.1131 44.1096C68.8116 44.9377 67.8041 46.3405 66.5029 45.5241C64.9162 44.5284 65.1283 41.9128 68.7127 40.96C69.6412 40.7568 70.5561 40.4943 71.4506 40.1736C71.7373 42.3209 73.2342 44.8244 71.7873 46.6045C71.4916 46.9608 71.0842 47.2065 70.6311 47.3026C70.1781 47.3987 69.7058 47.3393 69.2909 47.1338C67.9714 46.4354 68.623 44.8377 69.7109 45.0322C69.7968 45.0408 69.8761 44.9854 69.898 44.9018C69.9198 44.8186 69.8777 44.7315 69.7987 44.6967C69.4655 44.5807 69.0987 44.6119 68.7901 44.7822ZM76.978 55.4528C77.2221 55.1989 77.3471 54.8528 77.3213 54.5009C77.3084 54.4157 77.2354 54.3524 77.1487 54.3517C77.0623 54.3513 76.9885 54.4138 76.9748 54.4989C76.883 55.5786 75.1787 55.8579 74.8361 54.3603C74.4182 52.5341 76.4177 50.8345 79.6259 52.6955L79.6255 52.6959C80.4259 53.2087 81.2584 53.6697 82.1182 54.0756C80.8026 55.7966 80.0909 58.6251 77.8088 58.861C77.3474 58.9036 76.8857 58.7896 76.4974 58.5372C76.1092 58.2849 75.8174 57.9087 75.6689 57.47C75.2299 56.043 76.8205 55.3739 77.4517 56.2805H77.4521C77.5068 56.3473 77.6017 56.3645 77.6763 56.3211C77.751 56.2774 77.7826 56.186 77.7513 56.1055C77.5978 55.7883 77.3166 55.5509 76.978 55.4528ZM75.2221 68.7882C75.5748 68.7812 75.908 68.6249 76.1385 68.3578C76.2682 68.2093 76.0467 67.9831 75.8947 68.1113C75.0666 68.8097 73.6638 67.8023 74.4802 66.5011C75.4759 64.9144 78.0915 65.1265 79.0443 68.7109C79.2475 69.6394 79.51 70.5543 79.8307 71.4488C77.6834 71.7355 75.1799 73.2324 73.3998 71.7855C73.0435 71.4898 72.7978 71.0824 72.7017 70.6293C72.6056 70.1762 72.665 69.7039 72.8705 69.2891C73.5689 67.9696 75.1666 68.6211 74.9721 69.709C74.9635 69.7949 75.0189 69.8742 75.1025 69.8961C75.1857 69.918 75.2728 69.8758 75.3076 69.7969C75.4236 69.4637 75.3924 69.0968 75.2221 68.7882ZM64.5515 76.9761C64.8054 77.2203 65.1515 77.3453 65.5034 77.3195C65.5886 77.3066 65.6519 77.2335 65.6526 77.1468C65.653 77.0605 65.5905 76.9867 65.5054 76.9726C64.4257 76.8808 64.1464 75.1765 65.644 74.8339C67.4702 74.4159 69.1698 76.4155 67.3088 79.6237H67.3084C66.7956 80.4241 66.3346 81.2565 65.9287 82.1163C64.2076 80.8007 61.3791 80.089 61.1432 77.8069C61.1007 77.3456 61.2147 76.8839 61.4671 76.4956C61.7194 76.1073 62.0956 75.8155 62.5343 75.6671C63.9613 75.228 64.6304 76.8187 63.7238 77.4499V77.4503C63.657 77.505 63.6398 77.5999 63.6832 77.6745C63.7269 77.7491 63.8183 77.7807 63.8988 77.7495C64.216 77.596 64.4534 77.3148 64.5515 76.9761ZM51.2161 75.2202C51.2231 75.573 51.3794 75.9062 51.6465 76.1366C51.795 76.2663 52.0212 76.0448 51.893 75.8929C51.1946 75.0648 52.202 73.662 53.5032 74.4784C55.0899 75.4741 54.8778 78.0897 51.2934 79.0425C50.3649 79.2456 49.45 79.5081 48.5555 79.8288C48.2688 77.6815 46.7719 75.178 48.2188 73.3979C48.5145 73.0417 48.9219 72.796 49.375 72.6999C49.8281 72.6038 50.3004 72.6631 50.7152 72.8686C52.0347 73.5671 51.3832 75.1647 50.2953 74.9702C50.2094 74.9616 50.1301 75.0171 50.1082 75.1007C50.0863 75.1839 50.1285 75.271 50.2074 75.3058C50.5406 75.4218 50.9075 75.3905 51.2161 75.2202ZM43.0282 64.5496C42.784 64.8035 42.659 65.1496 42.6848 65.5016C42.6977 65.5867 42.7708 65.65 42.8575 65.6508C42.9438 65.6512 43.0176 65.5887 43.0313 65.5035C43.1231 64.4238 44.8274 64.1445 45.17 65.6422C45.588 67.4684 43.5884 69.168 40.3802 67.307L40.3806 67.3066C39.5802 66.7937 38.7478 66.3328 37.888 65.9269C39.2036 64.2058 39.9153 61.3773 42.1974 61.1414C42.6587 61.0988 43.1204 61.2129 43.5087 61.4652C43.897 61.7176 44.1888 62.0938 44.3372 62.5324C44.7763 63.9594 43.1856 64.6285 42.5544 63.7219H42.554C42.4993 63.6547 42.4044 63.6379 42.3298 63.6813C42.2552 63.7251 42.2236 63.8165 42.2548 63.8969C42.4083 64.2141 42.6895 64.4516 43.0282 64.5496ZM44.7841 51.2142C44.4313 51.2213 44.0981 51.3775 43.8677 51.6447C43.738 51.7931 43.9595 52.0193 44.1114 51.8912C44.9395 51.1927 46.3423 52.2002 45.5259 53.5014C44.5302 55.0881 41.9146 54.876 40.9618 51.2916C40.7587 50.3631 40.4962 49.4482 40.1755 48.5537C42.3228 48.267 44.8263 46.7701 46.6064 48.217C46.9626 48.5127 47.2083 48.9201 47.3044 49.3732C47.4005 49.8262 47.3411 50.2982 47.1357 50.7134C46.4372 52.0329 44.8396 51.3813 45.0341 50.2934C45.0427 50.2075 44.9872 50.1282 44.9036 50.1063C44.8204 50.0845 44.7333 50.1266 44.6985 50.2055C44.5825 50.5387 44.6138 50.9056 44.7841 51.2142ZM55.4547 43.0263C55.2008 42.7822 54.8547 42.6572 54.5027 42.683C54.4176 42.6959 54.3543 42.7689 54.3535 42.8556C54.3531 42.942 54.4156 43.0158 54.5008 43.0295C55.5805 43.1213 55.8598 44.8256 54.3621 45.1682C52.5359 45.5861 50.8363 43.5866 52.6973 40.3784L52.6977 40.3787C53.2106 39.5784 53.6715 38.7459 54.0774 37.8861C55.7985 39.2017 58.627 39.9134 58.8629 42.1955C58.9055 42.6569 58.7914 43.1186 58.5391 43.5068C58.2867 43.8951 57.9105 44.1869 57.4719 44.3354C56.0449 44.7744 55.3758 43.1838 56.2824 42.5526V42.5522C56.3492 42.4975 56.3664 42.4026 56.323 42.328C56.2792 42.2533 56.1878 42.2217 56.1074 42.253C55.7902 42.4065 55.5527 42.6877 55.4547 43.0263ZM67.6427 46.7681C66.772 47.3494 65.8372 47.8286 64.8572 48.197C63.617 48.3396 62.0248 47.7076 62.0736 46.2306C62.1619 43.5587 65.9619 44.2583 64.5256 46.1904C64.4908 46.1607 64.4615 46.1373 64.4299 46.1111C64.9518 45.7377 64.2963 44.7779 63.5131 45.0423C62.7537 45.2985 62.8385 46.3333 63.3467 46.781H63.3471C63.649 46.9908 64.0189 47.0787 64.383 47.0279C64.747 46.9767 65.0787 46.79 65.3111 46.5052C65.5435 46.2204 65.6599 45.8583 65.6372 45.4911C65.8728 45.8177 66.2017 46.0653 66.581 46.2009C66.9599 46.3368 67.3712 46.3548 67.7607 46.2521C68.1044 46.1403 67.9556 46.0548 68.031 46.4079C68.1365 46.7966 68.3576 47.1439 68.665 47.4044C68.972 47.6646 69.3509 47.8259 69.7513 47.8665C69.4224 48.0302 69.1673 48.3122 69.0368 48.656C68.9064 48.9997 68.9107 49.3802 69.0482 49.7208C69.186 50.0618 69.447 50.3379 69.7798 50.495C70.4216 50.7114 71.3603 50.2676 71.2025 49.4817C71.0431 48.6868 69.8818 48.5735 69.8185 49.2219C69.7802 49.2075 69.7451 49.1938 69.7021 49.1785C70.6587 46.9652 73.1673 49.9075 70.8931 51.3224C69.6384 52.1032 68.2951 51.0403 67.7982 49.8951C67.6271 48.8623 67.5747 47.8131 67.6427 46.7681ZM74.7618 56.0462C73.7352 55.8415 72.7352 55.5193 71.7821 55.0868C70.804 54.3107 70.1255 52.738 71.2043 51.7282C73.1559 49.9012 75.3481 53.0829 72.9668 53.4337C72.9633 53.3884 72.959 53.3509 72.9551 53.3103C73.5883 53.415 73.8036 52.2732 73.0625 51.906C72.3442 51.5501 71.6724 52.3419 71.7156 53.0177H71.7153C71.7805 53.3794 71.9797 53.7033 72.2735 53.9247C72.5668 54.1462 72.9332 54.2486 73.2993 54.2115C73.6649 54.1743 74.0036 54.0009 74.2469 53.7251C74.1825 54.1224 74.2399 54.5302 74.4121 54.8942C74.584 55.2583 74.8621 55.5618 75.2102 55.7645C75.5321 55.9286 75.4875 55.763 75.2911 56.0661C75.0911 56.4153 75.0016 56.8173 75.0348 57.2188C75.068 57.62 75.2219 58.002 75.4762 58.3137C75.1278 58.1969 74.7481 58.216 74.4125 58.3668C74.0774 58.5176 73.8113 58.7895 73.668 59.1278C73.5242 59.4664 73.5133 59.8465 73.6379 60.1923C73.9387 60.7993 74.916 61.1489 75.3602 60.4817C75.8094 59.8067 75.0684 58.9059 74.5649 59.3196C74.5481 59.2825 74.5329 59.2477 74.5133 59.2067C76.7547 58.3181 76.4485 62.1723 73.8399 61.5649C72.4008 61.2298 72.202 59.5286 72.661 58.3672C73.2704 57.5157 73.9751 56.7367 74.7618 56.0461L74.7618 56.0462ZM73.2356 67.6412C72.6543 66.7705 72.1751 65.8357 71.8067 64.8557C71.6641 63.6155 72.2961 62.0233 73.7731 62.0721C76.445 62.1604 75.7454 65.9604 73.8133 64.5241C73.843 64.4894 73.8664 64.4601 73.8926 64.4284C74.266 64.9503 75.2258 64.2948 74.9614 63.5116C74.7052 62.7522 73.6704 62.837 73.2227 63.3452V63.3456C73.0129 63.6476 72.9246 64.0175 72.9758 64.3815C73.027 64.7455 73.2137 65.0772 73.4985 65.3096C73.7832 65.542 74.1454 65.6585 74.5126 65.6358C74.186 65.8713 73.9384 66.2002 73.8028 66.5795C73.6669 66.9585 73.6489 67.3698 73.7516 67.7592C73.8634 68.103 73.9489 67.9542 73.5958 68.0296C73.2071 68.135 72.8598 68.3561 72.5993 68.6635C72.3391 68.9706 72.1778 69.3495 72.1372 69.7498C71.9735 69.4209 71.6915 69.1655 71.3477 69.0354C71.004 68.9049 70.6235 68.9088 70.2829 69.0467C69.9419 69.1846 69.6657 69.4455 69.5087 69.7784C69.2923 70.4202 69.7361 71.3589 70.522 71.2011C71.3169 71.0417 71.4302 69.8804 70.7818 69.8171C70.7962 69.7788 70.8099 69.7436 70.8251 69.7006C73.0384 70.6573 70.0962 73.1658 68.6813 70.8916C67.9005 69.6369 68.9634 68.2936 70.1086 67.7967C71.1414 67.6257 72.1906 67.5733 73.2356 67.6412ZM63.9571 74.7603H63.9575C64.1622 73.7337 64.4844 72.7337 64.9169 71.7802C65.693 70.8021 67.2657 70.1236 68.2755 71.2025C70.1025 73.1541 66.9207 75.3463 66.5699 72.965C66.6153 72.9615 66.6528 72.9572 66.6934 72.9533C66.5887 73.5865 67.7305 73.8017 68.0977 73.0607C68.4536 72.3423 67.6617 71.6705 66.986 71.7138C66.6243 71.779 66.3004 71.9782 66.079 72.272C65.8575 72.5654 65.7551 72.9318 65.7922 73.2978C65.8293 73.6634 66.0028 74.0021 66.2786 74.2455C65.8813 74.181 65.4735 74.2384 65.1095 74.4107C64.7454 74.5826 64.4419 74.8611 64.2392 75.2087C64.0751 75.5306 64.2407 75.4861 63.9376 75.2896C63.5884 75.0896 63.1864 75.0001 62.7849 75.0334C62.3837 75.0666 62.0017 75.2205 61.69 75.4748C61.8068 75.1263 61.7877 74.7466 61.6369 74.4115C61.4861 74.0759 61.2142 73.8099 60.8759 73.6665C60.5377 73.5228 60.1572 73.5119 59.8114 73.6365C59.2044 73.9372 58.8548 74.9146 59.522 75.3588C60.197 75.808 61.0978 75.067 60.6841 74.5635C60.7212 74.5467 60.756 74.5314 60.797 74.5119C61.6856 76.7533 57.8314 76.4471 58.4388 73.8384C58.7739 72.3993 60.4751 72.2005 61.6365 72.6595C62.488 73.2689 63.267 73.9736 63.9576 74.7603L63.9571 74.7603ZM52.3625 73.2341C53.2332 72.6529 54.168 72.1736 55.148 71.8052C56.3882 71.6626 57.9804 72.2947 57.9316 73.7716C57.8433 76.4435 54.0433 75.7439 55.4796 73.8119C55.5143 73.8415 55.5436 73.865 55.5753 73.8912C55.0534 74.2646 55.7089 75.2243 56.4921 74.9599C57.2514 74.7037 57.1667 73.669 56.6585 73.2213H56.6581C56.3561 73.0115 55.9862 72.9232 55.6222 72.9744C55.2582 73.0255 54.9265 73.2123 54.6941 73.497C54.4617 73.7818 54.3452 74.1439 54.3679 74.5111C54.1324 74.1846 53.8034 73.9369 53.4241 73.801C53.0452 73.6654 52.6339 73.6474 52.2444 73.7502C51.9007 73.8619 52.0495 73.9475 51.9741 73.5943C51.8687 73.2057 51.6476 72.8584 51.3402 72.5979C51.0331 72.3377 50.6542 72.1764 50.2539 72.1357C50.5828 71.9717 50.8382 71.69 50.9683 71.3463C51.0988 71.0025 51.0949 70.6221 50.957 70.2815C50.8191 69.9405 50.5582 69.6643 50.2253 69.5073C49.5835 69.2909 48.6448 69.7346 48.8026 70.5206C48.962 71.3155 50.1233 71.4288 50.1866 70.7803C50.2249 70.7948 50.2601 70.8085 50.3031 70.8237C49.3464 73.037 46.8379 70.0948 49.1121 68.6799C50.3668 67.899 51.71 68.9619 52.207 70.1072C52.378 71.14 52.4304 72.1891 52.3625 73.2341ZM45.243 63.9556L45.2434 63.956C46.27 64.1607 47.27 64.483 48.2235 64.9154C49.2016 65.6916 49.8801 67.2642 48.8012 68.274C46.8496 70.101 44.6574 66.9193 47.0387 66.5685C47.0422 66.6138 47.0465 66.6513 47.0504 66.6919C46.4172 66.5872 46.202 67.729 46.943 68.0962C47.6614 68.4521 48.3332 67.6603 48.2899 66.9845C48.2247 66.6228 48.0254 66.299 47.7317 66.0775C47.4383 65.856 47.0719 65.7537 46.7059 65.7908C46.3403 65.8279 46.0016 66.0013 45.7582 66.2771C45.8227 65.8798 45.7653 65.472 45.593 65.108C45.4211 64.744 45.1426 64.4404 44.795 64.2377C44.4731 64.0736 44.5176 64.2393 44.7141 63.9362C44.9141 63.5869 45.0035 63.185 44.9703 62.7834C44.9371 62.3823 44.7832 62.0003 44.5289 61.6885C44.8774 61.8054 45.2571 61.7862 45.5922 61.6354C45.9278 61.4846 46.1938 61.2128 46.3372 60.8745C46.4809 60.5362 46.4918 60.1557 46.3672 59.81C46.0665 59.203 45.0891 58.8533 44.6449 59.5205C44.1957 60.1955 44.9367 61.0963 45.4402 60.6826C45.457 60.7197 45.4723 60.7545 45.4918 60.7955C43.2504 61.6842 43.5566 57.8299 46.1652 58.4373C47.6043 58.7725 47.8031 60.4736 47.3441 61.635C46.7348 62.4866 46.03 63.2655 45.2433 63.9561L45.243 63.9556ZM46.7696 52.361C47.3508 53.2317 47.8301 54.1665 48.1985 55.1465C48.3411 56.3867 47.709 57.9789 46.2321 57.9301C43.5602 57.8418 44.2598 54.0418 46.1918 55.4781C46.1622 55.5129 46.1387 55.5422 46.1125 55.5738C45.7391 55.0519 44.7793 55.7074 45.0437 56.4906C45.3 57.25 46.3347 57.1652 46.7824 56.657V56.6566C46.9922 56.3547 47.0805 55.9848 47.0293 55.6207C46.9782 55.2567 46.7914 54.925 46.5067 54.6926C46.2219 54.4602 45.8598 54.3438 45.4926 54.3665C45.8191 54.1309 46.0668 53.802 46.2027 53.4227C46.3383 53.0438 46.3562 52.6325 46.2535 52.243C46.1418 51.8993 46.0562 52.0481 46.4094 51.9727C46.798 51.8672 47.1453 51.6461 47.4058 51.3387C47.666 51.0317 47.8273 50.6528 47.868 50.252C48.032 50.5813 48.3137 50.8364 48.6574 50.9669C49.0012 51.0973 49.3816 51.093 49.7222 50.9555C50.0632 50.8176 50.3394 50.5567 50.4964 50.2239C50.7128 49.5821 50.2691 48.6434 49.4831 48.8012C48.6882 48.9606 48.5749 50.1219 49.2234 50.1852C49.2089 50.2235 49.1952 50.2586 49.18 50.3016C46.9667 49.345 49.9089 46.8364 51.3238 49.1106C52.1047 50.3653 51.0418 51.7086 49.8965 52.2055C48.8637 52.3766 47.8146 52.429 46.7696 52.361ZM56.0477 45.2415V45.2419C55.843 46.2685 55.5207 47.2685 55.0883 48.2216C54.3121 49.1997 52.7395 49.8782 51.7297 48.7993C49.9027 46.8477 53.0844 44.6555 53.4352 47.0368C53.3899 47.0404 53.3524 47.0447 53.3118 47.0486C53.4165 46.4154 52.2747 46.2001 51.9075 46.9411C51.5516 47.6595 52.3434 48.3313 53.0192 48.2881V48.2884C53.3809 48.2232 53.7047 48.024 53.9262 47.7302C54.1477 47.4365 54.25 47.0705 54.2129 46.7044C54.1758 46.3388 54.0024 46.0001 53.7266 45.7568C54.1238 45.8212 54.5317 45.7638 54.8957 45.5915C55.2597 45.4197 55.5633 45.1412 55.766 44.7935C55.93 44.4716 55.7644 44.5162 56.0675 44.7126C56.4168 44.9126 56.8187 45.0021 57.2202 44.9689C57.6214 44.9357 58.0034 44.7818 58.3151 44.5275C58.1983 44.8759 58.2175 45.2556 58.3683 45.5908C58.5191 45.9263 58.7909 46.1923 59.1292 46.3357C59.4675 46.4795 59.848 46.4904 60.1937 46.3658C60.8007 46.065 61.1504 45.0877 60.4832 44.6435C59.8082 44.1943 58.9074 44.9353 59.3211 45.4388C59.284 45.4556 59.2492 45.4708 59.2082 45.4904C58.3195 43.249 62.1738 43.5551 61.5664 46.1638C61.2312 47.6029 59.5301 47.8017 58.3687 47.3427C57.5171 46.7333 56.7382 46.0286 56.0476 45.2419L56.0477 45.2415ZM69.1577 35.8481C68.487 34.3141 67.1889 33.1426 65.5948 32.6317C65.6409 32.5059 65.6764 32.377 65.7022 32.2454C65.8776 32.2161 65.8499 32.0794 65.8655 31.9059C67.7491 32.4962 69.4378 33.586 70.7507 35.0602C70.2288 35.3411 69.6976 35.6036 69.1577 35.8481ZM49.3977 36.4481C47.8387 35.838 46.0926 35.9274 44.6039 36.6934C44.5476 36.5719 44.4816 36.4551 44.4066 36.3442C44.5101 36.1997 44.3937 36.1227 44.282 35.9887C46.0316 35.0739 47.9965 34.6508 49.9672 34.7649C49.7965 35.3329 49.6066 35.8938 49.3977 36.4485L49.3977 36.4481ZM35.8497 50.8451C34.3157 51.5158 33.1442 52.8139 32.6333 54.408C32.5075 54.3623 32.3786 54.3264 32.2469 54.3006C32.2177 54.1252 32.0809 54.1529 31.9075 54.1373C32.4977 52.2537 33.5876 50.565 35.0618 49.2521C35.3427 49.774 35.6051 50.3052 35.8497 50.8451ZM36.4501 70.6051C35.8395 72.1641 35.929 73.9102 36.695 75.3989C36.5735 75.4552 36.4571 75.5212 36.3458 75.5962C36.2012 75.4927 36.1243 75.6091 35.9903 75.7208C35.0755 73.9712 34.6524 72.0063 34.7665 70.0356C35.3345 70.2063 35.8954 70.3961 36.4501 70.6051ZM50.8471 84.1531C51.5178 85.6871 52.8159 86.8586 54.41 87.3695C54.3643 87.4953 54.3283 87.6242 54.3025 87.7559C54.1272 87.7851 54.1549 87.9219 54.1393 88.0953C52.2557 87.5051 50.567 86.4152 49.2541 84.941C49.7759 84.6601 50.3072 84.3977 50.8471 84.1531ZM70.6071 83.5527C72.1661 84.1633 73.9122 84.0738 75.4009 83.3078C75.4571 83.4293 75.5231 83.5457 75.5981 83.657C75.4946 83.8016 75.611 83.8785 75.7227 84.0125C73.9731 84.9273 72.0083 85.3504 70.0375 85.2363C70.2082 84.6683 70.3981 84.1074 70.6071 83.5527ZM84.1551 69.1557C85.6891 68.485 86.8606 67.1869 87.3715 65.5928C87.4973 65.6385 87.6262 65.6745 87.7578 65.7003C87.7871 65.8756 87.9238 65.8479 88.0972 65.8635C87.507 67.7471 86.4171 69.4358 84.9429 70.7487C84.6621 70.2269 84.3996 69.6956 84.1551 69.1557ZM83.5547 49.3957C84.1652 47.8367 84.0758 46.0906 83.3098 44.6019C83.4312 44.5457 83.5476 44.4797 83.659 44.4047C83.8035 44.5082 83.8805 44.3918 84.0144 44.28C84.9293 46.0296 85.3523 47.9945 85.2382 49.9652C84.6703 49.7945 84.1094 49.6047 83.5547 49.3957ZM76.2274 38.2217C78.1606 38.6213 79.9489 39.5385 81.4016 40.8756C81.2594 40.976 81.127 41.0202 81.1891 41.187C81.0883 41.2745 80.9942 41.3702 80.9082 41.4729C79.6687 40.3475 78.0055 39.8092 76.3414 39.9956C76.2836 39.4054 76.2453 38.8143 76.2274 38.2217ZM56.0754 33.1279C57.725 32.0435 59.6383 31.4275 61.6109 31.3455C61.5812 31.517 61.5187 31.642 61.6808 31.7158C61.6714 31.8494 61.6726 31.9834 61.6843 32.1166C60.012 32.1975 58.4554 32.9932 57.4105 34.301C56.9523 33.9248 56.5074 33.5338 56.0753 33.128L56.0754 33.1279ZM38.2234 43.7759C38.623 41.8427 39.5402 40.0544 40.8773 38.6017C40.9777 38.7439 41.0218 38.8763 41.1886 38.8142C41.2761 38.915 41.3718 39.0091 41.4745 39.0951C40.3491 40.3346 39.8108 41.9978 39.9972 43.6619C39.407 43.7197 38.816 43.758 38.2234 43.7759ZM33.1296 63.9279C32.0452 62.2783 31.4292 60.365 31.3472 58.3924C31.5187 58.4221 31.6437 58.4846 31.7175 58.3225C31.8511 58.3319 31.9851 58.3307 32.1183 58.319C32.1991 59.9913 32.9948 61.5479 34.3027 62.5928C33.9265 63.051 33.5355 63.4959 33.1297 63.928L33.1296 63.9279ZM43.7776 81.7799C41.8444 81.3803 40.0561 80.4631 38.6034 79.126C38.7456 79.0256 38.878 78.9815 38.8159 78.8147C38.9167 78.7272 39.0108 78.6315 39.0967 78.5288C40.3362 79.6542 41.9994 80.1925 43.6635 80.0061C43.7213 80.5963 43.7596 81.1873 43.7776 81.7799ZM63.9296 86.8737H63.93C62.2804 87.9581 60.3671 88.5741 58.3945 88.6561C58.4242 88.4846 58.4867 88.3596 58.3245 88.2858C58.3339 88.1522 58.3327 88.0182 58.321 87.885C59.9933 87.8042 61.5499 87.0085 62.5948 85.7006C63.053 86.0764 63.498 86.4678 63.93 86.8736L63.9296 86.8737ZM81.7816 76.2257C81.382 78.1589 80.4648 79.9472 79.1277 81.3999C79.0273 81.2577 78.9831 81.1253 78.8163 81.1874C78.7288 81.0866 78.6331 80.9925 78.5304 80.9066C79.6558 79.6671 80.1941 78.0039 80.0077 76.3398C80.5979 76.282 81.189 76.2437 81.7816 76.2257ZM86.8754 56.0737V56.0733C87.9598 57.7229 88.5758 59.6362 88.6578 61.6088C88.4863 61.5792 88.3613 61.5167 88.2875 61.6788C88.1539 61.6694 88.0199 61.6706 87.8867 61.6823C87.8058 60.01 87.0101 58.4534 85.7023 57.4085C86.0781 56.9503 86.4695 56.5054 86.8753 56.0733L86.8754 56.0737ZM77.7879 29.1967V29.1963C75.9594 31.4834 73.7082 33.3979 71.1574 34.8358C69.8535 33.2366 68.0765 32.092 66.0812 31.567C65.9648 31.2104 67.2234 30.3752 67.4031 30.2596C70.3765 28.3479 75.1816 28.7662 78.7011 27.6147C79.4569 31.2069 82.2292 35.167 82.0593 38.7217C82.0495 38.9237 81.9569 40.4424 81.5882 40.5201H81.5878C80.1355 39.0549 78.2558 38.0881 76.219 37.7584C76.1909 34.8307 76.7234 31.9244 77.7879 29.1967ZM94.3609 50.7943C91.4507 51.1186 88.505 50.8807 85.6847 50.0936C85.8937 48.0409 85.446 45.9748 84.4066 44.1928C84.5765 43.858 86.057 44.1576 86.2656 44.2029C89.7199 44.9537 92.8218 48.647 96.1246 50.3213C94.1187 53.3959 93.2789 58.1565 90.6457 60.5493C90.4961 60.6853 89.3566 61.6934 89.041 61.4876V61.4884C89.0504 59.4251 88.4046 57.4122 87.1976 55.7392C89.248 53.649 91.6792 51.9704 94.3609 50.7943ZM90.8074 77.7857C88.5203 75.9572 86.6058 73.706 85.1679 71.1552C86.7671 69.8517 87.9117 68.0743 88.4367 66.079C88.7933 65.9626 89.6285 67.2212 89.7441 67.4009C91.6558 70.3743 91.2375 75.1794 92.389 78.6989C88.7968 79.4548 84.8367 82.227 81.282 82.0571C81.08 82.0474 79.5613 81.9548 79.4836 81.586V81.5857C80.9488 80.1334 81.9156 78.2536 82.2453 76.2168C85.173 76.1887 88.0793 76.7212 90.807 77.7857L90.8074 77.7857ZM69.2094 94.3587C68.8852 91.4485 69.1231 88.5028 69.9102 85.6825C71.9629 85.8915 74.029 85.4443 75.811 84.4044C76.1457 84.5743 75.8461 86.0548 75.8008 86.2634C75.05 89.7177 71.3567 92.8196 69.6824 96.1224C66.6078 94.1165 61.8472 93.2767 59.4544 90.6435C59.3185 90.4939 58.3103 89.3544 58.5161 89.0388H58.5153C60.5786 89.0482 62.5915 88.4025 64.2645 87.1954C66.3547 89.2458 68.0333 91.6774 69.2094 94.3587ZM42.2184 90.8052C44.0469 88.5181 46.2981 86.6036 48.8489 85.1657C50.1524 86.7649 51.9298 87.9095 53.9251 88.4345C54.0415 88.7912 52.7829 89.6263 52.6032 89.7419C49.6298 91.6536 44.8247 91.2353 41.3052 92.3868C40.5493 88.7946 37.7771 84.8345 37.947 81.2798C37.9567 81.0779 38.0493 79.5591 38.4181 79.4814H38.4185C39.8708 80.9466 41.7505 81.9134 43.7873 82.2431C43.8154 85.1708 43.283 88.0771 42.2185 90.8048L42.2184 90.8052ZM25.6454 69.2072C28.5556 68.883 31.5013 69.1209 34.3216 69.908C34.1126 71.9607 34.5599 74.0268 35.5997 75.8088C35.4298 76.1436 33.9493 75.844 33.7407 75.7987C30.2864 75.0479 27.1845 71.3546 23.8817 69.6803C25.8876 66.6057 26.7274 61.8451 29.3606 59.4523C29.5102 59.3163 30.6497 58.3082 30.9653 58.514V58.5132C30.9559 60.5765 31.6016 62.5894 32.8087 64.2624C30.7583 66.3526 28.3267 68.0311 25.6454 69.2072ZM29.1989 42.2162C31.486 44.0447 33.4005 46.2959 34.8384 48.8467C33.2392 50.1502 32.0946 51.9276 31.5696 53.9229C31.2129 54.0393 30.3778 52.7807 30.2622 52.601C28.3505 49.6276 28.7688 44.8225 27.6173 41.303C31.2095 40.5472 35.1696 37.7749 38.7243 37.9448C38.9262 37.9546 40.445 38.0472 40.5227 38.4159V38.4163C39.0575 39.8686 38.0907 41.7483 37.761 43.7851C34.8333 43.8132 31.927 43.2808 29.1993 42.2163L29.1989 42.2162ZM50.7969 25.6432C51.1211 28.5534 50.8832 31.4991 50.0961 34.3194C48.0434 34.1104 45.9773 34.5577 44.1953 35.5975C43.8605 35.4276 44.1601 33.9471 44.2055 33.7385C44.9562 30.2842 48.6496 27.1823 50.3239 23.8795C53.3985 25.8854 58.1591 26.7252 60.5519 29.3584C60.6878 29.508 61.696 30.6475 61.4901 30.9631H61.4909C59.4276 30.9538 57.4147 31.5995 55.7417 32.8065C53.6515 30.7561 51.973 28.3245 50.7969 25.6432ZM64.9419 22.4877C67.7642 21.7905 70.7489 22.4967 72.9595 24.3846C74.3072 25.5557 74.1216 25.8319 74.7411 26.4608H74.7415C73.4169 27.0389 72.0626 27.5475 70.6845 27.9835C70.261 27.0788 69.4165 26.4425 68.4298 26.2851C68.6325 25.9152 68.7626 25.5101 68.813 25.0913C70.1868 25.2484 71.4407 25.9491 72.2946 27.037C72.445 27.1737 72.7254 27.003 72.6371 26.8054C71.8227 25.4671 70.37 24.6495 68.8036 24.6476C68.6028 23.2371 66.3676 22.2464 64.6427 24.7613C63.6199 21.8648 61.202 22.2875 60.6528 23.5746V23.5749C59.1391 23.171 57.5247 23.5847 56.3916 24.6667C56.2548 24.8347 56.4818 25.0722 56.6626 24.9792V24.9789C57.7688 24.1492 59.1614 23.7969 60.529 24.0007C60.4701 24.4183 60.4908 24.8433 60.5904 25.253C59.5966 25.1503 58.6166 25.5464 57.9728 26.31C56.7544 25.5323 55.5779 24.6909 54.4482 23.7889C55.4181 23.2198 58.6232 19.5104 64.9422 22.4877L64.9419 22.4877ZM90.0219 36.9677C92.5106 38.4704 94.1219 41.0802 94.35 43.9782C94.3863 44.8927 94.3164 45.8079 94.1418 46.7063C92.7961 46.1786 91.4793 45.5805 90.1965 44.9145C90.5367 43.9751 90.3894 42.9278 89.8031 42.1188C90.2082 42.0009 90.5867 41.8063 90.9183 41.5458C91.7785 42.6286 92.1695 44.0106 92.0042 45.3833C92.014 45.5864 92.3331 45.6641 92.4101 45.4618C92.7808 43.9395 92.3316 42.3345 91.2249 41.2255C92.0804 40.086 91.2003 37.8052 88.2022 38.3638C89.5272 35.5927 87.5186 34.1814 86.2202 34.7036H86.2206C85.4358 33.3477 84.0015 32.4985 82.4354 32.4622C82.342 32.4829 82.2736 32.5626 82.2666 32.6575C82.26 32.7528 82.3166 32.8411 82.4061 32.8747C83.7749 33.07 85.0088 33.8056 85.8315 34.9169C85.4948 35.1704 85.2088 35.4856 84.9897 35.8458C84.3592 35.0708 83.3866 34.6575 82.3909 34.7423C82.0791 33.331 81.8424 31.904 81.6815 30.4677C82.7698 30.7509 87.6588 30.3943 90.0217 36.9677L90.0219 36.9677ZM97.5172 64.9407C98.2144 67.763 97.5082 70.7477 95.6203 72.9583C94.4492 74.306 94.173 74.1204 93.5441 74.7399V74.7403C92.966 73.4157 92.4574 72.0614 92.0214 70.6833C92.9261 70.2599 93.5624 69.4153 93.7198 68.4286C94.0897 68.6314 94.4948 68.7614 94.9136 68.8118C94.7565 70.1856 94.0558 71.4395 92.9679 72.2934C92.8312 72.4438 93.0019 72.7243 93.1995 72.636C94.5378 71.8215 95.3554 70.3688 95.3573 68.8024C96.7678 68.6016 97.7585 66.3665 95.2437 64.6415C98.1402 63.6188 97.7174 61.2009 96.4304 60.6517H96.43C96.8339 59.138 96.4202 57.5236 95.3382 56.3904C95.1702 56.2537 94.9327 56.4806 95.0257 56.6615H95.0261C95.8557 57.7677 96.208 59.1603 96.0042 60.5279C95.5866 60.4689 95.1616 60.4896 94.7519 60.5892C94.8546 59.5955 94.4585 58.6154 93.6949 57.9716C94.4726 56.7532 95.314 55.5767 96.216 54.447C96.7851 55.4169 100.494 58.622 97.5172 64.941L97.5172 64.9407ZM83.0372 90.0207C81.5345 92.5094 78.9247 94.1207 76.0267 94.3488C75.1122 94.3852 74.197 94.3152 73.2986 94.1406C73.8263 92.7949 74.4244 91.4781 75.0904 90.1953C76.0298 90.5356 77.0771 90.3883 77.8861 89.802C78.004 90.207 78.1986 90.5856 78.4591 90.9172C77.3763 91.7773 75.9943 92.1684 74.6216 92.0031C74.4185 92.0128 74.3408 92.332 74.5431 92.4089C76.0654 92.7796 77.6704 92.3304 78.7794 91.2237C79.9189 92.0792 82.1997 91.1991 81.6411 88.201C84.4122 89.526 85.8235 87.5174 85.3013 86.219V86.2194C86.6572 85.4347 87.5064 84.0003 87.5427 82.4342C87.522 82.3409 87.4423 82.2725 87.3474 82.2655C87.2521 82.2588 87.1638 82.3155 87.1302 82.4049C86.9349 83.7737 86.1994 85.0076 85.088 85.8303C84.8345 85.4936 84.5193 85.2077 84.1591 84.9885C84.9341 84.358 85.3474 83.3854 85.2626 82.3897C86.6739 82.078 88.1009 81.8413 89.5372 81.6803C89.254 82.7686 89.6106 87.6576 83.0372 90.0205L83.0372 90.0207ZM55.0642 97.516C52.2419 98.2133 49.2572 97.507 47.0466 95.6191C45.6989 94.448 45.8845 94.1718 45.265 93.5429H45.2646C46.5892 92.9648 47.9435 92.4562 49.3216 92.0202C49.745 92.9249 50.5896 93.5612 51.5763 93.7186C51.3736 94.0885 51.2435 94.4936 51.1931 94.9124C49.8193 94.7554 48.5654 94.0546 47.7115 92.9667C47.5611 92.83 47.2806 93.0007 47.3689 93.1984C48.1834 94.5367 49.6361 95.3543 51.2025 95.3562C51.4033 96.7667 53.6384 97.7574 55.3634 95.2425C56.3861 98.139 58.804 97.7163 59.3532 96.4292V96.4288C60.8669 96.8327 62.4813 96.419 63.6145 95.337C63.7512 95.169 63.5243 94.9315 63.3434 95.0245V95.0249C62.2372 95.8546 60.8446 96.2069 59.477 96.003C59.536 95.5854 59.5153 95.1604 59.4157 94.7507C60.4094 94.8535 61.3895 94.4574 62.0333 93.6937C63.2517 94.4715 64.4282 95.3128 65.5579 96.2148C64.588 96.784 61.3829 100.493 55.0639 97.516L55.0642 97.516ZM29.9842 83.036C27.4955 81.5333 25.8842 78.9235 25.6561 76.0255C25.6197 75.1111 25.6897 74.1958 25.8643 73.2974C27.21 73.8252 28.5268 74.4232 29.8096 75.0892C29.4693 76.0287 29.6166 77.0759 30.2029 77.8849C29.7979 78.0029 29.4193 78.1974 29.0877 78.458C28.2276 77.3752 27.8365 75.9932 28.0018 74.6205C27.9921 74.4174 27.6729 74.3396 27.596 74.542C27.2253 76.0643 27.6745 77.6693 28.7812 78.7783C27.9257 79.9178 28.8058 82.1986 31.8039 81.64C30.4789 84.4111 32.4875 85.8224 33.7859 85.3002H33.7855C34.5703 86.6561 36.0046 87.5053 37.5707 87.5416C37.664 87.5209 37.7324 87.4412 37.7394 87.3463C37.7461 87.2509 37.6894 87.1627 37.6 87.1291C36.2312 86.9338 34.9973 86.1982 34.1746 85.0869C34.5113 84.8333 34.7972 84.5181 35.0164 84.158C35.6469 84.933 36.6195 85.3463 37.6152 85.2615C37.9269 86.6728 38.1636 88.0998 38.3246 89.5361C37.2363 89.2529 32.3473 89.6095 29.9844 83.0361L29.9842 83.036ZM22.4889 55.063C21.7916 52.2407 22.4979 49.256 24.3858 47.0454C25.5569 45.6977 25.8331 45.8833 26.462 45.2638V45.2634C27.0401 46.588 27.5487 47.9423 27.9847 49.3204C27.08 49.7439 26.4437 50.5884 26.2863 51.5751C25.9164 51.3724 25.5113 51.2423 25.0925 51.1919C25.2495 49.8181 25.9503 48.5642 27.0382 47.7103C27.1749 47.5599 27.0042 47.2795 26.8065 47.3678C25.4682 48.1822 24.6506 49.635 24.6487 51.2014C23.2382 51.4021 22.2475 53.6373 24.7624 55.3623C21.8659 56.385 22.2886 58.8029 23.5757 59.3521H23.5761C23.1722 60.8658 23.5859 62.4802 24.6679 63.6134C24.8359 63.7501 25.0734 63.5231 24.9804 63.3423H24.98C24.1503 62.2361 23.798 60.8435 24.0019 59.4759C24.4195 59.5349 24.8445 59.5141 25.2542 59.4145C25.1515 60.4083 25.5475 61.3883 26.3112 62.0321C25.5335 63.2505 24.6921 64.427 23.7901 65.5567C23.2209 64.5868 19.5116 61.3817 22.4889 55.0627L22.4889 55.063ZM36.9689 29.983C38.4716 27.4943 41.0814 25.883 43.9794 25.6549C44.8938 25.6186 45.8091 25.6885 46.7075 25.8631C46.1797 27.2088 45.5817 28.5256 44.9157 29.8084C43.9762 29.4682 42.929 29.6155 42.12 30.2018C42.002 29.7967 41.8075 29.4182 41.5469 29.0866C42.6297 28.2264 44.0117 27.8354 45.3844 28.0007C45.5875 27.9909 45.6653 27.6718 45.4629 27.5948C43.9406 27.2241 42.3356 27.6733 41.2266 28.78C40.0871 27.9246 37.8063 28.8046 38.3649 31.8027C35.5938 30.4777 34.1825 32.4863 34.7047 33.7847V33.7843C33.3488 34.5691 32.4996 36.0034 32.4633 37.5695C32.484 37.6629 32.5637 37.7313 32.6587 37.7383C32.754 37.7449 32.8422 37.6883 32.8758 37.5988C33.0712 36.23 33.8067 34.9961 34.918 34.1734C35.1716 34.5102 35.4868 34.7961 35.847 35.0152C35.072 35.6457 34.6587 36.6183 34.7435 37.614C33.3322 37.9258 31.9052 38.1625 30.4689 38.3234C30.7521 37.2351 30.3954 32.3461 36.9689 29.9832L36.9689 29.983ZM81.9789 21.7385C82.0508 21.3573 82.1941 20.9928 82.4008 20.6647C83.6805 18.6686 83.3 20.8112 82.1519 21.8385C82.4695 20.9549 82.589 21.017 81.9789 21.7385ZM102.599 48.4845C102.919 48.2658 103.278 48.1095 103.657 48.0236C105.973 47.5173 104.189 48.763 102.651 48.6775C103.5 48.2775 103.54 48.406 102.599 48.4845ZM98.2665 81.9775C98.6477 82.0494 99.0122 82.1928 99.3403 82.3994C101.336 83.6791 99.1938 83.2986 98.1665 82.1506C99.0501 82.4682 98.988 82.5877 98.2665 81.9775ZM71.5205 102.598C71.7392 102.918 71.8955 103.277 71.9814 103.655C72.4877 105.972 71.242 104.187 71.3275 102.649C71.7275 103.498 71.599 103.539 71.5205 102.598ZM38.0275 98.2651C37.9556 98.6464 37.8122 99.0108 37.6056 99.3389C36.3259 101.335 36.7064 99.1925 37.8544 98.1651C37.5368 99.0487 37.4173 98.9866 38.0275 98.2651ZM17.4075 71.5191C17.0872 71.7379 16.7282 71.8941 16.3497 71.9801C14.0333 72.4863 15.8176 71.2406 17.3556 71.3262C16.5067 71.7262 16.4661 71.5976 17.4075 71.5191ZM21.7399 38.0261C21.3586 37.9543 20.9942 37.8109 20.6661 37.6042C18.67 36.3245 20.8126 36.705 21.8399 37.8531C20.9563 37.5355 21.0184 37.416 21.7399 38.0261ZM48.4859 17.4061C48.2671 17.0858 48.1109 16.7268 48.0249 16.3483C47.5187 14.0319 48.7644 15.8163 48.6788 17.3542C48.2789 16.5054 48.4074 16.4647 48.4859 17.4061ZM79.2019 26.7467C77.0132 27.4174 74.7581 27.8483 72.4761 28.0319C86.5291 23.3237 78.5187 18.7678 81.4515 33.2139H81.4519C80.4698 31.1459 79.7156 28.9776 79.2019 26.7467ZM97.0929 50.0627C95.071 48.9889 93.1718 47.699 91.4284 46.2154C104.694 52.8228 102.251 43.9373 94.1108 56.2264C94.8788 54.0702 95.8789 52.0034 97.0929 50.0627ZM93.257 79.2007C92.5863 77.012 92.1554 74.7569 91.9718 72.4749C96.68 86.5279 101.236 78.5175 86.7898 81.4503V81.4507C88.8578 80.4687 91.0261 79.7144 93.257 79.2007ZM69.941 97.0917C71.0148 95.0698 72.3047 93.1706 73.7883 91.4272C67.1809 104.693 76.0664 102.25 63.7773 94.1096C65.9335 94.8776 68.0003 95.8776 69.941 97.0916V97.0917ZM40.803 93.2558C42.9917 92.5851 45.2468 92.1542 47.5288 91.9706C33.4758 96.6788 41.4862 101.235 38.5534 86.7886H38.553C39.535 88.8566 40.2893 91.0249 40.803 93.2558ZM22.912 69.9398C24.9339 71.0136 26.8331 72.3035 28.5765 73.7871C15.3105 67.1797 17.7535 76.0652 25.8941 63.7761C25.1261 65.9323 24.1261 67.9991 22.9121 69.9398H22.912ZM26.7479 40.8018C27.4186 42.9905 27.8495 45.2456 28.0331 47.5276C23.3249 33.4746 18.769 41.485 33.2151 38.5522V38.5518C31.1471 39.5339 28.9788 40.2881 26.7479 40.8018ZM50.0639 22.9108C48.9901 24.9327 47.7002 26.8319 46.2166 28.5753C52.824 15.3093 43.9385 17.7523 56.2276 25.8929C54.0714 25.125 52.0046 24.1249 50.0639 22.9109V22.9108ZM65.6309 17.2456C68.8528 16.0968 70.0008 18.2456 70.7879 18.5487C71.2973 18.7448 72.0012 18.3507 73.0098 18.6882C74.2848 19.1147 74.3828 19.8749 74.7969 20.3362C75.5816 21.21 77.1321 19.7643 80.3973 23.2608L80.3977 23.2612C78.7829 24.4796 77.0227 25.4921 75.1575 26.2757C74.5399 23.6527 69.0067 20.6167 65.0125 21.9441C61.4574 19.6015 55.3238 21.2097 54.0915 23.5023H54.0919C52.4931 22.2628 51.0548 20.8293 49.8107 19.2343C53.9857 16.6296 54.9205 18.5472 55.9771 17.8585C56.5263 17.5007 56.7896 16.8108 58.1298 16.7292C59.2388 16.6612 59.7165 17.2327 60.3122 17.1694C61.1805 17.0772 62.7946 15.287 65.631 17.2456L65.6309 17.2456ZM94.2149 33.7486C97.3051 35.2146 96.5977 37.5459 96.9399 38.317C97.1614 38.8159 97.9375 39.035 98.4126 39.9869V39.9865C98.7591 40.7529 98.7946 41.624 98.511 42.4158C98.4477 43.5885 100.567 43.6627 100.403 48.4439C98.3993 48.1639 96.4387 47.635 94.5661 46.8701C95.9841 44.5787 94.2185 38.5193 90.4552 36.6331C89.5978 32.4628 84.1236 29.2628 81.6314 30.0128C81.3771 28.0062 81.374 25.9753 81.622 23.9679C86.4161 25.0784 85.7212 27.0952 86.9552 27.3554C87.5966 27.491 88.2704 27.189 89.2763 28.0793C90.1084 28.8156 90.042 29.5574 90.5083 29.9336C91.1869 30.4824 93.5942 30.3578 94.2149 33.7484L94.2149 33.7486ZM102.757 65.6306C103.906 68.8525 101.757 70.0005 101.454 70.7876C101.258 71.297 101.652 72.0009 101.315 73.0095C100.888 74.2845 100.128 74.3825 99.6669 74.7966C98.7931 75.5814 100.239 77.1318 96.7423 80.397L96.7419 80.3974C95.5235 78.7826 94.5107 77.0224 93.7274 75.1572C96.3504 74.5396 99.3864 69.0064 98.059 65.0122C100.402 61.4571 98.7934 55.3235 96.5008 54.0912V54.0916C97.7403 52.4928 99.1738 51.0545 100.769 49.8104C103.374 53.9854 101.456 54.9202 102.145 55.9768C102.502 56.526 103.192 56.7893 103.274 58.1295C103.342 59.2385 102.77 59.7162 102.834 60.3119C102.926 61.1803 104.716 62.7943 102.758 65.6307L102.757 65.6306ZM86.2545 94.2146C84.7885 97.3048 82.4572 96.5974 81.6861 96.9396C81.1872 97.1611 80.9681 97.9373 80.0162 98.4123H80.0166C79.2502 98.7588 78.3791 98.7944 77.5873 98.5108C76.4146 98.4475 76.3404 100.566 71.5592 100.403C71.8392 98.3991 72.3682 96.4385 73.133 94.5659C75.4244 95.9839 81.4838 94.2182 83.37 90.455C87.5403 89.5975 90.7403 84.1234 89.9903 81.6312C91.9969 81.3769 94.0278 81.3737 96.0352 81.6218C94.9247 86.4159 92.9079 85.721 92.6477 86.955C92.5121 87.5964 92.8141 88.2702 91.9238 89.2761C91.1875 90.1081 90.4457 90.0417 90.0695 90.5081C89.5207 91.1866 89.6453 93.594 86.2547 94.2147L86.2545 94.2146ZM54.3725 102.757C51.1506 103.906 50.0026 101.757 49.2155 101.454C48.7061 101.258 48.0022 101.652 46.9936 101.315C45.7186 100.888 45.6206 100.128 45.2065 99.6667C44.4217 98.7929 42.8713 100.239 39.6061 96.7421L39.6057 96.7417C41.2205 95.5233 42.9807 94.5105 44.8459 93.7272C45.4635 96.3502 50.9967 99.3862 54.9909 98.0588C58.546 100.401 64.6796 98.7932 65.9119 96.5006H65.9115C67.5103 97.7401 68.9486 99.1736 70.1927 100.769C66.0177 103.373 65.0829 101.456 64.0263 102.144C63.4771 102.502 63.2138 103.192 61.8736 103.274C60.7646 103.342 60.2869 102.77 59.6912 102.833C58.8228 102.926 57.2089 104.716 54.3725 102.757ZM25.7885 86.2542C22.6983 84.7882 23.4057 82.4569 23.0635 81.6858C22.842 81.187 22.0658 80.9679 21.5908 80.0159V80.0163C21.2443 79.2499 21.2087 78.3788 21.4923 77.587C21.5556 76.4143 19.4368 76.3401 19.6005 71.5589C21.604 71.839 23.5646 72.3679 25.4372 73.1327C24.0192 75.4241 25.7849 81.4835 29.5481 83.3697C30.4056 87.54 35.8797 90.74 38.3719 89.99C38.6262 91.9966 38.6294 94.0275 38.3813 96.0349C33.5872 94.9244 34.2821 92.9076 33.0481 92.6474C32.4067 92.5119 31.7329 92.8138 30.727 91.9236C29.895 91.1873 29.9614 90.4455 29.495 90.0693C28.8165 89.5205 26.4091 89.6451 25.7884 86.2545L25.7885 86.2542ZM17.2459 54.3722C16.0971 51.1503 18.2459 50.0023 18.549 49.2152C18.7451 48.7058 18.3509 48.0019 18.6884 46.9933C19.115 45.7183 19.8751 45.6203 20.3364 45.2062C21.2103 44.4215 19.7645 42.871 23.261 39.6058L23.2614 39.6054C24.4798 41.2202 25.4923 42.9804 26.2759 44.8456C23.6529 45.4632 20.6169 50.9964 21.9443 54.9906C19.6017 58.5457 21.2099 64.6793 23.5025 65.9116V65.9113C22.263 67.51 20.8295 68.9483 19.2345 70.1925C16.6298 66.0175 18.5474 65.0826 17.8587 64.0261C17.5009 63.4768 16.811 63.2135 16.7294 61.8733C16.6614 60.7643 17.2329 60.2866 17.1696 59.6909C17.0775 58.8226 15.2873 57.2086 17.2459 54.3722ZM33.7489 25.7882C35.2149 22.698 37.5462 23.4054 38.3173 23.0632C38.8161 22.8417 39.0352 22.0656 39.9872 21.5905H39.9868C40.7532 21.244 41.6243 21.2085 42.4161 21.4921C43.5888 21.5554 43.663 19.4366 48.4442 19.6003C48.1641 21.6038 47.6352 23.5644 46.8704 25.437C44.579 24.019 38.5196 25.7846 36.6334 29.5479C32.4631 30.4053 29.2631 35.8795 30.0131 38.3717C28.0065 38.626 25.9756 38.6291 23.9682 38.3811C25.0787 33.587 27.0955 34.2819 27.3557 33.0479C27.4912 32.4065 27.1893 31.7327 28.0795 30.7268C28.8158 29.8947 29.5576 29.9611 29.9338 29.4948C30.4826 28.8162 30.358 26.4089 33.7486 25.7882L33.7489 25.7882Z",
    fill: "url(#paint2_linear_1835_25046)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5187 41.783C69.5976 41.7099 68.6722 41.8447 67.8101 42.1767C67.6808 42.2209 67.6101 42.3595 67.6496 42.4904C67.689 42.6209 67.825 42.697 67.957 42.6623C68.6828 42.5428 69.4093 42.5096 70.1343 42.4482C70.4437 43.1072 70.7784 43.7525 71.0374 44.4412H71.0378C71.0737 44.5729 71.2073 44.6526 71.3405 44.6213C71.4734 44.5901 71.5577 44.4596 71.5316 44.3256C71.3882 43.4127 71.0422 42.544 70.5187 41.783Z",
    fill: "url(#paint3_linear_1835_25046)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3185 54.556C79.7188 53.8533 78.9697 53.2939 78.1251 52.9193C78.0024 52.8592 77.8544 52.9072 77.7899 53.0275C77.7254 53.1479 77.7676 53.2975 77.8856 53.3666C78.4833 53.7951 79.0204 54.2854 79.5766 54.7549C79.3297 55.4397 79.1094 56.1326 78.8063 56.8029V56.8025C78.7383 56.9213 78.7766 57.072 78.8926 57.1443C79.009 57.2162 79.161 57.1834 79.2371 57.0701C79.7813 56.3236 80.1508 55.4642 80.3183 54.556L80.3185 54.556Z",
    fill: "url(#paint4_linear_1835_25046)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2162 70.518C78.2892 69.5969 78.1545 68.6715 77.8224 67.8094C77.7779 67.6801 77.6396 67.6094 77.5088 67.6489C77.3783 67.6883 77.3021 67.8242 77.3369 67.9563C77.4564 68.682 77.4896 69.4086 77.5509 70.1336C76.892 70.4429 76.2466 70.7777 75.5579 71.0367V71.0371C75.4263 71.073 75.3466 71.2066 75.3779 71.3398C75.4091 71.4726 75.5396 71.557 75.6736 71.5308C76.5861 71.3875 77.4552 71.0414 78.2162 70.518Z",
    fill: "url(#paint5_linear_1835_25046)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4447 80.318C66.1474 79.7184 66.7068 78.9692 67.0814 78.1246C67.1415 78.0019 67.0935 77.8539 66.9732 77.7894C66.8529 77.725 66.7033 77.7671 66.6341 77.8851C66.2056 78.4828 65.7154 79.0199 65.2458 79.5761C64.5611 79.3292 63.8681 79.1089 63.1978 78.8058H63.1982C63.0795 78.7378 62.9287 78.7761 62.8564 78.8921C62.7845 79.0085 62.8174 79.1605 62.9306 79.2367C63.6771 79.7808 64.5365 80.1503 65.4447 80.3179L65.4447 80.318Z",
    fill: "url(#paint6_linear_1835_25046)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4824 78.217C50.4035 78.2901 51.3289 78.1553 52.191 77.8233C52.3203 77.7788 52.391 77.6405 52.3516 77.5096C52.3121 77.3792 52.1762 77.303 52.0442 77.3377C51.3184 77.4573 50.5919 77.4905 49.8669 77.5518C49.5575 76.8928 49.2227 76.2475 48.9637 75.5588H48.9633C48.9274 75.4272 48.7938 75.3475 48.6606 75.3787C48.5278 75.41 48.4434 75.5404 48.4696 75.6744C48.613 76.5869 48.959 77.456 49.4824 78.217Z",
    fill: "url(#paint7_linear_1835_25046)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6816 65.4439C40.2813 66.1467 41.0304 66.706 41.875 67.0806C41.9977 67.1408 42.1457 67.0928 42.2102 66.9724C42.2747 66.8521 42.2325 66.7025 42.1145 66.6334C41.5168 66.2049 40.9797 65.7146 40.4235 65.2451C40.6704 64.5603 40.8907 63.8674 41.1938 63.1971V63.1975C41.2618 63.0787 41.2235 62.928 41.1075 62.8557C40.9911 62.7838 40.8391 62.8166 40.7629 62.9299C40.2188 63.6764 39.8493 64.5358 39.6817 65.444L39.6816 65.4439Z",
    fill: "url(#paint8_linear_1835_25046)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.783 49.482C41.7099 50.4031 41.8447 51.3285 42.1767 52.1906C42.2209 52.3199 42.3595 52.3906 42.4904 52.3512C42.6209 52.3117 42.697 52.1758 42.6623 52.0437C42.5428 51.318 42.5096 50.5914 42.4482 49.8664C43.1072 49.5571 43.7525 49.2223 44.4412 48.9633V48.9629C44.5729 48.927 44.6526 48.7934 44.6213 48.6602C44.5901 48.5274 44.4596 48.443 44.3256 48.4692C43.4127 48.6125 42.544 48.9586 41.783 49.482Z",
    fill: "url(#paint9_linear_1835_25046)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5552 39.682C53.8525 40.2816 53.2931 41.0308 52.9185 41.8754C52.8583 41.9981 52.9064 42.1461 53.0267 42.2106C53.147 42.275 53.2966 42.2328 53.3658 42.1149C53.7943 41.5172 54.2845 40.9801 54.7541 40.4239C55.4388 40.6707 56.1318 40.8911 56.8021 41.1942H56.8017C56.9204 41.2621 57.0712 41.2239 57.1435 41.1078C57.2153 40.9914 57.1825 40.8395 57.0692 40.7633C56.3228 40.2192 55.4633 39.8496 54.5551 39.6821L54.5552 39.682Z",
    fill: "url(#paint10_linear_1835_25046)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2756 54.3249C62.7467 53.5206 61.894 52.9862 60.9393 52.8604C59.985 52.7347 59.0229 53.0304 58.3038 53.6706C57.3609 53.4757 56.38 53.7007 55.6159 54.287C54.8523 54.873 54.3811 55.7624 54.3249 56.7233C53.5206 57.2522 52.9862 58.1049 52.8604 59.0596C52.7347 60.0139 53.0304 60.976 53.6706 61.6951C53.4757 62.6381 53.7007 63.6189 54.287 64.383C54.873 65.1467 55.7624 65.6178 56.7233 65.674C57.2522 66.4783 58.1049 67.0127 59.0596 67.1385C60.0139 67.2643 60.976 66.9686 61.6951 66.3284C62.6381 66.5233 63.6189 66.2983 64.383 65.7119C65.1467 65.126 65.6178 64.2365 65.674 63.2756C66.4783 62.7467 67.0127 61.894 67.1385 60.9393C67.2643 59.985 66.9686 59.0229 66.3284 58.3038C66.5233 57.3609 66.2983 56.38 65.7119 55.6159C65.126 54.8523 64.2365 54.3811 63.2756 54.3249ZM62.9491 54.8906C63.8159 54.9374 64.619 55.3609 65.1475 56.0496C65.6756 56.7382 65.8768 57.6234 65.6979 58.4726C66.2776 59.1187 66.5459 59.9859 66.4327 60.8464C66.3194 61.7069 65.8358 62.4753 65.1084 62.9491C65.0616 63.8159 64.6381 64.619 63.9494 65.1471C63.2608 65.6756 62.3756 65.8768 61.5264 65.6978C60.8804 66.2775 60.0132 66.5459 59.1527 66.4326C58.2921 66.3193 57.5237 65.8357 57.0499 65.1084C56.1831 65.0615 55.38 64.6381 54.8519 63.9494C54.3234 63.2607 54.1223 62.3756 54.3012 61.5264C53.7215 60.8803 53.4531 60.0131 53.5664 59.1526C53.6797 58.2921 54.1633 57.5237 54.8906 57.0499C54.9375 56.1831 55.3609 55.38 56.0496 54.8519C56.7383 54.3234 57.6234 54.1222 58.4726 54.3011C59.1187 53.7214 59.9859 53.4531 60.8464 53.5664C61.707 53.6796 62.4753 54.1632 62.9491 54.8906Z",
    fill: "url(#paint11_linear_1835_25046)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2761 57.895C60.3456 58.0321 60.5277 57.9923 60.989 58.2852C61.4613 58.5317 61.5269 58.7161 61.6835 58.7071C61.8249 59.1751 61.9429 59.6497 62.0363 60.1294C62.0386 60.1857 62.0628 60.2384 62.1038 60.2767C61.9667 60.3462 62.0066 60.5282 61.7136 60.9896C61.4671 61.4618 61.2827 61.5275 61.2917 61.6841L61.2913 61.6837C60.8238 61.8255 60.3491 61.9435 59.8694 62.0368C59.8132 62.0392 59.7604 62.0634 59.7222 62.1044C59.6526 61.9673 59.4706 62.0071 59.0093 61.7142C58.537 61.4677 58.4714 61.2833 58.3147 61.2923V61.2919C58.1733 60.8243 58.0554 60.3497 57.962 59.87C57.9597 59.8138 57.9354 59.761 57.8944 59.7227C58.0315 59.6532 57.9917 59.4712 58.2847 59.0098C58.5311 58.5376 58.7155 58.472 58.7065 58.3153H58.7069C59.1745 58.1739 59.6491 58.0559 60.1288 57.9626C60.1851 57.9602 60.2378 57.936 60.2761 57.895ZM60.3105 57.6337C60.13 57.1477 58.4593 57.595 58.546 58.1063C58.0749 57.8903 57.2097 59.3879 57.6327 59.6879C57.1468 59.8684 57.594 61.5391 58.1054 61.4524C57.8893 61.9235 59.387 62.7887 59.687 62.3657C59.8674 62.8517 61.5382 62.4044 61.4515 61.8931C61.9225 62.1091 62.7878 60.6115 62.3647 60.3115C62.8507 60.131 62.4034 58.4603 61.8921 58.547C62.1085 58.0759 60.6109 57.2107 60.3105 57.6337Z",
    fill: "url(#paint12_linear_1835_25046)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2619 35.214C64.3506 35.5534 65.3705 36.0827 66.274 36.7781C67.0025 37.2004 66.3428 35.2996 63.3299 34.7C60.2979 34.5015 59.1229 36.168 59.9479 35.9453C61.001 35.5078 62.1229 35.2601 63.262 35.214L63.2619 35.214Z",
    fill: "url(#paint13_linear_1835_25046)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8319 44.781C80.3616 45.7908 80.7085 46.8861 80.8561 48.0169C81.0729 48.8306 81.9502 47.02 80.2436 44.4653C78.2397 42.1809 76.2307 42.5286 76.9717 42.9548V42.9544C78.0252 43.3896 78.994 44.0083 79.8319 44.781Z",
    fill: "url(#paint14_linear_1835_25046)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7868 63.263C84.4474 64.3517 83.9181 65.3716 83.2227 66.2751C82.8005 67.0036 84.7012 66.3439 85.3008 63.331C85.4993 60.299 83.8328 59.124 84.0555 59.949C84.493 61.0021 84.7407 62.124 84.7868 63.2631L84.7868 63.263Z",
    fill: "url(#paint15_linear_1835_25046)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2179 79.833C74.2081 80.3627 73.1128 80.7096 71.982 80.8572C71.1684 81.074 72.9789 81.9513 75.5336 80.2447C77.818 78.2408 77.4703 76.2318 77.0441 76.9728H77.0445C76.6094 78.0263 75.9906 78.9951 75.2179 79.833Z",
    fill: "url(#paint16_linear_1835_25046)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7365 84.786C55.6478 84.4465 54.6279 83.9172 53.7244 83.2219C52.9959 82.7996 53.6557 84.7004 56.6685 85.3C59.7005 85.4984 60.8755 83.832 60.0505 84.0547C58.9974 84.4922 57.8755 84.7398 56.7364 84.7859L56.7365 84.786Z",
    fill: "url(#paint17_linear_1835_25046)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1671 75.219C39.6374 74.2092 39.2906 73.1139 39.1429 71.9831C38.9261 71.1695 38.0488 72.98 39.7554 75.5347C41.7593 77.8191 43.7683 77.4714 43.0273 77.0452V77.0456C41.9738 76.6105 41.005 75.9917 40.1671 75.219Z",
    fill: "url(#paint18_linear_1835_25046)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.214 56.737C35.5535 55.6483 36.0828 54.6284 36.7781 53.7249C37.2004 52.9964 35.2996 53.6562 34.7 56.669C34.5016 59.701 36.168 60.876 35.9453 60.051C35.5078 58.9979 35.2602 57.876 35.2141 56.7369L35.214 56.737Z",
    fill: "url(#paint19_linear_1835_25046)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7805 40.167C45.7903 39.6373 46.8856 39.2904 48.0164 39.1428C48.8301 38.926 47.0195 38.0487 44.4648 39.7553C42.1804 41.7592 42.5281 43.7682 42.9543 43.0272H42.9539C43.3891 41.9737 44.0078 41.0049 44.7805 40.167Z",
    fill: "url(#paint20_linear_1835_25046)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7144 30.927C71.1749 30.3785 68.3671 30.8821 69.0929 31.4614V31.461C69.803 31.9821 70.3089 32.7348 70.523 33.5891C70.5523 33.7028 70.6523 33.7836 70.7695 33.7887C70.8863 33.7942 70.9933 33.7223 71.0323 33.6117C71.5241 32.5105 72.5046 31.7039 73.68 31.4332C73.9109 31.3786 73.9866 30.9856 73.7144 30.927ZM70.841 32.8786C70.6269 32.3309 70.2882 31.8407 69.8519 31.4466C70.732 31.338 71.6191 31.2993 72.5054 31.3306C71.8246 31.6919 71.2508 32.2259 70.841 32.8786Z",
    fill: "url(#paint21_linear_1835_25046)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M49.14 29.744C46.9564 31.1518 45.3271 33.4932 46.2498 33.3897C47.1205 33.2557 48.0103 33.4303 48.7662 33.883C48.867 33.9428 48.9951 33.9291 49.0814 33.8502C49.1678 33.7709 49.1928 33.6447 49.1424 33.5389C48.7115 32.4123 48.8342 31.1491 49.474 30.1264C49.5986 29.9244 49.3744 29.5932 49.14 29.744ZM48.4884 33.1561C47.9498 32.9201 47.3634 32.8127 46.7763 32.8424C47.322 32.1436 47.922 31.4889 48.5704 30.8842C48.3447 31.6213 48.3166 32.4045 48.4884 33.1561Z",
    fill: "url(#paint22_linear_1835_25046)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9274 46.285C30.3789 48.8245 30.8824 51.6323 31.4617 50.9065H31.4613C31.9824 50.1963 32.7351 49.6905 33.5894 49.4764C33.7031 49.4471 33.784 49.3471 33.7891 49.2299C33.7945 49.1131 33.7227 49.0061 33.6121 48.967C32.5109 48.4752 31.7043 47.4947 31.4336 46.3193C31.3789 46.0884 30.9859 46.0127 30.9274 46.285ZM32.879 49.1584C32.3313 49.3724 31.8411 49.7111 31.447 50.1474C31.3384 49.2673 31.2997 48.3802 31.3309 47.4939C31.6923 48.1748 32.2263 48.7486 32.879 49.1584Z",
    fill: "url(#paint23_linear_1835_25046)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7432 70.86C31.151 73.0436 33.4924 74.6729 33.3889 73.7502C33.255 72.8795 33.4296 71.9897 33.8823 71.2338C33.9421 71.133 33.9284 71.0049 33.8495 70.9186C33.7702 70.8322 33.644 70.8072 33.5382 70.8576C32.4116 71.2885 31.1484 71.1658 30.1257 70.526C29.9237 70.4014 29.5925 70.6256 29.7432 70.86ZM33.1553 71.5115C32.9194 72.0502 32.812 72.6365 32.8417 73.2236C32.1428 72.6779 31.4882 72.0779 30.8835 71.4295C31.6206 71.6553 32.4037 71.6834 33.1553 71.5115Z",
    fill: "url(#paint24_linear_1835_25046)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2851 89.0729C48.8246 89.6214 51.6324 89.1179 50.9066 88.5386V88.5389C50.1964 88.0178 49.6906 87.2651 49.4765 86.4108C49.4472 86.2972 49.3472 86.2163 49.23 86.2112C49.1132 86.2058 49.0062 86.2776 48.9671 86.3882C48.4753 87.4894 47.4948 88.296 46.3194 88.5667C46.0886 88.6214 46.0128 89.0143 46.2851 89.0729ZM49.1585 87.1213C49.3725 87.669 49.7112 88.1592 50.1475 88.5533C49.2675 88.6619 48.3803 88.7006 47.494 88.6694C48.1749 88.308 48.7487 87.774 49.1585 87.1213Z",
    fill: "url(#paint25_linear_1835_25046)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8599 90.256C73.0435 88.8482 74.6728 86.5068 73.7501 86.6103C72.8794 86.7443 71.9896 86.5697 71.2337 86.117C71.1329 86.0576 71.0048 86.0709 70.9184 86.1498C70.8321 86.2291 70.8071 86.3553 70.8575 86.4611C71.2884 87.5877 71.1657 88.8513 70.5259 89.8736C70.4012 90.0756 70.6255 90.4068 70.8599 90.256ZM71.5114 86.8439C72.0501 87.0799 72.6364 87.1873 73.2235 87.1576C72.6778 87.8564 72.0778 88.5111 71.4294 89.1158C71.6552 88.3787 71.6833 87.5955 71.5114 86.8439Z",
    fill: "url(#paint26_linear_1835_25046)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0729 73.715C89.6214 71.1755 89.1179 68.3677 88.5386 69.0935H88.5389C88.0178 69.8036 87.2651 70.3095 86.4108 70.5236C86.2972 70.5529 86.2163 70.6529 86.2112 70.7701C86.2058 70.8869 86.2776 70.9939 86.3882 71.033C87.4894 71.5248 88.296 72.5053 88.5667 73.6807C88.6214 73.9115 89.0143 73.9873 89.0729 73.715ZM87.1213 70.8416C87.669 70.6275 88.1592 70.2889 88.5533 69.8525C88.6619 70.7326 88.7006 71.6197 88.6694 72.506C88.308 71.8252 87.774 71.2514 87.1213 70.8416Z",
    fill: "url(#paint27_linear_1835_25046)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M90.256 49.14C88.8482 46.9564 86.5068 45.3271 86.6103 46.2498C86.7443 47.1205 86.5697 48.0103 86.117 48.7662C86.0576 48.867 86.0709 48.9951 86.1498 49.0814C86.2291 49.1678 86.3553 49.1928 86.4611 49.1424C87.5877 48.7115 88.8513 48.8342 89.8736 49.474C90.0756 49.5986 90.4068 49.3744 90.256 49.14ZM86.8439 48.4884C87.0799 47.9498 87.1873 47.3634 87.1576 46.7763C87.8564 47.322 88.5111 47.922 89.1158 48.5704C88.3787 48.3447 87.5955 48.3166 86.8439 48.4884Z",
    fill: "url(#paint28_linear_1835_25046)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3213 33.586C80.0658 35.511 81.0338 38.1942 80.1693 37.8555H80.1697C79.3635 37.5008 78.4584 37.4391 77.6115 37.6809C77.4986 37.7121 77.3783 37.6661 77.3154 37.5676C77.2522 37.4688 77.2611 37.3403 77.3373 37.2512C78.0451 36.2746 78.2533 35.0223 77.9002 33.8688C77.8322 33.6419 78.1342 33.3798 78.3213 33.586ZM78.0678 37.0505C78.6495 36.9618 79.2432 37.0099 79.803 37.1907C79.4565 36.3747 79.0464 35.5868 78.5764 34.8348C78.6038 35.6051 78.4284 36.3693 78.0678 37.0505Z",
    fill: "url(#paint29_linear_1835_25046)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2775 28.368C56.8724 28.4957 59.4541 29.7082 58.6033 30.0801C57.7826 30.3992 57.099 30.9953 56.6709 31.7653C56.6135 31.8673 56.4959 31.9196 56.3815 31.8946C56.267 31.8692 56.1826 31.7723 56.1733 31.6555C55.983 30.4641 55.2452 29.4313 54.1799 28.8657C53.9709 28.7532 53.9994 28.3543 54.2775 28.368ZM56.5478 30.9969C56.8967 30.5231 57.3505 30.1371 57.874 29.8692C57.0521 29.5368 56.2049 29.27 55.3408 29.0704C55.9049 29.5958 56.3209 30.2601 56.5478 30.9969Z",
    fill: "url(#paint30_linear_1835_25046)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5865 41.679C35.5115 39.9345 38.1947 38.9665 37.856 39.831C37.5013 40.6373 37.4396 41.5419 37.6814 42.3888C37.7126 42.5017 37.6665 42.622 37.5681 42.6849C37.4693 42.7482 37.3408 42.7392 37.2517 42.663C36.2751 41.9552 35.0228 41.747 33.8693 42.1002C33.6423 42.1681 33.3802 41.8661 33.5865 41.679ZM37.051 41.9325C36.9623 41.3509 37.0104 40.7571 37.1912 40.1973C36.3752 40.5438 35.5873 40.954 34.8353 41.4239C35.6056 41.3966 36.3698 41.572 37.051 41.9325Z",
    fill: "url(#paint31_linear_1835_25046)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3675 65.723C28.4952 63.1281 29.7077 60.5464 30.0796 61.3972C30.3987 62.2179 30.9948 62.9015 31.7648 63.3296C31.8667 63.387 31.9191 63.5046 31.8941 63.619C31.8687 63.7335 31.7718 63.8179 31.655 63.8272C30.4636 64.0175 29.4308 64.7553 28.8652 65.8206C28.7527 66.0296 28.3538 66.0011 28.3675 65.723ZM30.9964 63.4527C30.5225 63.1038 30.1366 62.6499 29.8687 62.1265C29.5362 62.9484 29.2694 63.7956 29.0698 64.6597C29.5952 64.0956 30.2596 63.6796 30.9964 63.4527Z",
    fill: "url(#paint32_linear_1835_25046)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6791 86.414C39.9346 84.489 38.9666 81.8058 39.8311 82.1445H39.8308C40.637 82.4992 41.5421 82.5609 42.389 82.3191C42.5018 82.2879 42.6222 82.334 42.685 82.4324C42.7483 82.5312 42.7393 82.6598 42.6632 82.7488C41.9554 83.7254 41.7471 84.9777 42.1003 86.1312C42.1682 86.3582 41.8663 86.6203 41.6791 86.414ZM41.9327 82.9495C41.351 83.0382 40.7573 82.9902 40.1975 82.8093C40.5439 83.6253 40.9541 84.4132 41.4241 85.1652C41.3967 84.3949 41.5721 83.6307 41.9327 82.9495Z",
    fill: "url(#paint33_linear_1835_25046)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7236 91.632C63.1287 91.5043 60.547 90.2918 61.3978 89.9199C62.2185 89.6008 62.9021 89.0047 63.3302 88.2347C63.3876 88.1328 63.5052 88.0804 63.6196 88.1054C63.7341 88.1308 63.8185 88.2277 63.8278 88.3445C64.0181 89.5359 64.756 90.5687 65.8212 91.1343C66.0302 91.2468 66.0017 91.6457 65.7236 91.632ZM63.4533 89.0031C63.1045 89.477 62.6506 89.8629 62.1271 90.1308C62.949 90.4632 63.7962 90.73 64.6603 90.9297C64.0962 90.4043 63.6802 89.7399 63.4533 89.0031Z",
    fill: "url(#paint34_linear_1835_25046)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4139 78.321C84.4889 80.0655 81.8057 81.0335 82.1444 80.169V80.1694C82.4991 79.3631 82.5608 78.4581 82.319 77.6112C82.2878 77.4983 82.3339 77.378 82.4323 77.3151C82.5311 77.2518 82.6596 77.2608 82.7487 77.3369C83.7253 78.0448 84.9776 78.253 86.1311 77.8998C86.3581 77.8319 86.6202 78.1339 86.4139 78.321ZM82.9494 78.0674C83.0381 78.6491 82.99 79.2428 82.8092 79.8026C83.6252 79.4562 84.4131 79.046 85.1651 78.576C84.3948 78.6034 83.6306 78.428 82.9494 78.0674Z",
    fill: "url(#paint35_linear_1835_25046)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6324 54.277C91.5047 56.8719 90.2922 59.4536 89.9203 58.6028C89.6011 57.7821 89.0051 57.0985 88.2351 56.6704C88.1331 56.613 88.0808 56.4954 88.1058 56.381C88.1312 56.2665 88.2281 56.1822 88.3448 56.1728C89.5362 55.9826 90.569 55.2447 91.1346 54.1794C91.2471 53.9704 91.6461 53.9989 91.6324 54.277ZM89.0035 56.5473C89.4773 56.8962 89.8633 57.3501 90.1312 57.8735C90.4636 57.0517 90.7304 56.2044 90.93 55.3403C90.4046 55.9044 89.7403 56.3204 89.0035 56.5473Z",
    fill: "url(#paint36_linear_1835_25046)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1898 20.586C65.5355 20.5325 65.8253 20.2969 65.9487 19.9696C66.0722 19.6422 66.0101 19.2739 65.7862 19.0051C65.003 18.1551 63.9319 19.9848 65.1898 20.586Z",
    fill: "url(#paint37_linear_1835_25046)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5391 35.799C91.8216 36.0053 92.193 36.0435 92.5118 35.8994C92.8305 35.7557 93.047 35.451 93.0786 35.1029C93.1259 33.9478 91.0751 34.4842 91.5391 35.799Z",
    fill: "url(#paint38_linear_1835_25046)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4141 65.189C99.4676 65.5347 99.7032 65.8246 100.031 65.948C100.358 66.0715 100.726 66.0093 100.995 65.7855C101.845 65.0023 100.015 63.9312 99.4141 65.189Z",
    fill: "url(#paint39_linear_1835_25046)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2004 91.539C83.9941 91.8214 83.9559 92.1929 84.1 92.5117C84.2438 92.8304 84.5484 93.0468 84.8965 93.0785C86.0516 93.1257 85.5152 91.075 84.2004 91.539Z",
    fill: "url(#paint40_linear_1835_25046)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8117 99.414C54.466 99.4675 54.1762 99.703 54.0527 100.03C53.9293 100.358 53.9914 100.726 54.2152 100.995C54.9984 101.845 56.0695 100.015 54.8117 99.414Z",
    fill: "url(#paint41_linear_1835_25046)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4602 84.201C28.1778 83.9948 27.8063 83.9565 27.4875 84.1006C27.1688 84.2444 26.9524 84.5491 26.9207 84.8971C26.8735 86.0522 28.9242 85.5158 28.4602 84.201Z",
    fill: "url(#paint42_linear_1835_25046)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5854 54.811C20.5319 54.4653 20.2964 54.1754 19.969 54.052C19.6417 53.9286 19.2733 53.9907 19.0046 54.2145C18.1546 54.9977 19.9842 56.0688 20.5854 54.811Z",
    fill: "url(#paint43_linear_1835_25046)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M35.799 28.461C36.0053 28.1786 36.0435 27.8071 35.8994 27.4883C35.7557 27.1696 35.451 26.9532 35.1029 26.9215C33.9478 26.8743 34.4842 28.925 35.799 28.461Z",
    fill: "url(#paint44_linear_1835_25046)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5938 19.39C69.6156 19.4381 69.6266 19.4435 69.5938 19.39V19.39Z",
    fill: "#EDECF7"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9588 19.283C67.71 19.6791 67.7896 20.1978 68.1455 20.5014C68.5014 20.8053 69.026 20.8018 69.3779 20.4936C69.5842 20.3131 69.7013 20.0522 69.6998 19.7783C69.6978 19.5045 69.5771 19.2451 69.3689 19.0674C69.1607 18.8897 68.8853 18.8112 68.6146 18.8526C68.3439 18.894 68.1045 19.051 67.9588 19.283Z",
    fill: "url(#paint45_linear_1835_25046)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0684 24.501C38.1176 24.5193 38.1293 24.5154 38.0684 24.501V24.501Z",
    fill: "#EDECF7"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8361 25.58C36.9404 26.0358 37.3635 26.3468 37.8295 26.3097C38.2959 26.2726 38.6647 25.8991 38.6955 25.4323C38.7139 25.1593 38.6123 24.8917 38.4174 24.6991C38.2225 24.5069 37.9537 24.4085 37.6807 24.4304C37.4076 24.4519 37.1576 24.5913 36.9955 24.812C36.8334 25.0327 36.7752 25.3128 36.8361 25.58Z",
    fill: "url(#paint46_linear_1835_25046)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3906 50.4069C19.4387 50.3851 19.4441 50.3741 19.3906 50.4069V50.4069Z",
    fill: "#EDECF7"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2831 52.0409C19.6791 52.2898 20.1979 52.2101 20.5015 51.8542C20.8054 51.4984 20.8018 50.9738 20.4936 50.6218C20.3132 50.4156 20.0522 50.2984 19.7784 50.2999C19.5046 50.3019 19.2452 50.4226 19.0675 50.6308C18.8897 50.839 18.8112 51.1144 18.8526 51.3851C18.894 51.6558 19.051 51.8952 19.2831 52.0409Z",
    fill: "url(#paint47_linear_1835_25046)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 81.932C24.5145 81.8711 24.5184 81.8828 24.5 81.932V81.932Z",
    fill: "#EDECF7"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5803 83.163C26.0362 83.0587 26.3471 82.6357 26.31 82.1697C26.2729 81.7032 25.8995 81.3345 25.4327 81.3036C25.1596 81.2853 24.8921 81.3868 24.6995 81.5818C24.5073 81.7767 24.4089 82.0454 24.4307 82.3185C24.4522 82.5915 24.5917 82.8415 24.8124 83.0036C25.0331 83.1657 25.3131 83.2239 25.5803 83.163Z",
    fill: "url(#paint48_linear_1835_25046)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4074 100.61C50.3746 100.556 50.3856 100.562 50.4074 100.61V100.61Z",
    fill: "#EDECF7"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0418 100.72C52.2906 100.324 52.2109 99.8051 51.8551 99.5015C51.4992 99.1976 50.9746 99.2011 50.6227 99.5093C50.4164 99.6898 50.2992 99.9508 50.3008 100.225C50.3027 100.498 50.4235 100.758 50.6317 100.936C50.8399 101.113 51.1152 101.192 51.386 101.15C51.6567 101.109 51.8961 100.952 52.0418 100.72Z",
    fill: "url(#paint49_linear_1835_25046)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M81.932 95.499C81.8711 95.4846 81.8828 95.4807 81.932 95.499V95.499Z",
    fill: "#EDECF7"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1623 94.4199C83.058 93.9641 82.6349 93.6531 82.1689 93.6903C81.7025 93.7274 81.3338 94.1008 81.3029 94.5676C81.2845 94.8406 81.3861 95.1082 81.581 95.3008C81.7759 95.493 82.0447 95.5914 82.3177 95.5695C82.5908 95.5481 82.8408 95.4086 83.0029 95.1879C83.165 94.9672 83.2232 94.6871 83.1623 94.4199Z",
    fill: "url(#paint50_linear_1835_25046)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M100.61 69.593C100.557 69.6258 100.562 69.6149 100.61 69.593V69.593Z",
    fill: "#EDECF7"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M100.719 67.959C100.323 67.7102 99.8046 67.7899 99.501 68.1457C99.1971 68.5016 99.2007 69.0262 99.5089 69.3781C99.6893 69.5844 99.9503 69.7016 100.224 69.7C100.498 69.6981 100.757 69.5774 100.935 69.3692C101.113 69.161 101.191 68.8856 101.15 68.6149C101.108 68.3442 100.951 68.1047 100.719 67.959Z",
    fill: "url(#paint51_linear_1835_25046)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4987 38.068C95.4803 38.1172 95.4842 38.1289 95.4987 38.068V38.068Z",
    fill: "url(#paint52_linear_1835_25046)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4202 36.837C93.9643 36.9413 93.6534 37.3643 93.6905 37.8303C93.7276 38.2968 94.1011 38.6655 94.5678 38.6964C94.8409 38.7147 95.1085 38.6132 95.301 38.4182C95.4932 38.2233 95.5917 37.9546 95.5698 37.6815C95.5483 37.4085 95.4088 37.1585 95.1881 36.9964C94.9674 36.8343 94.6874 36.7761 94.4202 36.837Z",
    fill: "url(#paint53_linear_1835_25046)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3714 31.387C90.3085 31.3851 90.3191 31.3921 90.3714 31.387V31.387Z",
    fill: "url(#paint54_linear_1835_25046)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M90.57 31.405C90.0544 31.3398 90.768 31.3319 91.0704 31.6218H91.0708C91.4219 31.9214 91.5012 32.4331 91.2571 32.8249C91.0126 33.2167 90.5184 33.3706 90.095 33.187C89.6712 33.0034 89.4458 32.5374 89.5649 32.0913C89.6837 31.6452 90.1114 31.353 90.57 31.405Z",
    fill: "url(#paint55_linear_1835_25046)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2448 18.291C61.199 18.334 61.2112 18.3316 61.2448 18.291V18.291Z",
    fill: "url(#paint56_linear_1835_25046)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8492 18.61C62.9871 19.0569 62.7761 19.5373 62.3539 19.7385C61.9316 19.9396 61.4254 19.8006 61.1652 19.4119C61.0128 19.1842 60.9671 18.9017 61.0394 18.6377C61.1121 18.3736 61.296 18.1545 61.5433 18.0365C61.7906 17.9189 62.0765 17.9143 62.3273 18.0244C62.5781 18.1346 62.7687 18.3483 62.8492 18.61Z",
    fill: "url(#paint57_linear_1835_25046)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3871 29.628C31.3851 29.6909 31.3921 29.6803 31.3871 29.628V29.628Z",
    fill: "url(#paint58_linear_1835_25046)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4044 29.43C31.3391 29.9456 31.3313 29.2319 31.6212 28.9296V28.9292C31.9208 28.578 32.4325 28.4987 32.8243 28.7429C33.2161 28.9874 33.37 29.4815 33.1864 29.905C33.0028 30.3288 32.5368 30.5542 32.0907 30.435C31.6446 30.3163 31.3524 29.8886 31.4044 29.43Z",
    fill: "url(#paint59_linear_1835_25046)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M18.291 58.756C18.3316 58.7896 18.334 58.8017 18.291 58.756V58.756Z",
    fill: "url(#paint60_linear_1835_25046)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6103 57.15C19.0572 57.0122 19.5377 57.2231 19.7388 57.6454C19.94 58.0676 19.8009 58.5739 19.4123 58.8341C19.1845 58.9864 18.9021 59.0321 18.6381 58.9598C18.374 58.8872 18.1549 58.7032 18.0369 58.4559C17.9193 58.2086 17.9146 57.9227 18.0248 57.6719C18.1349 57.4212 18.3486 57.2305 18.6103 57.15Z",
    fill: "url(#paint61_linear_1835_25046)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M29.627 88.613C29.6793 88.6079 29.6898 88.6149 29.627 88.613V88.613Z",
    fill: "#EDECF7"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4298 88.595C29.9454 88.6602 29.2317 88.6681 28.9294 88.3782H28.929C28.5778 88.0786 28.4985 87.5669 28.7427 87.1751C28.9872 86.7833 29.4813 86.6294 29.9048 86.813C30.3286 86.9966 30.554 87.4626 30.4349 87.9087C30.3161 88.3548 29.8884 88.647 29.4298 88.595Z",
    fill: "url(#paint62_linear_1835_25046)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7559 101.71C58.7895 101.669 58.8016 101.667 58.7559 101.71V101.71Z",
    fill: "url(#paint63_linear_1835_25046)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1494 101.39C57.0115 100.943 57.2225 100.463 57.6447 100.261C58.067 100.06 58.5733 100.199 58.8334 100.588C58.9858 100.816 59.0315 101.098 58.9592 101.362C58.8866 101.626 58.7026 101.845 58.4553 101.963C58.208 102.081 57.9221 102.086 57.6713 101.976C57.4206 101.865 57.2299 101.652 57.1494 101.39Z",
    fill: "url(#paint64_linear_1835_25046)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6132 90.372C88.6081 90.3197 88.6152 90.3091 88.6132 90.372V90.372Z",
    fill: "url(#paint65_linear_1835_25046)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5954 90.57C88.6606 90.0544 88.6684 90.768 88.3786 91.0704V91.0708C88.079 91.4219 87.5672 91.5012 87.1755 91.2571C86.7837 91.0126 86.6298 90.5184 86.8134 90.095C86.997 89.6712 87.463 89.4458 87.9091 89.5649C88.3552 89.6837 88.6473 90.1114 88.5954 90.57Z",
    fill: "url(#paint66_linear_1835_25046)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M101.709 61.244C101.666 61.1983 101.668 61.2104 101.709 61.244V61.244Z",
    fill: "#EDECF7"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M101.39 62.85C100.943 62.9879 100.463 62.777 100.262 62.3547C100.06 61.9325 100.2 61.4262 100.588 61.166C100.816 61.0137 101.098 60.968 101.362 61.0402C101.626 61.1129 101.846 61.2969 101.964 61.5442C102.081 61.7914 102.086 62.0774 101.976 62.3281C101.866 62.5789 101.652 62.7696 101.39 62.85Z",
    fill: "url(#paint67_linear_1835_25046)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4421 20.187C72.0988 19.8241 71.5273 19.8054 71.1609 20.1448C70.7945 20.4843 70.7699 21.0554 71.1058 21.4253C71.4488 21.7882 72.0203 21.807 72.3867 21.4675C72.7531 21.1281 72.7777 20.557 72.4421 20.187Z",
    fill: "url(#paint68_linear_1835_25046)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6452 23.049C40.1468 23.0361 39.7308 23.4267 39.7116 23.9248C39.6925 24.4232 40.078 24.8439 40.5757 24.8693C41.0745 24.8822 41.4905 24.4916 41.5093 23.9935C41.5284 23.4951 41.1432 23.074 40.6452 23.049Z",
    fill: "url(#paint69_linear_1835_25046)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1873 47.557C19.8244 47.9004 19.8057 48.4718 20.1451 48.8382C20.4846 49.2046 21.0557 49.2292 21.4256 48.8933C21.7885 48.5503 21.8073 47.9788 21.4678 47.6124C21.1284 47.246 20.5573 47.2215 20.1873 47.557Z",
    fill: "url(#paint70_linear_1835_25046)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0491 79.354C23.0362 79.8524 23.4269 80.2685 23.9249 80.2876C24.4234 80.3067 24.8441 79.9212 24.8694 79.4235C24.8823 78.9247 24.4917 78.5087 23.9937 78.4899C23.4952 78.4708 23.0741 78.856 23.0491 79.354Z",
    fill: "url(#paint71_linear_1835_25046)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5568 99.813C47.9001 100.176 48.4716 100.195 48.838 99.8551C49.2044 99.5157 49.229 98.9446 48.893 98.5746C48.5501 98.2118 47.9786 98.193 47.6121 98.5325C47.2457 98.8719 47.2212 99.443 47.5568 99.813Z",
    fill: "url(#paint72_linear_1835_25046)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M79.353 96.951C79.8515 96.9639 80.2675 96.5733 80.2866 96.0752C80.3058 95.5768 79.9202 95.1561 79.4226 95.1307C78.9237 95.1178 78.5077 95.5084 78.489 96.0065C78.4698 96.5049 78.855 96.926 79.353 96.951Z",
    fill: "url(#paint73_linear_1835_25046)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8123 72.443C100.175 72.0996 100.194 71.5281 99.8545 71.1618C99.5151 70.7954 98.944 70.7707 98.574 71.1067C98.2111 71.4497 98.1924 72.0211 98.5318 72.3876C98.8713 72.754 99.4424 72.7785 99.8123 72.443Z",
    fill: "url(#paint74_linear_1835_25046)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9515 40.646C96.9644 40.1476 96.5738 39.7316 96.0757 39.7124C95.5773 39.6933 95.1566 40.0788 95.1312 40.5765C95.1183 41.0753 95.5089 41.4913 96.007 41.5101C96.5054 41.5292 96.9265 41.144 96.9515 40.646Z",
    fill: "url(#paint75_linear_1835_25046)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2577 29.317C88.7437 29.433 89.0452 29.9182 88.9343 30.4053C88.8237 30.892 88.3417 31.1991 87.8538 31.0936C87.3682 30.9776 87.0663 30.492 87.1772 30.0053C87.2878 29.5186 87.7698 29.2115 88.2577 29.317Z",
    fill: "url(#paint76_linear_1835_25046)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2847 18.323C58.71 18.0617 59.2667 18.1914 59.5324 18.614C59.7984 19.0363 59.6746 19.5941 59.255 19.8648C58.8296 20.1262 58.2734 19.9961 58.0073 19.5738C57.7413 19.1512 57.8651 18.5933 58.2847 18.323Z",
    fill: "url(#paint77_linear_1835_25046)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3176 31.743C29.4336 31.257 29.9188 30.9555 30.4059 31.0664C30.8926 31.177 31.1997 31.659 31.0942 32.1469C30.9782 32.6325 30.4926 32.9344 30.0059 32.8235C29.5192 32.7129 29.2121 32.2309 29.3176 31.743Z",
    fill: "url(#paint78_linear_1835_25046)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3224 61.715C18.0611 61.2896 18.1908 60.733 18.6134 60.4673C19.0357 60.2013 19.5935 60.3251 19.8642 60.7446C20.1256 61.17 19.9955 61.7263 19.5732 61.9923C19.1505 62.2583 18.5927 62.1345 18.3224 61.715Z",
    fill: "url(#paint79_linear_1835_25046)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7425 90.6829C31.2566 90.5669 30.955 90.0818 31.0659 89.5946C31.1765 89.1079 31.6585 88.8009 32.1464 88.9064C32.632 89.0224 32.9339 89.5079 32.823 89.9947C32.7124 90.4814 32.2304 90.7884 31.7425 90.6829Z",
    fill: "url(#paint80_linear_1835_25046)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M61.714 101.68C61.2886 101.941 60.732 101.811 60.4663 101.389C60.2003 100.966 60.3241 100.409 60.7436 100.138C61.169 99.8769 61.7253 100.007 61.9913 100.429C62.2574 100.851 62.1335 101.409 61.714 101.68Z",
    fill: "url(#paint81_linear_1835_25046)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6821 88.257C90.5661 88.7429 90.0809 89.0445 89.5938 88.9336C89.1071 88.823 88.8 88.341 88.9055 87.8531C89.0215 87.3675 89.5071 87.0656 89.9938 87.1765C90.4805 87.2871 90.7876 87.7691 90.6821 88.257Z",
    fill: "url(#paint82_linear_1835_25046)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M101.681 58.285C101.942 58.7104 101.812 59.2671 101.39 59.5327C100.967 59.7988 100.409 59.6749 100.139 59.2554C99.8776 58.83 100.007 58.2737 100.43 58.0077C100.852 57.7417 101.41 57.8655 101.681 58.285Z",
    fill: "url(#paint83_linear_1835_25046)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4195 22.25C75.3909 21.8648 75.1331 21.5343 74.7663 21.4132C74.3995 21.2922 73.996 21.4039 73.7436 21.6964C73.4913 21.989 73.4401 22.4046 73.6136 22.7495C73.7874 23.0945 74.1518 23.3011 74.537 23.2726C75.0632 23.2339 75.4581 22.7762 75.4195 22.25Z",
    fill: "url(#paint84_linear_1835_25046)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M44.208 22.404C43.9154 22.1516 43.4998 22.1005 43.1545 22.2739C42.8096 22.4477 42.6033 22.8122 42.6315 23.1973C42.66 23.5829 42.9178 23.913 43.2846 24.0341C43.6514 24.1551 44.0549 24.0434 44.3073 23.7509C44.6518 23.3516 44.6072 22.7486 44.208 22.404Z",
    fill: "url(#paint85_linear_1835_25046)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2501 44.581C21.865 44.6095 21.5345 44.8673 21.4134 45.2341C21.2923 45.6009 21.4041 46.0044 21.6966 46.2568C21.9892 46.5092 22.4048 46.5603 22.7497 46.3869C23.0946 46.2131 23.3013 45.8486 23.2728 45.4635C23.2341 44.9373 22.7764 44.5423 22.2501 44.581Z",
    fill: "url(#paint86_linear_1835_25046)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4038 75.791C22.1514 76.0836 22.1003 76.4992 22.2737 76.8445C22.4475 77.1894 22.812 77.3957 23.1971 77.3676C23.5827 77.339 23.9128 77.0812 24.0339 76.7144C24.155 76.3476 24.0432 75.9441 23.7507 75.6917C23.3514 75.3472 22.7484 75.3918 22.4038 75.791Z",
    fill: "url(#paint87_linear_1835_25046)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5807 97.75C44.6092 98.1351 44.867 98.4656 45.2338 98.5867C45.6006 98.7078 46.0041 98.5961 46.2565 98.3035C46.5089 98.0109 46.56 97.5953 46.3866 97.2504C46.2128 96.9055 45.8483 96.6988 45.4632 96.7273C44.937 96.766 44.542 97.2238 44.5807 97.75Z",
    fill: "url(#paint88_linear_1835_25046)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7901 97.596C76.0827 97.8483 76.4984 97.8995 76.8437 97.7261C77.1886 97.5522 77.3948 97.1878 77.3667 96.8026C77.3382 96.4171 77.0804 96.087 76.7136 95.9659C76.3468 95.8448 75.9433 95.9565 75.6909 96.2491C75.3464 96.6483 75.3909 97.2514 75.7901 97.596Z",
    fill: "url(#paint89_linear_1835_25046)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7499 75.419C98.135 75.3904 98.4655 75.1326 98.5866 74.7658C98.7077 74.399 98.596 73.9955 98.3034 73.7431C98.0108 73.4908 97.5952 73.4396 97.2503 73.6131C96.9054 73.7869 96.6987 74.1513 96.7272 74.5365C96.7659 75.0627 97.2236 75.4576 97.7499 75.419Z",
    fill: "url(#paint90_linear_1835_25046)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5962 44.209C97.8486 43.9164 97.8998 43.5008 97.7263 43.1555C97.5525 42.8106 97.188 42.6043 96.8029 42.6324C96.4173 42.661 96.0873 42.9188 95.9662 43.2856C95.8451 43.6524 95.9568 44.0559 96.2494 44.3083C96.6486 44.6528 97.2516 44.6082 97.5962 44.209Z",
    fill: "url(#paint91_linear_1835_25046)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9831 27.771C85.3312 27.603 85.746 27.6612 86.0343 27.9182C86.3226 28.1753 86.4277 28.5807 86.3007 28.9455C86.1734 29.3104 85.839 29.5623 85.4535 29.5846C85.0675 29.6069 84.7066 29.3944 84.5386 29.0463C84.3093 28.5713 84.5081 28.0007 84.9831 27.771Z",
    fill: "url(#paint92_linear_1835_25046)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8777 19.545C55.0047 19.1801 55.3391 18.9278 55.725 18.9055C56.1106 18.8837 56.4715 19.0962 56.6395 19.4438C56.8074 19.7915 56.7496 20.2063 56.4926 20.495C56.2355 20.7833 55.8301 20.8884 55.4653 20.761C54.9672 20.5876 54.7039 20.043 54.8777 19.545Z",
    fill: "url(#paint93_linear_1835_25046)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7708 35.017C27.6028 34.6689 27.661 34.2541 27.9181 33.9658C28.1751 33.6775 28.5806 33.5724 28.9454 33.6994C29.3102 33.8267 29.5622 34.1611 29.5844 34.5467C29.6067 34.9326 29.3942 35.2935 29.0461 35.4615C28.5711 35.6908 28.0005 35.492 27.7708 35.017Z",
    fill: "url(#paint94_linear_1835_25046)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5453 65.123C19.1804 64.996 18.9281 64.6616 18.9058 64.2757C18.884 63.8902 19.0965 63.5292 19.4441 63.3612C19.7918 63.1933 20.2066 63.2511 20.4953 63.5081C20.7836 63.7652 20.8887 64.1706 20.7613 64.5354C20.5879 65.0335 20.0433 65.2968 19.5453 65.123Z",
    fill: "url(#paint95_linear_1835_25046)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0172 92.229C34.6692 92.397 34.2543 92.3388 33.966 92.0817C33.6777 91.8247 33.5727 91.4192 33.6996 91.0544C33.827 90.69 34.1614 90.4376 34.5469 90.4154C34.9328 90.3935 35.2938 90.6056 35.4617 90.9536C35.691 91.4286 35.4922 91.9997 35.0172 92.229Z",
    fill: "url(#paint96_linear_1835_25046)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1225 100.45C64.9955 100.815 64.6612 101.067 64.2752 101.089C63.8897 101.111 63.5287 100.899 63.3608 100.551C63.1928 100.203 63.2506 99.7886 63.5076 99.4999C63.7647 99.2117 64.1701 99.1066 64.5349 99.2339C65.033 99.4074 65.2963 99.9519 65.1225 100.45Z",
    fill: "url(#paint97_linear_1835_25046)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2292 84.983C92.3972 85.331 92.339 85.7459 92.082 86.0342C91.8249 86.3225 91.4195 86.4276 91.0547 86.3006C90.6902 86.1733 90.4379 85.8389 90.4156 85.4533C90.3937 85.0674 90.6058 84.7065 90.9539 84.5385C91.4289 84.3092 91.9999 84.508 92.2292 84.983Z",
    fill: "url(#paint98_linear_1835_25046)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M100.449 54.877C100.814 55.004 101.066 55.3383 101.089 55.7243C101.11 56.1098 100.898 56.4708 100.55 56.6387C100.203 56.8067 99.7878 56.7489 99.4991 56.4918C99.2108 56.2348 99.1057 55.8293 99.2331 55.4645C99.4065 54.9665 99.9511 54.7032 100.449 54.877Z",
    fill: "url(#paint99_linear_1835_25046)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1358 23.958C74.9007 24.2338 74.855 24.6244 75.0206 24.947C75.1862 25.2697 75.53 25.4607 75.8917 25.4302C77.6987 24.8841 76.0725 22.7873 75.1358 23.958Z",
    fill: "url(#paint100_linear_1835_25046)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2165 23.812C45.245 24.1733 45.4892 24.4819 45.8341 24.5929C46.1794 24.7042 46.5575 24.5956 46.7915 24.3186C47.6837 22.6545 45.0509 22.3217 45.2165 23.812Z",
    fill: "url(#paint101_linear_1835_25046)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9574 44.865C24.2331 45.1002 24.6238 45.1459 24.9464 44.9802C25.2691 44.8146 25.4601 44.4709 25.4296 44.1092C24.8835 42.3022 22.7867 43.9283 23.9574 44.865Z",
    fill: "url(#paint102_linear_1835_25046)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8117 74.784C24.173 74.7555 24.4816 74.5113 24.5926 74.1664C24.7039 73.8211 24.5953 73.443 24.3183 73.209C22.6542 72.3168 22.3214 74.9496 23.8117 74.784Z",
    fill: "url(#paint103_linear_1835_25046)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8643 96.042C45.0995 95.7662 45.1452 95.3756 44.9796 95.0529C44.8139 94.7303 44.4702 94.5392 44.1085 94.5697C42.3015 95.1158 43.9276 97.2127 44.8643 96.042Z",
    fill: "url(#paint104_linear_1835_25046)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7835 96.188C74.755 95.8267 74.5108 95.5181 74.1659 95.4072C73.8206 95.2958 73.4425 95.4044 73.2085 95.6814C72.3163 97.3455 74.9491 97.6783 74.7835 96.188Z",
    fill: "url(#paint105_linear_1835_25046)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0418 75.135C95.7661 74.8998 95.3754 74.8541 95.0528 75.0197C94.7301 75.1854 94.5391 75.5291 94.5696 75.8908C95.1157 77.6978 97.2125 76.0717 96.0418 75.135Z",
    fill: "url(#paint106_linear_1835_25046)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1873 45.216C95.826 45.2445 95.5174 45.4887 95.4064 45.8336C95.2951 46.1789 95.4037 46.557 95.6806 46.791C97.3447 47.6832 97.6775 45.0504 96.1873 45.216Z",
    fill: "url(#paint107_linear_1835_25046)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6461 28.871C83.525 29.2132 83.2094 29.448 82.8469 29.4659C82.4847 29.4839 82.1476 29.2812 81.9933 28.953C81.5621 27.1147 84.1918 27.4749 83.6461 28.871Z",
    fill: "url(#paint108_linear_1835_25046)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7085 21.269C54.8643 21.5963 54.8073 21.9854 54.5639 22.2545C54.3202 22.5233 53.9385 22.6186 53.5975 22.4956C51.9885 21.4979 54.1058 19.8933 54.7085 21.269Z",
    fill: "url(#paint109_linear_1835_25046)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8714 36.354C29.2136 36.4751 29.4483 36.7907 29.4663 37.1532C29.4843 37.5153 29.2815 37.8524 28.9534 38.0067C27.1151 38.438 27.4753 35.8083 28.8714 36.354Z",
    fill: "url(#paint110_linear_1835_25046)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2698 65.291C21.5971 65.1352 21.9862 65.1922 22.2553 65.4356C22.5241 65.6793 22.6194 66.061 22.4963 66.402C21.4987 68.011 19.8941 65.8937 21.2698 65.291Z",
    fill: "url(#paint111_linear_1835_25046)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3542 91.129C36.4752 90.7868 36.7909 90.552 37.1534 90.5341C37.5155 90.5161 37.8526 90.7188 38.0069 91.047C38.4381 92.8853 35.8085 92.525 36.3542 91.129Z",
    fill: "url(#paint112_linear_1835_25046)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2901 98.731C65.1342 98.4037 65.1912 98.0146 65.4346 97.7455C65.6783 97.4767 66.06 97.3814 66.401 97.5045C68.01 98.5021 65.8928 100.107 65.2901 98.731Z",
    fill: "url(#paint113_linear_1835_25046)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1292 83.646C90.787 83.5249 90.5523 83.2092 90.5343 82.8467C90.5163 82.4846 90.7191 82.1475 91.0472 81.9932C92.8855 81.562 92.5253 84.1917 91.1292 83.646Z",
    fill: "url(#paint114_linear_1835_25046)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7308 54.709C98.4035 54.8648 98.0144 54.8078 97.7452 54.5644C97.4765 54.3207 97.3812 53.939 97.5042 53.598C98.5019 51.989 100.106 54.1063 98.7308 54.709Z",
    fill: "url(#paint115_linear_1835_25046)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7953 15.98C68.8715 15.0644 70.057 17.2355 71.4297 17.6167C73.075 18.0733 74.1141 17.1925 75.6395 18.8261C77.586 20.9105 78.8598 19.4952 80.7446 21.973L80.745 21.9734C80.8091 22.057 80.9204 22.0886 81.0188 22.0507C81.1173 22.0124 81.179 21.9144 81.17 21.8093C81.0352 19.7409 77.6247 20.0675 75.9473 18.2359C74.4614 16.6132 73.2207 17.4086 71.7375 17.0496C70.2176 16.6816 69.2348 14.466 65.8844 15.3051C62.9336 13.6656 61.1828 15.5094 59.7789 15.475C58.25 15.4379 57.2621 14.3477 55.4055 15.5313C53.2762 16.8887 50.1059 15.6547 49.436 17.6309V17.6313C49.4001 17.7305 49.4344 17.8414 49.5196 17.9035C49.6047 17.9657 49.7208 17.9641 49.8044 17.9C52.2356 16.018 53.1837 17.6582 55.5501 16.1816C57.4439 15 58.2646 16.118 59.9294 16.1031C61.3892 16.0894 63.0609 14.2995 65.7953 15.98Z",
    fill: "url(#paint116_linear_1835_25046)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2254 32.971C98.0481 34.4987 97.3512 36.8722 98.0524 38.1124C98.8926 39.5987 100.25 39.7104 100.174 41.9444C100.076 44.7944 101.978 44.6948 101.559 47.7796C101.545 47.8843 101.601 47.9854 101.698 48.028C101.794 48.071 101.907 48.0448 101.975 47.9644C103.342 46.4066 100.7 44.2261 100.809 41.7445C100.905 39.5461 99.4657 39.2316 98.6704 37.9289C97.8556 36.5941 98.7274 34.3324 95.7649 32.5566C94.8379 29.3109 92.2961 29.3765 91.3274 28.3597C90.2723 27.2523 90.345 25.7827 88.1954 25.307C85.7302 24.7613 84.361 21.6468 82.4895 22.5707H82.4899C82.3946 22.6156 82.3403 22.7183 82.3563 22.8222C82.3727 22.9265 82.4559 23.0074 82.5602 23.021C85.6102 23.4093 85.1207 25.2394 87.8383 25.8687C90.0129 26.3723 89.8028 27.7429 90.9906 28.9097C92.0324 29.9327 94.4801 29.8495 95.2254 32.971Z",
    fill: "url(#paint117_linear_1835_25046)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M104.02 65.7949C104.936 68.8711 102.765 70.0566 102.383 71.4293C101.927 73.0746 102.808 74.1137 101.174 75.6391C99.0897 77.5856 100.505 78.8594 98.0272 80.7442L98.0268 80.7446C97.9432 80.8087 97.9116 80.92 97.9495 81.0185C97.9877 81.1169 98.0858 81.1786 98.1909 81.1696C100.259 81.0349 99.9327 77.6243 101.764 75.9469C103.387 74.461 102.592 73.2203 102.951 71.7371C103.319 70.2172 105.534 69.2344 104.695 65.884C106.335 62.9332 104.491 61.1824 104.525 59.7785C104.562 58.2496 105.652 57.2617 104.469 55.4051C103.111 53.2758 104.345 50.1055 102.369 49.4356H102.369C102.27 49.3997 102.159 49.4341 102.097 49.5192C102.035 49.6044 102.036 49.7204 102.1 49.804C103.982 52.2352 102.342 53.1833 103.819 55.5497C105 57.4435 103.882 58.2642 103.897 59.929C103.911 61.3888 105.701 63.0605 104.02 65.7949Z",
    fill: "url(#paint118_linear_1835_25046)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0287 95.225C85.501 98.0477 83.1275 97.3508 81.8873 98.052C80.401 98.8923 80.2893 100.25 78.0553 100.174C75.2053 100.076 75.3049 101.978 72.2201 101.558C72.1154 101.544 72.0142 101.601 71.9717 101.697C71.9287 101.794 71.9549 101.907 72.0353 101.975C73.5931 103.342 75.7736 100.699 78.2552 100.808C80.4536 100.905 80.7681 99.4653 82.0708 98.67C83.4056 97.8552 85.6673 98.7271 87.4431 95.7645C90.6888 94.8376 90.6232 92.2957 91.64 91.327C92.7474 90.2719 94.217 90.3446 94.6927 88.195C95.2384 85.7298 98.3529 84.3606 97.429 82.4891V82.4895C97.3841 82.3942 97.2814 82.3399 97.1775 82.3559C97.0732 82.3723 96.9923 82.4555 96.9787 82.5598C96.5904 85.6098 94.7603 85.1203 94.131 87.8379C93.6274 90.0125 92.2568 89.8024 91.0899 90.9902C90.0669 92.032 90.1502 94.4797 87.0287 95.225Z",
    fill: "url(#paint119_linear_1835_25046)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2056 104.02C51.1294 104.936 49.9439 102.764 48.5712 102.383C46.9259 101.927 45.8868 102.807 44.3614 101.174C42.4149 99.0894 41.1411 100.505 39.2563 98.0269L39.2559 98.0266C39.1919 97.943 39.0806 97.9113 38.9821 97.9492C38.8837 97.9875 38.822 98.0855 38.8309 98.1906C38.9657 100.259 42.3762 99.9324 44.0536 101.764C45.5395 103.387 46.7802 102.591 48.2634 102.95C49.7833 103.318 50.7661 105.534 54.1165 104.695C57.0673 106.334 58.8181 104.491 60.222 104.525C61.7509 104.562 62.7388 105.652 64.5954 104.469C66.7247 103.111 69.895 104.345 70.5649 102.369V102.369C70.6009 102.269 70.5665 102.158 70.4813 102.096C70.3962 102.034 70.2802 102.036 70.1966 102.1C67.7654 103.982 66.8173 102.342 64.4509 103.818C62.5571 105 61.7364 103.882 60.0716 103.897C58.6118 103.91 56.94 105.7 54.2056 104.02Z",
    fill: "url(#paint120_linear_1835_25046)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7741 87.029C21.9514 85.5013 22.6483 83.1278 21.9471 81.8876C21.1069 80.4013 19.7491 80.2896 19.8256 78.0556C19.9233 75.2056 18.0213 75.3052 18.4408 72.2204C18.4549 72.1157 18.3982 72.0145 18.3018 71.9719C18.2053 71.9289 18.0924 71.9551 18.0244 72.0356C16.6572 73.5934 19.2998 75.7739 19.1908 78.2555C19.0943 80.4539 20.5338 80.7684 21.3291 82.0711C22.144 83.4059 21.2721 85.6676 24.2346 87.4434C25.1616 90.6891 27.7034 90.6235 28.6721 91.6403C29.7272 92.7477 29.6545 94.2173 31.8041 94.693C34.2693 95.2387 35.6385 98.3532 37.51 97.4293H37.5096C37.6049 97.3844 37.6592 97.2816 37.6432 97.1777C37.6268 97.0734 37.5436 96.9926 37.4393 96.9789C34.3893 96.5906 34.8788 94.7605 32.1612 94.1312C29.9866 93.6277 30.1967 92.257 29.0089 91.0902C27.9671 90.0672 25.5194 90.1504 24.7741 87.029Z",
    fill: "url(#paint121_linear_1835_25046)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9801 54.205C15.0645 51.1288 17.2356 49.9433 17.6168 48.5706C18.0735 46.9253 17.1926 45.8862 18.8262 44.3608C20.9106 42.4143 19.4953 41.1405 21.9731 39.2557L21.9735 39.2553C22.0571 39.1912 22.0887 39.0799 22.0508 38.9814C22.0126 38.883 21.9145 38.8213 21.8094 38.8303C19.741 38.965 20.0676 42.3756 18.236 44.053C16.6133 45.5389 17.4087 46.7796 17.0497 48.2628C16.6818 49.7827 14.4661 50.7655 15.3052 54.1159C13.6657 57.0667 15.5095 58.8175 15.4752 60.2214C15.438 61.7503 14.3479 62.7382 15.5314 64.5948C16.8888 66.7241 15.6548 69.8944 17.631 70.5643H17.6314C17.7306 70.6002 17.8416 70.5658 17.9037 70.4807C17.9658 70.3955 17.9642 70.2795 17.9001 70.1959C16.0181 67.7647 17.6583 66.8166 16.1817 64.4502C15.0001 62.5564 16.1181 61.7357 16.1032 60.0709C16.0896 58.6111 14.2997 56.9394 15.9801 54.205Z",
    fill: "url(#paint122_linear_1835_25046)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9709 24.775C34.4986 21.9523 36.8721 22.6492 38.1123 21.948C39.5986 21.1077 39.7103 19.75 41.9443 19.8265C44.7943 19.9241 44.6947 18.0222 47.7795 18.4417C47.8842 18.4557 47.9853 18.3991 48.0279 18.3026C48.0709 18.2061 48.0447 18.0932 47.9642 18.0253C46.4064 16.6581 44.2259 19.3007 41.7443 19.1917C39.5459 19.0952 39.2314 20.5347 37.9287 21.33C36.5939 22.1448 34.3322 21.2729 32.5564 24.2355C29.3107 25.1624 29.3763 27.7043 28.3595 28.673C27.2521 29.7281 25.7825 29.6554 25.3068 31.805C24.7611 34.2702 21.6466 35.6394 22.5705 37.5109V37.5105C22.6155 37.6058 22.7182 37.6601 22.8221 37.6441C22.9264 37.6277 23.0073 37.5445 23.0209 37.4402C23.4092 34.3902 25.2393 34.8797 25.8686 32.1621C26.3721 29.9875 27.7428 30.1976 28.9096 29.0098C29.9326 27.968 29.8494 25.5203 32.9709 24.775Z",
    fill: "url(#paint123_linear_1835_25046)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4947 14.094C66.4721 14.5014 67.1057 14.4671 67.1287 14.0628C67.1514 13.6592 67.4064 13.3432 67.442 12.9546C67.4877 12.4585 66.5756 12.6346 66.4947 14.094Z",
    fill: "url(#paint124_linear_1835_25046)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1313 22.947C32.4036 23.2513 32.8274 22.7786 32.5575 22.4767C32.2883 22.1751 32.245 21.7716 31.9954 21.4716C31.677 21.0884 31.1567 21.8579 32.1313 22.947Z",
    fill: "url(#paint125_linear_1835_25046)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0942 53.506C14.5017 53.5287 14.4673 52.8951 14.063 52.8721C13.6595 52.8494 13.3435 52.5943 12.9548 52.5588C12.4587 52.5131 12.6348 53.4252 14.0942 53.506Z",
    fill: "url(#paint126_linear_1835_25046)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9463 87.869C23.2506 87.5967 22.7779 87.1729 22.476 87.4428C22.1744 87.7119 21.7709 87.7553 21.4709 88.0049C21.0877 88.3233 21.8572 88.8436 22.9463 87.869Z",
    fill: "url(#paint127_linear_1835_25046)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5056 105.91C53.5282 105.503 52.8946 105.537 52.8716 105.941C52.8489 106.345 52.5939 106.661 52.5583 107.049C52.5126 107.546 53.4247 107.369 53.5056 105.91Z",
    fill: "url(#paint128_linear_1835_25046)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8681 97.053C87.5958 96.7487 87.172 97.2214 87.4419 97.5233C87.7111 97.8249 87.7544 98.2284 88.004 98.5284C88.3224 98.9116 88.8427 98.1421 87.8681 97.053Z",
    fill: "url(#paint129_linear_1835_25046)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M105.91 66.494C105.503 66.4713 105.537 67.1049 105.942 67.128C106.345 67.1506 106.661 67.4057 107.05 67.4413C107.546 67.487 107.37 66.5749 105.91 66.494Z",
    fill: "url(#paint130_linear_1835_25046)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0533 32.131C96.749 32.4033 97.2216 32.8271 97.5236 32.5572C97.8252 32.288 98.2287 32.2447 98.5287 31.995C98.9119 31.6767 98.1424 31.1564 97.0533 32.131Z",
    fill: "url(#paint131_linear_1835_25046)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M96.508 31.423C96.1662 31.6464 95.8794 31.0804 96.2181 30.8586C96.556 30.6371 96.7025 30.2586 97.0212 30.0332C97.4279 29.7449 97.7314 30.623 96.508 31.423Z",
    fill: "url(#paint132_linear_1835_25046)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M65.609 13.977C65.5254 14.3766 64.9223 14.1793 65.0047 13.7828C65.0871 13.3871 64.9227 13.016 64.9887 12.6312C65.0731 12.1398 65.9086 12.5461 65.609 13.977Z",
    fill: "url(#paint133_linear_1835_25046)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4225 23.491C31.6459 23.8328 31.0799 24.1195 30.858 23.7808C30.6365 23.4429 30.258 23.2964 30.0326 22.9777C29.7443 22.5711 30.6225 22.2675 31.4225 23.491Z",
    fill: "url(#paint134_linear_1835_25046)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9766 54.391C14.3762 54.4746 14.179 55.0777 13.7825 54.9953C13.3868 54.9129 13.0157 55.0773 12.6309 55.0113C12.1395 54.9269 12.5458 54.0914 13.9766 54.391Z",
    fill: "url(#paint135_linear_1835_25046)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4916 88.577C23.8334 88.3536 24.1201 88.9196 23.7814 89.1415C23.4435 89.3629 23.2971 89.7415 22.9783 89.9669C22.5717 90.2551 22.2682 89.377 23.4916 88.577Z",
    fill: "url(#paint136_linear_1835_25046)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3907 106.02C54.4743 105.62 55.0775 105.818 54.995 106.214C54.9126 106.61 55.0771 106.981 55.0111 107.366C54.9267 107.857 54.0911 107.451 54.3907 106.02Z",
    fill: "url(#paint137_linear_1835_25046)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5767 96.5089C88.3532 96.1671 88.9192 95.8804 89.1411 96.2191C89.3626 96.557 89.7411 96.7035 89.9665 97.0222C90.2548 97.4289 89.3766 97.7324 88.5767 96.5089Z",
    fill: "url(#paint138_linear_1835_25046)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M106.02 65.609C105.62 65.5254 105.817 64.9223 106.214 65.0047C106.609 65.0871 106.981 64.9227 107.365 64.9887C107.857 65.0731 107.45 65.9086 106.02 65.609Z",
    fill: "url(#paint139_linear_1835_25046)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5764 13.223C69.4843 13.0086 69.1772 12.9359 69.0198 13.7168C68.9776 13.925 68.9413 14.1343 68.9081 14.3441C68.8573 14.6675 69.3327 14.8277 69.4116 14.491C69.6053 13.6621 69.6725 13.4469 69.5764 13.223Z",
    fill: "url(#paint140_linear_1835_25046)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6958 20.152C33.479 20.0656 33.2106 20.2309 33.6512 20.8949C33.7688 21.0719 33.8911 21.2457 34.0157 21.4176C34.2083 21.6824 34.6579 21.459 34.4754 21.1653C34.027 20.4422 33.9223 20.2422 33.6958 20.152Z",
    fill: "url(#paint141_linear_1835_25046)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2221 50.423C13.0077 50.5152 12.935 50.8223 13.7159 50.9797C13.9241 51.0219 14.1335 51.0582 14.3432 51.0914C14.6667 51.1422 14.8268 50.6668 14.4901 50.5879C13.6612 50.3941 13.446 50.3269 13.2221 50.423Z",
    fill: "url(#paint142_linear_1835_25046)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M20.152 86.305C20.0656 86.5218 20.2309 86.7902 20.8949 86.3496C21.0719 86.232 21.2457 86.1097 21.4176 85.9851C21.6824 85.7925 21.459 85.3429 21.1653 85.5253C20.4422 85.9738 20.2422 86.0785 20.152 86.305Z",
    fill: "url(#paint143_linear_1835_25046)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4223 106.78C50.5145 106.994 50.8215 107.067 50.9789 106.286C51.0211 106.078 51.0575 105.869 51.0907 105.659C51.1415 105.335 50.6661 105.175 50.5871 105.512C50.3934 106.341 50.3262 106.556 50.4223 106.78Z",
    fill: "url(#paint144_linear_1835_25046)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3048 99.848C86.5216 99.9343 86.7899 99.7691 86.3493 99.105C86.2317 98.9281 86.1095 98.7542 85.9849 98.5824C85.7923 98.3175 85.3427 98.5409 85.5251 98.8347C85.9735 99.5577 86.0782 99.7577 86.3048 99.848Z",
    fill: "url(#paint145_linear_1835_25046)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M106.779 69.5771C106.994 69.4849 107.066 69.1778 106.285 69.0204C106.077 68.9782 105.868 68.9419 105.658 68.9087C105.335 68.8579 105.175 69.3333 105.511 69.4122C106.34 69.606 106.555 69.6732 106.779 69.5771Z",
    fill: "url(#paint146_linear_1835_25046)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8485 33.695C99.9348 33.4782 99.7696 33.2099 99.1055 33.6505C98.9285 33.7681 98.7547 33.8903 98.5828 34.0149C98.318 34.2075 98.5414 34.6571 98.8352 34.4747C99.5582 34.0263 99.7582 33.9216 99.8485 33.695Z",
    fill: "url(#paint147_linear_1835_25046)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M95.72 28.318C95.9521 28.2906 96.1685 28.5199 95.5708 29.0473C95.4118 29.1875 95.2485 29.3242 95.0833 29.4574C94.8286 29.6633 94.4524 29.3313 94.7044 29.0945C95.3255 28.5125 95.4783 28.3465 95.72 28.318Z",
    fill: "url(#paint148_linear_1835_25046)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M62.856 12.339C63.0006 12.1558 63.3158 12.1648 63.2662 12.9601C63.2529 13.1718 63.2342 13.3839 63.2119 13.5949C63.1775 13.9206 62.6764 13.9519 62.6877 13.6062C62.7143 12.7558 62.7049 12.5304 62.856 12.339Z",
    fill: "url(#paint149_linear_1835_25046)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3186 24.279C28.2912 24.047 28.5205 23.8306 29.0479 24.4282C29.1881 24.5872 29.3248 24.7505 29.458 24.9157C29.6639 25.1704 29.3319 25.5466 29.0952 25.2947C28.5131 24.6736 28.3471 24.5208 28.3186 24.279Z",
    fill: "url(#paint150_linear_1835_25046)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3396 57.1429C12.1564 56.9984 12.1653 56.6832 12.9606 56.7328C13.1724 56.7461 13.3845 56.7648 13.5954 56.7871C13.9212 56.8215 13.9524 57.3226 13.6067 57.3113C12.7564 57.2847 12.531 57.2941 12.3396 57.1429Z",
    fill: "url(#paint151_linear_1835_25046)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M24.278 91.682C24.046 91.7093 23.8296 91.48 24.4273 90.9527C24.5862 90.8125 24.7495 90.6757 24.9148 90.5425C25.1695 90.3367 25.5456 90.6687 25.2937 90.9054C24.6726 91.4875 24.5198 91.6535 24.278 91.682Z",
    fill: "url(#paint152_linear_1835_25046)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M57.142 107.66C56.9974 107.843 56.6822 107.834 56.7318 107.039C56.7451 106.827 56.7638 106.615 56.7861 106.404C56.8205 106.078 57.3216 106.047 57.3103 106.393C57.2838 107.243 57.2931 107.469 57.142 107.66Z",
    fill: "url(#paint153_linear_1835_25046)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6825 95.721C91.7098 95.953 91.4805 96.1694 90.9532 95.5718C90.813 95.4128 90.6762 95.2495 90.543 95.0843C90.3372 94.8296 90.6692 94.4534 90.9059 94.7054C91.4879 95.3265 91.654 95.4792 91.6825 95.721Z",
    fill: "url(#paint154_linear_1835_25046)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M107.66 62.857C107.843 63.0016 107.834 63.3168 107.039 63.2672C106.827 63.2539 106.615 63.2352 106.404 63.2129C106.078 63.1785 106.047 62.6773 106.393 62.6887C107.243 62.7152 107.469 62.7059 107.66 62.857Z",
    fill: "url(#paint155_linear_1835_25046)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0883 14.036C71.0106 14.4067 70.825 14.7462 70.5547 15.0118C70.2071 15.345 70.8598 15.9247 71.3774 14.8591C71.7977 13.9942 71.1692 13.6372 71.0883 14.036Z",
    fill: "url(#paint156_linear_1835_25046)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3387 19.657C35.5461 19.9742 35.6547 20.3453 35.6516 20.7242C35.6415 21.2054 36.5129 21.1543 36.1254 20.0347C35.8106 19.1258 35.1141 19.3175 35.3387 19.657Z",
    fill: "url(#paint157_linear_1835_25046)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0358 48.911C14.4065 48.9887 14.7459 49.1743 15.0115 49.4446C15.3447 49.7923 15.9244 49.1395 14.8588 48.6219C13.994 48.2016 13.6369 48.8301 14.0358 48.911Z",
    fill: "url(#paint158_linear_1835_25046)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6569 84.661C19.9741 84.4536 20.3452 84.345 20.7241 84.3481C21.2054 84.3583 21.1542 83.4868 20.0347 83.8743C19.1257 84.1891 19.3175 84.8856 19.6569 84.661Z",
    fill: "url(#paint159_linear_1835_25046)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9111 105.96C48.9889 105.589 49.1744 105.25 49.4447 104.984C49.7924 104.651 49.1396 104.071 48.6221 105.137C48.2018 106.002 48.8303 106.359 48.9111 105.96Z",
    fill: "url(#paint160_linear_1835_25046)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6615 100.34C84.4541 100.023 84.3455 99.6517 84.3486 99.2728C84.3587 98.7916 83.4873 98.8427 83.8748 99.9623C84.1896 100.871 84.8861 100.679 84.6615 100.34Z",
    fill: "url(#paint161_linear_1835_25046)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M105.959 71.089C105.588 71.0113 105.249 70.8258 104.983 70.5554C104.65 70.2078 104.07 70.8605 105.136 71.3781C106.001 71.7984 106.358 71.1699 105.959 71.089Z",
    fill: "url(#paint162_linear_1835_25046)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M100.34 35.339C100.023 35.5464 99.6519 35.655 99.2729 35.6519C98.7917 35.6417 98.8429 36.5132 99.9624 36.1257C100.871 35.8108 100.68 35.1144 100.34 35.339Z",
    fill: "url(#paint163_linear_1835_25046)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2613 27.415C93.9789 27.6673 93.7777 27.9982 93.6828 28.365C93.5679 28.8326 92.7394 28.5576 93.4039 27.5763C93.9429 26.7798 94.5664 27.1454 94.2613 27.415Z",
    fill: "url(#paint164_linear_1835_25046)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1865 12.732C61.1658 13.1105 61.2572 13.4863 61.4494 13.8129C61.699 14.2246 60.9186 14.616 60.6943 13.4527C60.5123 12.5082 61.2115 12.3257 61.1865 12.732Z",
    fill: "url(#paint165_linear_1835_25046)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4144 25.738C27.6668 26.0204 27.9976 26.2216 28.3644 26.3165C28.832 26.4314 28.557 27.2599 27.5758 26.5954C26.7793 26.0564 27.1449 25.4329 27.4144 25.738Z",
    fill: "url(#paint166_linear_1835_25046)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M12.731 58.814C13.1095 58.8347 13.4853 58.7433 13.8119 58.5511C14.2236 58.3015 14.615 59.082 13.4517 59.3062C12.5072 59.4882 12.3247 58.789 12.731 58.814Z",
    fill: "url(#paint167_linear_1835_25046)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7386 92.585C26.021 92.3327 26.2222 92.0018 26.3171 91.635C26.432 91.1675 27.2605 91.4425 26.596 92.4237C26.057 93.2202 25.4335 92.8546 25.7386 92.585Z",
    fill: "url(#paint168_linear_1835_25046)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8135 107.27C58.8342 106.891 58.7428 106.516 58.5506 106.189C58.301 105.777 59.0815 105.386 59.3057 106.549C59.4877 107.494 58.7885 107.676 58.8135 107.27Z",
    fill: "url(#paint169_linear_1835_25046)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5841 94.262C92.3317 93.9796 92.0009 93.7784 91.6341 93.6835C91.1665 93.5687 91.4415 92.7402 92.4227 93.4046C93.2192 93.9437 92.8536 94.5671 92.5841 94.262Z",
    fill: "url(#paint170_linear_1835_25046)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M107.271 61.186C106.892 61.1653 106.517 61.2567 106.19 61.4489C105.778 61.6985 105.387 60.9181 106.55 60.6939C107.495 60.5118 107.677 61.211 107.271 61.186Z",
    fill: "url(#paint171_linear_1835_25046)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5541 14.796C73.5409 14.7331 73.4991 14.6792 73.4409 14.6511C73.3827 14.6225 73.3151 14.6229 73.2569 14.6511C72.9948 14.7854 72.5917 15.7898 72.5366 15.9394C72.4397 16.2026 72.8354 16.3499 72.9768 16.1276C73.0526 16.0081 73.6041 15.1026 73.5541 14.796Z",
    fill: "url(#paint172_linear_1835_25046)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6215 18.452C37.5672 18.4168 37.4996 18.4086 37.4387 18.4297C37.3773 18.4508 37.3293 18.4989 37.3086 18.5598C37.3504 19.0547 37.4867 19.5371 37.7102 19.9805C37.8277 20.2352 38.2117 20.0594 38.1547 19.8024C38.066 19.3219 37.8848 18.8633 37.6215 18.452Z",
    fill: "url(#paint173_linear_1835_25046)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7951 46.446C14.7322 46.4593 14.6783 46.5011 14.6501 46.5593C14.6216 46.6175 14.622 46.6851 14.6501 46.7433C14.7845 47.0054 15.7888 47.4085 15.9384 47.4636C16.2017 47.5605 16.349 47.1647 16.1267 47.0233C16.0072 46.9476 15.1017 46.396 14.7951 46.446Z",
    fill: "url(#paint174_linear_1835_25046)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4517 82.379C18.4166 82.4333 18.4084 82.5009 18.4295 82.5618C18.4506 82.6232 18.4986 82.6712 18.5596 82.6919C19.0545 82.6501 19.5369 82.5138 19.9803 82.2904C20.2349 82.1728 20.0592 81.7888 19.8021 81.8458C19.3217 81.9345 18.8631 82.1157 18.4517 82.379Z",
    fill: "url(#paint175_linear_1835_25046)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4466 105.2C46.4598 105.263 46.5016 105.317 46.5598 105.345C46.618 105.373 46.6856 105.373 46.7438 105.345C47.0059 105.21 47.4091 104.206 47.4641 104.057C47.561 103.793 47.1653 103.646 47.0239 103.868C46.9481 103.988 46.3966 104.893 46.4466 105.2Z",
    fill: "url(#paint176_linear_1835_25046)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3788 101.55C82.4331 101.585 82.5007 101.593 82.5616 101.572C82.6229 101.551 82.671 101.503 82.6917 101.442C82.6499 100.947 82.5136 100.465 82.2901 100.021C82.1725 99.7668 81.7886 99.9425 81.8456 100.2C81.9343 100.68 82.1155 101.139 82.3788 101.55Z",
    fill: "url(#paint177_linear_1835_25046)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M105.2 73.554C105.263 73.5407 105.317 73.4989 105.345 73.4407C105.373 73.3825 105.373 73.315 105.345 73.2568C105.21 72.9947 104.206 72.5915 104.057 72.5365C103.793 72.4396 103.646 72.8353 103.868 72.9767C103.988 73.0525 104.893 73.604 105.2 73.554Z",
    fill: "url(#paint178_linear_1835_25046)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M101.549 37.621C101.584 37.5667 101.593 37.4991 101.572 37.4382C101.55 37.3769 101.502 37.3288 101.441 37.3081C100.947 37.3499 100.464 37.4862 100.021 37.7097C99.766 37.8272 99.9418 38.2112 100.199 38.1542C100.679 38.0655 101.138 37.8843 101.549 37.621Z",
    fill: "url(#paint179_linear_1835_25046)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3696 25.66C92.4309 25.6397 92.4985 25.6491 92.552 25.6854C92.6055 25.7217 92.6395 25.7803 92.6438 25.8452C92.6587 26.1393 91.9903 26.9905 91.8883 27.1132C91.709 27.3288 91.3833 27.0597 91.5052 26.8265C91.568 26.7054 92.0802 25.7694 92.3696 25.66Z",
    fill: "url(#paint180_linear_1835_25046)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6076 12.829C58.6369 12.7712 58.6912 12.7302 58.7544 12.7181C58.8181 12.7056 58.8837 12.7235 58.9326 12.7657C59.1435 13.2153 59.2665 13.7013 59.2947 14.1969C59.3201 14.4762 58.8998 14.5161 58.8208 14.2649C58.6576 13.8043 58.5849 13.3169 58.6076 12.829Z",
    fill: "url(#paint181_linear_1835_25046)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M25.659 27.63C25.6387 27.5687 25.648 27.5011 25.6844 27.4476C25.7207 27.3941 25.7793 27.3601 25.8441 27.3558C26.1383 27.3409 26.9894 28.0093 27.1121 28.1112C27.3278 28.2905 27.0586 28.6163 26.8254 28.4944C26.7043 28.4316 25.7684 27.9194 25.659 27.63Z",
    fill: "url(#paint182_linear_1835_25046)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8297 61.393C12.7719 61.3638 12.7309 61.3095 12.7187 61.2462C12.7062 61.1825 12.7242 61.1169 12.7664 61.068C13.216 60.8571 13.702 60.7341 14.1976 60.7059C14.4769 60.6805 14.5167 61.1009 14.2656 61.1798C13.805 61.343 13.3175 61.4157 12.8297 61.393Z",
    fill: "url(#paint183_linear_1835_25046)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6299 94.3401C27.5686 94.3604 27.501 94.351 27.4475 94.3147C27.394 94.2783 27.36 94.2197 27.3557 94.1549C27.3409 93.8608 28.0092 93.0096 28.1112 92.8869C28.2905 92.6713 28.6163 92.9404 28.4944 93.1736C28.4315 93.2947 27.9194 94.2307 27.6299 94.3401Z",
    fill: "url(#paint184_linear_1835_25046)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3933 107.17C61.364 107.228 61.3097 107.269 61.2464 107.281C61.1827 107.293 61.1171 107.275 61.0683 107.233C60.8574 106.784 60.7343 106.298 60.7062 105.802C60.6808 105.523 61.1011 105.483 61.18 105.734C61.3433 106.195 61.416 106.682 61.3933 107.17Z",
    fill: "url(#paint185_linear_1835_25046)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3408 92.37C94.3611 92.4313 94.3517 92.4989 94.3154 92.5524C94.2791 92.6059 94.2205 92.6399 94.1556 92.6442C93.8615 92.659 93.0103 91.9907 92.8876 91.8887C92.672 91.7094 92.9411 91.3836 93.1743 91.5055C93.2954 91.5684 94.2314 92.0805 94.3408 92.37Z",
    fill: "url(#paint186_linear_1835_25046)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M107.169 58.607C107.227 58.6363 107.268 58.6905 107.28 58.7538C107.293 58.8175 107.275 58.8831 107.233 58.932C106.783 59.1429 106.297 59.2659 105.801 59.2941C105.522 59.3195 105.482 58.8991 105.733 58.8202C106.194 58.657 106.681 58.5843 107.169 58.607Z",
    fill: "url(#paint187_linear_1835_25046)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9522 15.346C75.919 15.2663 75.8416 15.2135 75.7553 15.2124C75.669 15.2108 75.5901 15.2604 75.5541 15.3389C75.4159 15.7436 75.3745 16.1221 74.9752 16.3647V16.3651C74.86 16.4378 74.8233 16.5886 74.892 16.7057C74.9608 16.8233 75.11 16.8651 75.2299 16.8007C75.7901 16.5534 76.094 15.9417 75.9522 15.346Z",
    fill: "url(#paint188_linear_1835_25046)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7045 17.144C39.5428 17.0749 39.3327 17.246 39.4182 17.4206C39.6065 17.8046 39.8448 18.1014 39.7342 18.5554C39.7041 18.6882 39.785 18.8206 39.9166 18.8554C40.0483 18.8897 40.1834 18.8136 40.2225 18.6835C40.444 18.1124 40.226 17.4651 39.7045 17.144Z",
    fill: "url(#paint189_linear_1835_25046)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3465 44.047C15.2668 44.0802 15.2141 44.1576 15.2129 44.2439C15.2114 44.3302 15.261 44.4091 15.3395 44.4451C15.7442 44.5834 16.1227 44.6248 16.3653 45.024H16.3657C16.4383 45.1392 16.5891 45.1759 16.7063 45.1072C16.8239 45.0384 16.8657 44.8892 16.8012 44.7693C16.5539 44.2091 15.9422 43.9052 15.3465 44.047Z",
    fill: "url(#paint190_linear_1835_25046)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1446 80.295C17.0755 80.4568 17.2466 80.6669 17.4212 80.5814C17.8052 80.3931 18.102 80.1548 18.556 80.2653C18.6888 80.2954 18.8212 80.2146 18.856 80.0829C18.8904 79.9513 18.8142 79.8161 18.6841 79.7771C18.113 79.5556 17.4657 79.7736 17.1446 80.295Z",
    fill: "url(#paint191_linear_1835_25046)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0464 104.65C44.0796 104.73 44.1569 104.782 44.2432 104.784C44.3296 104.785 44.4085 104.736 44.4444 104.657C44.5827 104.252 44.6241 103.874 45.0233 103.631V103.631C45.1385 103.558 45.1753 103.407 45.1065 103.29C45.0378 103.173 44.8885 103.131 44.7686 103.195C44.2085 103.443 43.9046 104.054 44.0464 104.65Z",
    fill: "url(#paint192_linear_1835_25046)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2954 102.86C80.4571 102.929 80.6673 102.758 80.5817 102.583C80.3935 102.199 80.1552 101.903 80.2657 101.449C80.2958 101.316 80.2149 101.183 80.0833 101.149C79.9517 101.114 79.8165 101.19 79.7774 101.321C79.556 101.892 79.7739 102.539 80.2954 102.86Z",
    fill: "url(#paint193_linear_1835_25046)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M104.649 75.9531C104.729 75.9198 104.781 75.8425 104.783 75.7562C104.784 75.6698 104.735 75.5909 104.656 75.555C104.251 75.4167 103.873 75.3753 103.63 74.9761H103.63C103.557 74.8609 103.406 74.8241 103.289 74.8929C103.172 74.9616 103.13 75.1109 103.194 75.2308C103.442 75.7909 104.053 76.0948 104.649 75.9531Z",
    fill: "url(#paint194_linear_1835_25046)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M102.86 39.705C102.929 39.5433 102.758 39.3331 102.584 39.4187C102.2 39.607 101.903 39.8452 101.449 39.7347C101.316 39.7046 101.184 39.7855 101.149 39.9171C101.114 40.0488 101.191 40.1839 101.321 40.223C101.892 40.4445 102.539 40.2265 102.86 39.705Z",
    fill: "url(#paint195_linear_1835_25046)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6942 23.857C90.7798 23.8457 90.8638 23.8863 90.9083 23.9605C90.9528 24.0347 90.9493 24.1281 90.8993 24.1984C90.6181 24.5203 90.311 24.7457 90.3005 25.2129L90.3001 25.2125C90.2946 25.3484 90.1825 25.4559 90.0466 25.4551C89.9102 25.4543 89.7993 25.3461 89.7954 25.2098C89.7813 24.6547 90.0778 23.9456 90.6942 23.857Z",
    fill: "url(#paint196_linear_1835_25046)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1487 12.738C56.2014 12.6696 56.2897 12.6388 56.3737 12.6599C56.4572 12.6806 56.5209 12.7493 56.535 12.8345C56.5639 13.261 56.5061 13.6372 56.8287 13.9751C56.9209 14.0751 56.9174 14.2302 56.8209 14.3259C56.724 14.4216 56.569 14.4235 56.4701 14.3302C55.9928 13.9462 55.8576 13.2767 56.1487 12.738Z",
    fill: "url(#paint197_linear_1835_25046)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8573 29.305C23.846 29.2194 23.8866 29.1355 23.9609 29.0909C24.0351 29.0464 24.1284 29.0499 24.1988 29.0999C24.5206 29.3812 24.746 29.6882 25.2133 29.6987L25.2129 29.6991C25.3488 29.7046 25.4562 29.8167 25.4554 29.9527C25.4547 30.089 25.3465 30.1999 25.2101 30.2038C24.6551 30.2179 23.9459 29.9214 23.8573 29.305Z",
    fill: "url(#paint198_linear_1835_25046)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M12.737 63.852C12.6687 63.7992 12.6378 63.711 12.6589 63.627C12.6796 63.5434 12.7483 63.4797 12.8335 63.4656C13.2601 63.4367 13.6362 63.4945 13.9741 63.1719C14.0741 63.0797 14.2292 63.0832 14.3249 63.1797C14.4206 63.2766 14.4225 63.4317 14.3292 63.5305C13.9452 64.0078 13.2757 64.143 12.737 63.852Z",
    fill: "url(#paint199_linear_1835_25046)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3057 96.143C29.2202 96.1543 29.1362 96.1137 29.0917 96.0395C29.0471 95.9653 29.0506 95.8719 29.1006 95.8016C29.3819 95.4797 29.6889 95.2543 29.6995 94.7871L29.6999 94.7875C29.7053 94.6516 29.8174 94.5441 29.9534 94.5449C30.0897 94.5457 30.2007 94.6539 30.2046 94.7902C30.2186 95.3453 29.9221 96.0544 29.3057 96.143Z",
    fill: "url(#paint200_linear_1835_25046)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8525 107.26C63.7997 107.328 63.7114 107.359 63.6275 107.338C63.5439 107.317 63.4802 107.249 63.4661 107.163C63.4372 106.737 63.495 106.361 63.1724 106.023C63.0802 105.923 63.0837 105.768 63.1802 105.672C63.2771 105.576 63.4321 105.574 63.531 105.668C64.0083 106.052 64.1435 106.721 63.8525 107.26Z",
    fill: "url(#paint201_linear_1835_25046)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M96.143 90.695C96.1543 90.7805 96.1137 90.8645 96.0395 90.909C95.9653 90.9536 95.8719 90.95 95.8016 90.9C95.4797 90.6188 95.2543 90.3118 94.7871 90.3012L94.7875 90.3008C94.6516 90.2954 94.5441 90.1832 94.5449 90.0473C94.5457 89.911 94.6539 89.8 94.7902 89.7961C95.3453 89.7821 96.0544 90.0786 96.143 90.695Z",
    fill: "url(#paint202_linear_1835_25046)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M107.261 56.148C107.329 56.2008 107.36 56.2891 107.339 56.373C107.318 56.4566 107.249 56.5203 107.164 56.5344C106.737 56.5633 106.361 56.5055 106.023 56.8281C105.923 56.9203 105.768 56.9168 105.673 56.8203C105.577 56.7234 105.575 56.5684 105.668 56.4695C106.052 55.9922 106.722 55.857 107.261 56.148Z",
    fill: "url(#paint203_linear_1835_25046)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8654 17.417C76.699 17.7334 77.2025 18.008 77.3377 17.6912V17.6916C77.481 17.3654 77.6712 17.0623 77.9021 16.7916C78.1712 16.4627 77.5478 16.1197 76.8654 17.417Z",
    fill: "url(#paint204_linear_1835_25046)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8162 17.963C41.9225 18.3044 42.4725 18.1427 42.3439 17.8232C42.215 17.4911 42.1353 17.1423 42.1068 16.7877C42.0646 16.3646 41.381 16.563 41.8162 17.963Z",
    fill: "url(#paint205_linear_1835_25046)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4175 43.134C17.7339 43.3004 18.0085 42.7969 17.6917 42.6617H17.6921C17.3659 42.5184 17.0628 42.3281 16.7921 42.0973C16.4632 41.8281 16.1202 42.4516 17.4175 43.134Z",
    fill: "url(#paint206_linear_1835_25046)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9625 78.184C18.3039 78.0778 18.1422 77.5278 17.8226 77.6563C17.4906 77.7852 17.1418 77.8649 16.7871 77.8934C16.3641 77.9356 16.5625 78.6192 17.9625 78.184Z",
    fill: "url(#paint207_linear_1835_25046)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M43.134 102.58C43.3004 102.264 42.7969 101.989 42.6617 102.306C42.5184 102.632 42.3281 102.935 42.0973 103.206C41.8281 103.534 42.4516 103.877 43.134 102.58Z",
    fill: "url(#paint208_linear_1835_25046)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1838 102.04C78.0775 101.699 77.5275 101.86 77.6561 102.18C77.785 102.512 77.8647 102.861 77.8932 103.215C77.9354 103.638 78.619 103.44 78.1838 102.04Z",
    fill: "url(#paint209_linear_1835_25046)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M102.581 76.866C102.264 76.6996 101.99 77.2031 102.307 77.3383C102.632 77.4816 102.935 77.6719 103.207 77.9027C103.535 78.1719 103.878 77.5484 102.581 76.866Z",
    fill: "url(#paint210_linear_1835_25046)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M102.04 41.816C101.699 41.9223 101.86 42.4723 102.18 42.3437C102.512 42.2148 102.861 42.1352 103.215 42.1066C103.638 42.0645 103.44 41.3809 102.04 41.816Z",
    fill: "url(#paint211_linear_1835_25046)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4456 24.102C88.2546 24.4043 87.7652 24.1055 87.9718 23.8301C88.1823 23.543 88.3499 23.227 88.4691 22.8914C88.6191 22.4938 89.2281 22.8626 88.4456 24.102Z",
    fill: "url(#paint212_linear_1835_25046)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7307 14.502C54.8096 14.8508 54.2522 14.9856 54.2037 14.6449H54.2033C54.149 14.293 54.044 13.9508 53.8912 13.6293C53.7162 13.2422 54.4073 13.0723 54.7307 14.502Z",
    fill: "url(#paint213_linear_1835_25046)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1018 31.555C24.4041 31.746 24.1053 32.2355 23.8299 32.0288C23.5428 31.8183 23.2268 31.6507 22.8913 31.5316C22.4936 31.3816 22.8624 30.7726 24.1018 31.555Z",
    fill: "url(#paint214_linear_1835_25046)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5019 65.27C14.8507 65.1911 14.9855 65.7485 14.6449 65.7969V65.7973C14.2929 65.8516 13.9507 65.9567 13.6293 66.1094C13.2422 66.2844 13.0722 65.5934 14.5019 65.27Z",
    fill: "url(#paint215_linear_1835_25046)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5549 95.898C31.7459 95.5957 32.2353 95.8945 32.0287 96.1699C31.8181 96.457 31.6506 96.773 31.5314 97.1086C31.3814 97.5062 30.7724 97.1374 31.5549 95.898Z",
    fill: "url(#paint216_linear_1835_25046)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2694 105.5C65.1904 105.151 65.7479 105.016 65.7963 105.357H65.7967C65.851 105.709 65.9561 106.051 66.1088 106.373C66.2838 106.76 65.5928 106.93 65.2694 105.5Z",
    fill: "url(#paint217_linear_1835_25046)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8981 88.445C95.5958 88.254 95.8946 87.7645 96.17 87.9712C96.4571 88.1817 96.7732 88.3493 97.1087 88.4685C97.5064 88.6185 97.1376 89.2274 95.8981 88.445Z",
    fill: "url(#paint218_linear_1835_25046)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M105.5 54.73C105.152 54.8089 105.017 54.2514 105.357 54.203V54.2026C105.709 54.1483 106.052 54.0432 106.373 53.8905C106.76 53.7155 106.93 54.4065 105.5 54.73Z",
    fill: "url(#paint219_linear_1835_25046)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3177 17.639C79.2365 18.0015 79.0677 18.3382 78.8259 18.6202C78.733 18.728 78.742 18.8905 78.8463 18.9874C78.9509 19.0839 79.1134 19.0808 79.2138 18.9796C80.4685 17.7409 79.4674 17.1323 79.3177 17.639Z",
    fill: "url(#paint220_linear_1835_25046)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7065 16.386C43.9096 16.6973 44.0291 17.0563 44.0526 17.4274C44.0631 17.5696 44.1842 17.6778 44.3264 17.6727C44.4686 17.6672 44.5811 17.55 44.5807 17.4075C44.592 15.6442 43.4541 15.922 43.7065 16.386Z",
    fill: "url(#paint221_linear_1835_25046)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6397 40.682C18.0022 40.7632 18.3389 40.932 18.621 41.1738C18.7288 41.2667 18.8913 41.2578 18.9882 41.1535C19.0846 41.0488 19.0815 40.8863 18.9803 40.7859C17.7416 39.5312 17.133 40.5324 17.6397 40.682Z",
    fill: "url(#paint222_linear_1835_25046)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3861 76.294C16.6974 76.0909 17.0564 75.9713 17.4275 75.9479C17.5697 75.9373 17.6779 75.8162 17.6728 75.6741C17.6673 75.5319 17.5502 75.4194 17.4076 75.4198C15.6443 75.4084 15.9221 76.5464 16.3861 76.294Z",
    fill: "url(#paint223_linear_1835_25046)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6819 102.36C40.7632 101.997 40.9319 101.661 41.1737 101.379C41.2667 101.271 41.2577 101.108 41.1534 101.012C41.0487 100.915 40.8862 100.918 40.7858 101.019C39.5311 102.258 40.5323 102.867 40.6819 102.36Z",
    fill: "url(#paint224_linear_1835_25046)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2942 103.61C76.0911 103.299 75.9716 102.94 75.9481 102.569C75.9376 102.426 75.8165 102.318 75.6743 102.323C75.5321 102.329 75.4196 102.446 75.42 102.589C75.4087 104.352 76.5466 104.074 76.2942 103.61Z",
    fill: "url(#paint225_linear_1835_25046)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M102.36 79.318C101.998 79.2367 101.661 79.068 101.379 78.8262C101.271 78.7332 101.109 78.7422 101.012 78.8465C100.915 78.9512 100.918 79.1137 101.019 79.2141C102.258 80.4688 102.867 79.4676 102.36 79.318Z",
    fill: "url(#paint226_linear_1835_25046)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M103.609 43.706C103.298 43.9091 102.939 44.0286 102.568 44.0521C102.426 44.0626 102.317 44.1837 102.322 44.3259C102.328 44.4681 102.445 44.5806 102.588 44.5802C104.351 44.5915 104.073 43.4536 103.609 43.706Z",
    fill: "url(#paint227_linear_1835_25046)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0266 22.089C86.7496 22.3374 86.5414 22.6531 86.4223 23.0054C86.3758 23.1402 86.2305 23.2136 86.0945 23.1714C85.9582 23.1292 85.8801 22.9871 85.9176 22.8496C86.3629 21.1437 87.3903 21.7062 87.0266 22.089Z",
    fill: "url(#paint228_linear_1835_25046)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3047 14.082C52.2891 14.4531 52.3649 14.8222 52.5254 15.1574C52.5875 15.2855 52.5371 15.4398 52.4109 15.5062C52.2852 15.573 52.1289 15.5273 52.0582 15.4039C51.1668 13.8828 52.291 13.5539 52.3047 14.082Z",
    fill: "url(#paint229_linear_1835_25046)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0884 32.973C22.3368 33.2499 22.6525 33.4581 23.0048 33.5773C23.1396 33.6238 23.213 33.7691 23.1708 33.905C23.1286 34.0413 22.9864 34.1195 22.8489 34.082C21.143 33.6367 21.7055 32.6093 22.0884 32.973Z",
    fill: "url(#paint230_linear_1835_25046)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0827 67.696C14.4538 67.7116 14.823 67.6358 15.1581 67.4753C15.2862 67.4132 15.4405 67.4636 15.507 67.5897C15.5738 67.7155 15.528 67.8718 15.4046 67.9425C13.8835 68.8339 13.5546 67.7096 14.0827 67.696Z",
    fill: "url(#paint231_linear_1835_25046)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M32.973 97.911C33.2499 97.6625 33.4581 97.3469 33.5773 96.9946C33.6238 96.8598 33.7691 96.7864 33.905 96.8285C34.0413 96.8707 34.1195 97.0129 34.082 97.1504C33.6367 98.8563 32.6093 98.2938 32.973 97.911Z",
    fill: "url(#paint232_linear_1835_25046)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6965 105.92C67.7121 105.549 67.6363 105.18 67.4758 104.845C67.4137 104.717 67.464 104.562 67.5902 104.496C67.716 104.429 67.8722 104.475 67.9429 104.598C68.8344 106.119 67.7101 106.448 67.6965 105.92Z",
    fill: "url(#paint233_linear_1835_25046)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9107 87.0271C97.6623 86.7501 97.3467 86.5419 96.9943 86.4228C96.8596 86.3763 96.7861 86.231 96.8283 86.095C96.8705 85.9587 97.0127 85.8806 97.1502 85.9181C98.8561 86.3634 98.2936 87.3908 97.9107 87.0271Z",
    fill: "url(#paint234_linear_1835_25046)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M105.92 52.304C105.549 52.2883 105.18 52.3641 104.844 52.5247C104.716 52.5868 104.562 52.5364 104.496 52.4102C104.429 52.2844 104.474 52.1282 104.598 52.0575C106.119 51.1661 106.448 52.2903 105.92 52.304Z",
    fill: "url(#paint235_linear_1835_25046)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7204 18.295C81.2591 18.6595 80.8759 19.1134 80.5938 19.6294C80.5079 19.745 80.529 19.9079 80.6415 19.9978C80.754 20.0876 80.9176 20.072 81.0114 19.9626C81.4368 19.5474 81.7747 19.0509 82.0051 18.5028C82.0219 18.4282 81.9926 18.3505 81.9309 18.3056C81.8692 18.2602 81.7864 18.2563 81.7204 18.295Z",
    fill: "url(#paint236_linear_1835_25046)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8673 15.152C45.7994 15.736 45.8494 16.3278 46.0142 16.8922C46.0353 17.0344 46.1654 17.1348 46.3087 17.1187C46.4517 17.1027 46.5564 16.9762 46.5455 16.8324C46.5525 16.2379 46.4404 15.648 46.2158 15.0976C46.1748 15.0332 46.0994 14.9988 46.024 15.0105C45.9482 15.0222 45.8869 15.0778 45.8673 15.152Z",
    fill: "url(#paint237_linear_1835_25046)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M18.294 38.28C18.6585 38.7413 19.1124 39.1245 19.6284 39.4066C19.7441 39.4925 19.907 39.4714 19.9968 39.3589C20.0866 39.2464 20.071 39.0828 19.9616 38.989C19.5464 38.5636 19.0499 38.2257 18.5018 37.9953C18.4272 37.9785 18.3495 38.0078 18.3046 38.0695C18.2593 38.1312 18.2554 38.214 18.294 38.28Z",
    fill: "url(#paint238_linear_1835_25046)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1516 74.132C15.7355 74.2 16.3274 74.15 16.8918 73.9852C17.034 73.9641 17.1343 73.834 17.1183 73.6906C17.1023 73.5477 16.9757 73.443 16.832 73.4539C16.2375 73.4469 15.6476 73.559 15.0972 73.7836C15.0327 73.8246 14.9984 73.9 15.0101 73.9754C15.0218 74.0512 15.0773 74.1125 15.1516 74.132Z",
    fill: "url(#paint239_linear_1835_25046)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2796 101.7C38.741 101.335 39.1242 100.882 39.4062 100.366C39.4922 100.25 39.4711 100.087 39.3586 99.9972C39.2461 99.9073 39.0824 99.923 38.9887 100.032C38.5633 100.448 38.2254 100.944 37.9949 101.492C37.9781 101.567 38.0074 101.644 38.0691 101.689C38.1308 101.735 38.2136 101.739 38.2796 101.7Z",
    fill: "url(#paint240_linear_1835_25046)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M74.132 104.85C74.2 104.266 74.15 103.674 73.9852 103.11C73.9641 102.968 73.834 102.867 73.6906 102.883C73.5477 102.899 73.443 103.026 73.4539 103.17C73.4469 103.764 73.559 104.354 73.7836 104.904C73.8246 104.969 73.9 105.003 73.9754 104.992C74.0512 104.98 74.1125 104.924 74.132 104.85Z",
    fill: "url(#paint241_linear_1835_25046)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M101.701 81.7201C101.336 81.2587 100.882 80.8755 100.366 80.5935C100.251 80.5075 100.088 80.5286 99.9978 80.6411C99.9079 80.7536 99.9236 80.9173 100.033 81.011C100.448 81.4364 100.945 81.7743 101.493 82.0048C101.567 82.0216 101.645 81.9923 101.69 81.9306C101.735 81.8688 101.739 81.7861 101.701 81.7201Z",
    fill: "url(#paint242_linear_1835_25046)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M104.849 45.868C104.265 45.8 103.674 45.85 103.109 46.0149C102.967 46.036 102.867 46.1661 102.883 46.3094C102.899 46.4524 103.025 46.5571 103.169 46.5461C103.763 46.5532 104.353 46.4411 104.904 46.2164C104.968 46.1754 105.002 46.1 104.991 46.0246C104.979 45.9489 104.924 45.8875 104.849 45.868Z",
    fill: "url(#paint243_linear_1835_25046)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2573 20.338C85.1722 20.92 84.9706 21.4786 84.6651 21.981C84.6081 22.113 84.4562 22.1763 84.3222 22.1236C84.1882 22.0712 84.1198 21.922 84.1675 21.7861C84.3148 21.2099 84.5757 20.6693 84.9351 20.1955C84.9913 20.1439 85.073 20.1302 85.1429 20.1611C85.2128 20.192 85.2577 20.2614 85.2573 20.338Z",
    fill: "url(#paint244_linear_1835_25046)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8129 14.095C50.1641 14.5669 50.4168 15.1044 50.5559 15.6755C50.6086 15.8095 50.5461 15.9611 50.4145 16.0189C50.2824 16.0763 50.1285 16.0193 50.0664 15.8896C49.7629 15.3783 49.5648 14.8115 49.4844 14.2224C49.4875 14.1458 49.5355 14.0786 49.607 14.0509C49.6785 14.0236 49.7594 14.0407 49.8129 14.095Z",
    fill: "url(#paint245_linear_1835_25046)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3378 34.743C20.9198 34.8281 21.4784 35.0297 21.9808 35.3352C22.1128 35.3922 22.1761 35.5442 22.1233 35.6781C22.071 35.8121 21.9218 35.8805 21.7858 35.8328C21.2097 35.6856 20.669 35.4246 20.1952 35.0653C20.1437 35.009 20.13 34.9274 20.1609 34.8574C20.1917 34.7875 20.2612 34.7426 20.3378 34.743Z",
    fill: "url(#paint246_linear_1835_25046)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M14.094 70.186C14.5659 69.8348 15.1034 69.5821 15.6745 69.443C15.8085 69.3903 15.9601 69.4528 16.0179 69.5844C16.0753 69.7165 16.0183 69.8704 15.8886 69.9325C15.3773 70.236 14.8105 70.434 14.2214 70.5145C14.1448 70.5114 14.0777 70.4633 14.0499 70.3918C14.0226 70.3204 14.0397 70.2395 14.094 70.186Z",
    fill: "url(#paint247_linear_1835_25046)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7422 99.6619C34.8273 99.0799 35.0289 98.5213 35.3344 98.0189C35.3914 97.8869 35.5434 97.8236 35.6773 97.8764C35.8113 97.9287 35.8797 98.0779 35.832 98.2139C35.6848 98.79 35.4238 99.3307 35.0645 99.8045C35.0082 99.856 34.9266 99.8697 34.8566 99.8388C34.7867 99.808 34.7418 99.7385 34.7422 99.6619Z",
    fill: "url(#paint248_linear_1835_25046)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1855 105.91C69.8343 105.438 69.5816 104.901 69.4425 104.33C69.3898 104.196 69.4523 104.044 69.5839 103.986C69.716 103.929 69.8699 103.986 69.932 104.115C70.2355 104.627 70.4335 105.194 70.514 105.783C70.5109 105.859 70.4628 105.926 70.3913 105.954C70.3199 105.982 70.239 105.964 70.1855 105.91Z",
    fill: "url(#paint249_linear_1835_25046)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6616 85.257C99.0795 85.1718 98.521 84.9703 98.0186 84.6648C97.8865 84.6078 97.8233 84.4558 97.876 84.3218C97.9283 84.1878 98.0776 84.1195 98.2135 84.1671C98.7897 84.3144 99.3303 84.5753 99.8041 84.9347C99.8557 84.991 99.8693 85.0726 99.8385 85.1425C99.8076 85.2124 99.7381 85.2574 99.6616 85.257Z",
    fill: "url(#paint250_linear_1835_25046)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M105.909 49.814C105.437 50.1652 104.9 50.4179 104.329 50.557C104.195 50.6097 104.043 50.5472 103.985 50.4156C103.928 50.2835 103.985 50.1296 104.115 50.0675C104.626 49.764 105.193 49.5659 105.782 49.4855C105.858 49.4886 105.925 49.5366 105.953 49.6081C105.981 49.6796 105.963 49.7605 105.909 49.814Z",
    fill: "url(#paint251_linear_1835_25046)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M85.225 16.307C84.7945 15.9769 84.3195 16.2641 84.4398 16.2621C83.9347 16.2426 83.4722 16.5434 83.2855 17.0133C83.0988 17.4828 83.2289 18.0192 83.6093 18.3516C84.0113 18.8645 84.7413 18.9789 85.2808 18.6133C85.8199 18.2473 85.9839 17.5266 85.6558 16.9637C85.7273 16.8489 85.6015 16.4633 85.225 16.307Z",
    fill: "url(#paint252_linear_1835_25046)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M108.73 46.942C108.659 46.4068 108.086 46.2385 108.206 46.3553V46.3549C107.863 45.9838 107.323 45.8697 106.859 46.0697C106.394 46.2697 106.107 46.7408 106.141 47.2451C106.066 47.8904 106.501 48.4846 107.139 48.6072C107.777 48.7295 108.401 48.3385 108.57 47.7108C108.704 47.6795 108.884 47.3151 108.73 46.942Z",
    fill: "url(#paint253_linear_1835_25046)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M103.69 85.2259C104.02 84.7955 103.733 84.3205 103.735 84.4408C103.754 83.9357 103.453 83.4732 102.984 83.2865C102.514 83.0998 101.978 83.2298 101.645 83.6103C101.132 84.0122 101.018 84.7423 101.384 85.2818C101.75 85.8209 102.47 85.9849 103.033 85.6568C103.148 85.7283 103.534 85.6025 103.69 85.2259Z",
    fill: "url(#paint254_linear_1835_25046)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0587 108.73C73.5938 108.659 73.7622 108.086 73.6454 108.207H73.6458C74.0169 107.863 74.1309 107.323 73.9309 106.859C73.7309 106.395 73.2598 106.107 72.7555 106.142C72.1102 106.066 71.516 106.501 71.3934 107.139C71.2712 107.778 71.6622 108.402 72.2899 108.57C72.3212 108.704 72.6856 108.884 73.0587 108.73Z",
    fill: "url(#paint255_linear_1835_25046)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7734 103.69C35.2038 104.02 35.6789 103.733 35.5585 103.735C36.0636 103.754 36.5261 103.454 36.7128 102.984C36.8996 102.514 36.7695 101.978 36.389 101.645C35.9871 101.133 35.257 101.018 34.7175 101.384C34.1784 101.75 34.0144 102.47 34.3425 103.033C34.271 103.148 34.3968 103.534 34.7734 103.69Z",
    fill: "url(#paint256_linear_1835_25046)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2664 73.058C11.3371 73.5932 11.9101 73.7616 11.7898 73.6448V73.6452C12.1332 74.0162 12.673 74.1303 13.1371 73.9303C13.6016 73.7303 13.8891 73.2592 13.8547 72.7549C13.9301 72.1096 13.4949 71.5154 12.857 71.3928C12.2188 71.2705 11.5945 71.6616 11.4261 72.2893C11.2922 72.3205 11.1121 72.685 11.2664 73.058Z",
    fill: "url(#paint257_linear_1835_25046)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3073 34.774C15.9772 35.2045 16.2643 35.6795 16.2623 35.5592C16.2428 36.0642 16.5436 36.5267 17.0135 36.7135C17.483 36.9002 18.0194 36.7701 18.3518 36.3896C18.8647 35.9877 18.9792 35.2576 18.6135 34.7181C18.2475 34.1791 17.5268 34.015 16.9639 34.3431C16.8491 34.2716 16.4635 34.3974 16.3073 34.774Z",
    fill: "url(#paint258_linear_1835_25046)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9424 11.267C46.4072 11.3377 46.2389 11.9107 46.3557 11.7904H46.3553C45.9842 12.1338 45.8701 12.6736 46.0701 13.1377C46.2701 13.6022 46.7412 13.8897 47.2455 13.8553C47.8908 13.9307 48.485 13.4955 48.6076 12.8577C48.7299 12.2194 48.3389 11.5952 47.7111 11.4268C47.6799 11.2928 47.3154 11.1127 46.9424 11.267Z",
    fill: "url(#paint259_linear_1835_25046)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7528 13.663C86.3216 13.3864 85.7583 13.4337 85.3794 13.7786C85.0005 14.1239 84.9009 14.6802 85.1365 15.1352C85.3716 15.5477 85.8111 15.8016 86.2861 15.7989C86.7982 15.7762 87.231 15.4114 87.3408 14.9106C87.4501 14.4094 87.2091 13.8974 86.7528 13.663Z",
    fill: "url(#paint260_linear_1835_25046)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M111.68 46.152C111.571 45.6512 111.139 45.2864 110.628 45.2625C110.116 45.2387 109.652 45.5617 109.497 46.05C109.373 46.5078 109.504 46.9969 109.84 47.332C110.219 47.6781 110.782 47.7262 111.214 47.4496C111.646 47.1727 111.837 46.6403 111.68 46.152Z",
    fill: "url(#paint261_linear_1835_25046)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M106.339 86.753C106.616 86.3217 106.568 85.7584 106.223 85.3796C105.878 85.0006 105.322 84.901 104.867 85.1366C104.454 85.3717 104.2 85.8112 104.203 86.2862C104.226 86.7983 104.591 87.2311 105.091 87.3409C105.593 87.4503 106.105 87.2092 106.339 86.753Z",
    fill: "url(#paint262_linear_1835_25046)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8475 111.68C74.3483 111.571 74.7132 111.139 74.737 110.627C74.7608 110.116 74.4378 109.651 73.9495 109.496C73.4917 109.373 73.0026 109.504 72.6675 109.84C72.3214 110.218 72.2734 110.782 72.5499 111.214C72.8269 111.646 73.3592 111.837 73.8475 111.68Z",
    fill: "url(#paint263_linear_1835_25046)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2469 106.34C33.6781 106.617 34.2414 106.569 34.6203 106.224C34.9992 105.879 35.0988 105.323 34.8633 104.868C34.6281 104.455 34.1886 104.201 33.7137 104.204C33.2015 104.227 32.7687 104.592 32.659 105.092C32.5496 105.594 32.7906 106.106 33.2469 106.34Z",
    fill: "url(#paint264_linear_1835_25046)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31802 73.848C8.427 74.3488 8.85904 74.7137 9.37072 74.7375C9.88244 74.7613 10.3465 74.4383 10.5016 73.95C10.6251 73.4922 10.4942 73.0031 10.1583 72.668C9.77974 72.3219 9.21607 72.2738 8.78446 72.5504C8.35243 72.8274 8.16099 73.3597 8.31802 73.848Z",
    fill: "url(#paint265_linear_1835_25046)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6636 33.247C13.3871 33.6783 13.4343 34.2415 13.7792 34.6204C14.1245 34.9993 14.6808 35.0989 15.1358 34.8634C15.5483 34.6282 15.8022 34.1888 15.7995 33.7138C15.7768 33.2017 15.412 32.7689 14.9112 32.6591C14.4101 32.5497 13.898 32.7908 13.6636 33.247Z",
    fill: "url(#paint266_linear_1835_25046)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1524 8.31802C45.6516 8.427 45.2868 8.85904 45.263 9.37072C45.2391 9.88244 45.5622 10.3465 46.0505 10.5016C46.5083 10.6251 46.9973 10.4942 47.3325 10.1583C47.6785 9.77974 47.7266 9.21607 47.45 8.78446C47.1731 8.35243 46.6407 8.16099 46.1524 8.31802Z",
    fill: "url(#paint267_linear_1835_25046)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9322 11.62C87.1517 11.0446 86.4064 12.4563 87.2553 12.7923C87.9724 13.3603 88.8209 12.0083 87.9322 11.62Z",
    fill: "url(#paint268_linear_1835_25046)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M113.961 45.541C113.816 44.582 112.291 45.0535 112.653 45.8914C112.758 46.8 114.314 46.4441 113.961 45.541Z",
    fill: "url(#paint269_linear_1835_25046)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M108.38 87.932C108.955 87.1515 107.544 86.4062 107.208 87.255C106.64 87.9722 107.992 88.8206 108.38 87.932Z",
    fill: "url(#paint270_linear_1835_25046)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4598 113.96C75.4188 113.815 74.9473 112.29 74.1095 112.653C73.2009 112.758 73.5567 114.314 74.4598 113.96Z",
    fill: "url(#paint271_linear_1835_25046)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0669 108.38C32.8474 108.955 33.5927 107.544 32.7439 107.208C32.0267 106.64 31.1783 107.992 32.0669 108.38Z",
    fill: "url(#paint272_linear_1835_25046)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03857 74.459C6.18349 75.418 7.70847 74.9465 7.34597 74.1086C7.24089 73.2 5.68467 73.5559 6.03857 74.459Z",
    fill: "url(#paint273_linear_1835_25046)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6207 32.068C11.0453 32.8485 12.457 33.5938 12.793 32.745C13.3609 32.0278 12.009 31.1794 11.6207 32.068Z",
    fill: "url(#paint274_linear_1835_25046)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5402 6.03869C44.5813 6.18361 45.0527 7.70859 45.8906 7.34609C46.7992 7.24101 46.4434 5.68479 45.5402 6.03869Z",
    fill: "url(#paint275_linear_1835_25046)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M67.636 10.246C67.6895 9.66906 67.2778 9.15301 66.7032 9.07721C66.129 9.00182 65.5977 9.39362 65.5001 9.96471C65.1806 11.4092 67.5708 11.7191 67.636 10.246Z",
    fill: "url(#paint276_linear_1835_25046)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M100.58 30.219C101.026 29.849 101.099 29.1928 100.746 28.7331C100.394 28.2733 99.7405 28.1745 99.2679 28.51C98.0206 29.3057 99.4917 31.2143 100.58 30.219Z",
    fill: "url(#paint277_linear_1835_25046)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M109.75 67.637C110.327 67.6905 110.843 67.2788 110.919 66.7042C110.994 66.1299 110.602 65.5987 110.031 65.5011C108.587 65.1815 108.277 67.5718 109.75 67.637Z",
    fill: "url(#paint278_linear_1835_25046)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7809 100.58C90.1508 101.026 90.8071 101.1 91.2668 100.747C91.7266 100.394 91.8254 99.7408 91.4899 99.2682C90.6942 98.0209 88.7856 99.4921 89.7809 100.58Z",
    fill: "url(#paint279_linear_1835_25046)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3621 109.75C52.3086 110.327 52.7203 110.843 53.2949 110.919C53.8691 110.994 54.4004 110.602 54.498 110.031C54.8175 108.587 52.4273 108.277 52.3621 109.75Z",
    fill: "url(#paint280_linear_1835_25046)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4186 89.781C18.9729 90.151 18.8995 90.8072 19.2522 91.2665C19.6046 91.7263 20.2577 91.8247 20.7303 91.49C21.9776 90.6943 20.5065 88.7857 19.4186 89.781Z",
    fill: "url(#paint281_linear_1835_25046)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2464 52.363C9.66949 52.3094 9.15344 52.7212 9.07764 53.2958C9.00225 53.87 9.39405 54.4013 9.96514 54.4989C11.4096 54.8184 11.7195 52.4282 10.2464 52.363Z",
    fill: "url(#paint282_linear_1835_25046)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2198 19.419C29.8499 18.9733 29.1936 18.8999 28.7343 19.2526C28.2745 19.6049 28.1761 20.2581 28.5109 20.7307C29.3066 21.978 31.2151 20.5069 30.2198 19.419Z",
    fill: "url(#paint283_linear_1835_25046)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8647 7.85591C67.3608 7.7313 67.46 6.97583 66.9979 6.84381C66.5174 6.85162 66.4178 7.60709 66.8647 7.85591Z",
    fill: "url(#paint284_linear_1835_25046)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M101.73 27.983C102.168 28.2455 102.773 27.7814 102.539 27.3615C102.194 27.0271 101.589 27.4908 101.73 27.983Z",
    fill: "url(#paint285_linear_1835_25046)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M112.141 66.865C112.265 67.3611 113.021 67.4603 113.153 66.9982C113.145 66.5177 112.389 66.4181 112.141 66.865Z",
    fill: "url(#paint286_linear_1835_25046)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0159 101.73C91.7534 102.169 92.2175 102.773 92.6374 102.54C92.9718 102.194 92.5081 101.59 92.0159 101.73Z",
    fill: "url(#paint287_linear_1835_25046)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1343 112.14C52.6382 112.265 52.539 113.02 53.0011 113.152C53.4816 113.144 53.5812 112.389 53.1343 112.14Z",
    fill: "url(#paint288_linear_1835_25046)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2738 92.017C17.8352 91.7545 17.2304 92.2186 17.4641 92.6385C17.8094 92.9729 18.4141 92.5092 18.2738 92.017Z",
    fill: "url(#paint289_linear_1835_25046)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85585 53.135C7.73124 52.6389 6.97577 52.5397 6.84375 53.0018C6.85156 53.4823 7.60703 53.5819 7.85585 53.135Z",
    fill: "url(#paint290_linear_1835_25046)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M27.983 18.274C28.2455 17.8354 27.7815 17.2306 27.3616 17.4643C27.0272 17.8096 27.4909 18.4143 27.983 18.274Z",
    fill: "url(#paint291_linear_1835_25046)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1835_25046",
    x1: 54.4823,
    y1: 67.8135,
    x2: 68.0122,
    y2: 63.1076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1835_25046",
    x1: 52.5261,
    y1: 78.8157,
    x2: 83.7779,
    y2: 50.2758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1835_25046",
    x1: 8.2075,
    y1: 133.336,
    x2: 135.191,
    y2: 89.1691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1835_25046",
    x1: 68.1941,
    y1: 45.7738,
    x2: 72.3941,
    y2: 40.5548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1835_25046",
    x1: 78.1244,
    y1: 58.8979,
    x2: 83.5335,
    y2: 55.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1835_25046",
    x1: 75.7793,
    y1: 73.0946,
    x2: 81.1934,
    y2: 69.4611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1835_25046",
    x1: 63.4295,
    y1: 81.3414,
    x2: 66.9465,
    y2: 75.9578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1835_25046",
    x1: 49.0203,
    y1: 79.3821,
    x2: 53.2202,
    y2: 74.1631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1835_25046",
    x1: 40.0463,
    y1: 68.8221,
    x2: 45.4553,
    y2: 65.8752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1835_25046",
    x1: 42.1719,
    y1: 53.9211,
    x2: 47.5859,
    y2: 50.2875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1835_25046",
    x1: 53.5038,
    y1: 43.2642,
    x2: 57.0207,
    y2: 37.8805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1835_25046",
    x1: 51.9003,
    y1: 71.4674,
    x2: 71.7574,
    y2: 64.5608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1835_25046",
    x1: 58.1577,
    y1: 64.6345,
    x2: 65.8557,
    y2: 57.6045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1835_25046",
    x1: 60.6681,
    y1: 37.7008,
    x2: 62.6597,
    y2: 31.9167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1835_25046",
    x1: 77.45,
    y1: 50.4421,
    x2: 85.4177,
    y2: 44.6166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1835_25046",
    x1: 83.4692,
    y1: 69.288,
    x2: 88.9275,
    y2: 67.7206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1835_25046",
    x1: 72.579,
    y1: 83.0596,
    x2: 79.2158,
    y2: 75.4892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1835_25046",
    x1: 54.4298,
    y1: 86.1785,
    x2: 56.4214,
    y2: 80.3945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1835_25046",
    x1: 39.3602,
    y1: 79.5853,
    x2: 47.3279,
    y2: 73.7598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1835_25046",
    x1: 34.9907,
    y1: 63.0491,
    x2: 40.449,
    y2: 61.4817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1835_25046",
    x1: 43.4364,
    y1: 44.9685,
    x2: 50.0733,
    y2: 37.3981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1835_25046",
    x1: 68.6573,
    y1: 34.7184,
    x2: 74.5057,
    y2: 31.4934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1835_25046",
    x1: 45.7573,
    y1: 35.1844,
    x2: 50.8018,
    y2: 33.7175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1835_25046",
    x1: 30.49,
    y1: 52.4963,
    x2: 35.0797,
    y2: 51.4894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1835_25046",
    x1: 29.4312,
    y1: 75.0707,
    x2: 35.0096,
    y2: 72.7499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1835_25046",
    x1: 45.7921,
    y1: 90.2383,
    x2: 51.6404,
    y2: 87.0133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1835_25046",
    x1: 70.2612,
    y1: 91.5584,
    x2: 75.3057,
    y2: 90.0915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1835_25046",
    x1: 86.0096,
    y1: 75.3622,
    x2: 90.5992,
    y2: 74.3553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1835_25046",
    x1: 85.8062,
    y1: 50.5666,
    x2: 91.3845,
    y2: 48.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1835_25046",
    x1: 77.0643,
    y1: 39.1967,
    x2: 81.7532,
    y2: 37.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1835_25046",
    x1: 53.7358,
    y1: 32.9607,
    x2: 59.7683,
    y2: 30.1542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1835_25046",
    x1: 33.2274,
    y1: 43.6921,
    x2: 38.7778,
    y2: 41.0678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1835_25046",
    x1: 28.1375,
    y1: 67.3752,
    x2: 33.2762,
    y2: 66.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1835_25046",
    x1: 39.3006,
    y1: 87.8008,
    x2: 43.9895,
    y2: 86.6011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1835_25046",
    x1: 60.9253,
    y1: 92.6922,
    x2: 66.9577,
    y2: 89.8857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1835_25046",
    x1: 81.831,
    y1: 81.4555,
    x2: 87.3813,
    y2: 78.8313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1835_25046",
    x1: 87.87,
    y1: 60.1859,
    x2: 93.0087,
    y2: 58.8497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1835_25046",
    x1: 64.5203,
    y1: 21.1267,
    x2: 66.5463,
    y2: 20.5794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1835_25046",
    x1: 91.3661,
    y1: 36.4408,
    x2: 93.565,
    y2: 35.6298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1835_25046",
    x1: 99.2969,
    y1: 66.4305,
    x2: 101.628,
    y2: 65.3866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1835_25046",
    x1: 83.9151,
    y1: 93.5619,
    x2: 86.0419,
    y2: 92.8643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1835_25046",
    x1: 53.8992,
    y1: 101.757,
    x2: 55.9252,
    y2: 101.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1835_25046",
    x1: 26.8154,
    y1: 85.9864,
    x2: 29.0142,
    y2: 85.1753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1835_25046",
    x1: 18.6661,
    y1: 55.8094,
    x2: 20.9972,
    y2: 54.7655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1835_25046",
    x1: 34.3701,
    y1: 29.012,
    x2: 36.4969,
    y2: 28.3145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1835_25046",
    x1: 68.0831,
    y1: 21.4812,
    x2: 70.9013,
    y2: 18.9075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1835_25046",
    x1: 37.0811,
    y1: 27.0668,
    x2: 39.8993,
    y2: 24.4934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1835_25046",
    x1: 19.1105,
    y1: 52.9394,
    x2: 21.9287,
    y2: 50.3658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1835_25046",
    x1: 24.6964,
    y1: 83.9407,
    x2: 27.5144,
    y2: 81.3671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1835_25046",
    x1: 50.5694,
    y1: 101.915,
    x2: 53.3877,
    y2: 99.3416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1835_25046",
    x1: 81.5694,
    y1: 96.3267,
    x2: 84.3876,
    y2: 93.7533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1835_25046",
    x1: 99.544,
    y1: 70.4542,
    x2: 102.362,
    y2: 67.8805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1835_25046",
    x1: 95.4881,
    y1: 38.126,
    x2: 95.5196,
    y2: 38.1174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1835_25046",
    x1: 93.9562,
    y1: 39.4525,
    x2: 96.7741,
    y2: 36.8789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1835_25046",
    x1: 90.3343,
    y1: 31.3898,
    x2: 90.3347,
    y2: 31.3831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1835_25046",
    x1: 89.799,
    y1: 34.0225,
    x2: 92.6289,
    y2: 31.4808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1835_25046",
    x1: 61.2191,
    y1: 18.3349,
    x2: 61.2657,
    y2: 18.2943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1835_25046",
    x1: 61.2745,
    y1: 20.5843,
    x2: 64.0926,
    y2: 18.0106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1835_25046",
    x1: 31.387,
    y1: 29.6886,
    x2: 31.3931,
    y2: 29.6883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1835_25046",
    x1: 31.6374,
    y1: 31.2127,
    x2: 34.4291,
    y2: 28.6206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1835_25046",
    x1: 18.2955,
    y1: 58.7979,
    x2: 18.3403,
    y2: 58.7549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1835_25046",
    x1: 18.214,
    y1: 59.7475,
    x2: 21.0322,
    y2: 57.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1835_25046",
    x1: 28.8673,
    y1: 89.3907,
    x2: 31.6972,
    y2: 86.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1835_25046",
    x1: 58.7601,
    y1: 101.722,
    x2: 58.8067,
    y2: 101.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_1835_25046",
    x1: 57.3761,
    y1: 102.809,
    x2: 60.1942,
    y2: 100.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_1835_25046",
    x1: 88.6116,
    y1: 90.3894,
    x2: 88.6178,
    y2: 90.3891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_1835_25046",
    x1: 87.0065,
    y1: 92.1442,
    x2: 89.7982,
    y2: 89.5521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_1835_25046",
    x1: 100.439,
    y1: 63.6462,
    x2: 103.257,
    y2: 61.0727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_1835_25046",
    x1: 71.127,
    y1: 22.4336,
    x2: 73.8302,
    y2: 19.9634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_1835_25046",
    x1: 39.9673,
    y1: 25.598,
    x2: 42.6861,
    y2: 23.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_1835_25046",
    x1: 20.16,
    y1: 49.8537,
    x2: 22.8646,
    y2: 47.3854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_1835_25046",
    x1: 23.3083,
    y1: 81.0079,
    x2: 26.0003,
    y2: 78.5196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_1835_25046",
    x1: 47.5782,
    y1: 100.821,
    x2: 50.2813,
    y2: 98.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_1835_25046",
    x1: 78.7446,
    y1: 97.6797,
    x2: 81.4634,
    y2: 95.2267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_1835_25046",
    x1: 98.5467,
    y1: 73.4032,
    x2: 101.251,
    y2: 70.9349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_1835_25046",
    x1: 95.3903,
    y1: 42.2303,
    x2: 98.0823,
    y2: 39.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_1835_25046",
    x1: 87.4112,
    y1: 31.8415,
    x2: 90.1268,
    y2: 29.3822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_1835_25046",
    x1: 58.1244,
    y1: 20.7243,
    x2: 60.8315,
    y2: 18.2606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_1835_25046",
    x1: 29.5559,
    y1: 33.5676,
    x2: 32.253,
    y2: 31.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_1835_25046",
    x1: 18.4456,
    y1: 62.8546,
    x2: 21.1451,
    y2: 60.3809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_1835_25046",
    x1: 31.2999,
    y1: 91.4309,
    x2: 34.0154,
    y2: 88.9716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_1835_25046",
    x1: 60.5834,
    y1: 102.539,
    x2: 63.2904,
    y2: 100.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_1835_25046",
    x1: 89.1438,
    y1: 89.6777,
    x2: 91.8409,
    y2: 87.1941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_1835_25046",
    x1: 100.262,
    y1: 60.395,
    x2: 102.961,
    y2: 57.9214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_1835_25046",
    x1: 73.7839,
    y1: 24.0393,
    x2: 76.6393,
    y2: 21.4315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_1835_25046",
    x1: 42.9011,
    y1: 24.8463,
    x2: 45.7565,
    y2: 22.2386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_1835_25046",
    x1: 21.6374,
    y1: 47.2529,
    x2: 24.493,
    y2: 44.6453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_1835_25046",
    x1: 22.4441,
    y1: 78.1342,
    x2: 25.2996,
    y2: 75.5266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_1835_25046",
    x1: 44.8503,
    y1: 99.399,
    x2: 47.7057,
    y2: 96.7912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_1835_25046",
    x1: 75.7312,
    y1: 98.592,
    x2: 78.5866,
    y2: 95.9843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_1835_25046",
    x1: 96.9968,
    y1: 76.1857,
    x2: 99.8524,
    y2: 73.5781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_1835_25046",
    x1: 96.1902,
    y1: 45.3043,
    x2: 99.0457,
    y2: 42.6967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_1835_25046",
    x1: 84.7156,
    y1: 30.3503,
    x2: 87.5711,
    y2: 27.7422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_1835_25046",
    x1: 55.0964,
    y1: 21.5786,
    x2: 57.9522,
    y2: 18.9707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_1835_25046",
    x1: 27.948,
    y1: 36.321,
    x2: 30.8038,
    y2: 33.7133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_1835_25046",
    x1: 19.1765,
    y1: 65.9406,
    x2: 22.0322,
    y2: 63.3327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_1835_25046",
    x1: 33.9187,
    y1: 93.0881,
    x2: 36.7742,
    y2: 90.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_1835_25046",
    x1: 63.5379,
    y1: 101.855,
    x2: 66.3936,
    y2: 99.2473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_1835_25046",
    x1: 90.6863,
    y1: 87.1179,
    x2: 93.5421,
    y2: 84.5104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_1835_25046",
    x1: 99.4519,
    y1: 57.498,
    x2: 102.308,
    y2: 54.8901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_1835_25046",
    x1: 75.1763,
    y1: 26.1636,
    x2: 77.8988,
    y2: 23.7319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_1835_25046",
    x1: 45.4609,
    y1: 25.3458,
    x2: 48.1123,
    y2: 22.9337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_1835_25046",
    x1: 23.8675,
    y1: 45.7931,
    x2: 26.541,
    y2: 43.2969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_1835_25046",
    x1: 23.1142,
    y1: 75.4985,
    x2: 25.7573,
    y2: 73.0755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_1835_25046",
    x1: 43.5474,
    y1: 97.1221,
    x2: 46.2699,
    y2: 94.6904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_1835_25046",
    x1: 73.2753,
    y1: 97.8481,
    x2: 75.9267,
    y2: 95.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_1835_25046",
    x1: 94.8265,
    y1: 77.4205,
    x2: 97.5,
    y2: 74.9242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_1835_25046",
    x1: 95.6161,
    y1: 47.6831,
    x2: 98.2592,
    y2: 45.2601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_1835_25046",
    x1: 82.1983,
    y1: 30.1751,
    x2: 84.8451,
    y2: 27.7505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_1835_25046",
    x1: 53.2609,
    y1: 23.2738,
    x2: 55.9677,
    y2: 20.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_1835_25046",
    x1: 27.9495,
    y1: 38.765,
    x2: 30.603,
    y2: 36.3493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_1835_25046",
    x1: 20.9947,
    y1: 67.7095,
    x2: 23.6727,
    y2: 65.2317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_1835_25046",
    x1: 36.5323,
    y1: 93.0111,
    x2: 39.1791,
    y2: 90.5866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_1835_25046",
    x1: 65.4581,
    y1: 99.9897,
    x2: 68.1649,
    y2: 97.5499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_1835_25046",
    x1: 90.7854,
    y1: 84.4311,
    x2: 93.4389,
    y2: 82.0153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_1835_25046",
    x1: 97.7095,
    y1: 55.5117,
    x2: 100.388,
    y2: 53.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_1835_25046",
    x1: 47.3582,
    y1: 24.2991,
    x2: 62.7551,
    y2: 1.45166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_1835_25046",
    x1: 81.0525,
    y1: 55.7429,
    x2: 110,
    y2: 47.8859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_1835_25046",
    x1: 97.4499,
    y1: 90.6952,
    x2: 108.929,
    y2: 89.7594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_1835_25046",
    x1: 70.2841,
    y1: 108.373,
    x2: 103.51,
    y2: 93.5639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_1835_25046",
    x1: 36.7664,
    y1: 107.608,
    x2: 52.1633,
    y2: 84.7601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_1835_25046",
    x1: 16.3299,
    y1: 105.294,
    x2: 45.277,
    y2: 97.4368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_1835_25046",
    x1: 14.1413,
    y1: 80.1031,
    x2: 25.6206,
    y2: 79.1672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_1835_25046",
    x1: 20.7333,
    y1: 43.6514,
    x2: 53.9595,
    y2: 28.8425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_1835_25046",
    x1: 66.4324,
    y1: 14.8868,
    x2: 67.8519,
    y2: 14.6075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_1835_25046",
    x1: 31.4984,
    y1: 23.5472,
    x2: 33.0891,
    y2: 23.1916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_1835_25046",
    x1: 12.596,
    y1: 53.7915,
    x2: 14.4873,
    y2: 52.6287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_1835_25046",
    x1: 21.2623,
    y1: 88.7546,
    x2: 23.2722,
    y2: 87.6669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_1835_25046",
    x1: 52.4949,
    y1: 107.803,
    x2: 53.9144,
    y2: 107.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_1835_25046",
    x1: 87.2856,
    y1: 99.1302,
    x2: 88.8762,
    y2: 98.7746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_1835_25046",
    x1: 105.512,
    y1: 67.7278,
    x2: 107.403,
    y2: 66.5649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_1835_25046",
    x1: 96.8463,
    y1: 32.9663,
    x2: 98.8562,
    y2: 31.8787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_1835_25046",
    x1: 95.9811,
    y1: 31.9234,
    x2: 97.8453,
    y2: 31.3552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_1835_25046",
    x1: 64.9271,
    y1: 14.7249,
    x2: 65.9951,
    y2: 14.5773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_1835_25046",
    x1: 29.8792,
    y1: 24.3262,
    x2: 31.8877,
    y2: 23.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_1835_25046",
    x1: 12.317,
    y1: 55.2376,
    x2: 13.8678,
    y2: 53.8803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_1835_25046",
    x1: 22.5358,
    y1: 90.4721,
    x2: 24.4,
    y2: 89.9038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_1835_25046",
    x1: 54.2806,
    y1: 108.094,
    x2: 55.3486,
    y2: 107.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_1835_25046",
    x1: 88.4281,
    y1: 97.7731,
    x2: 90.4365,
    y2: 96.9759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_1835_25046",
    x1: 105.686,
    y1: 65.8839,
    x2: 107.237,
    y2: 64.5265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_1835_25046",
    x1: 68.8578,
    y1: 15.1577,
    x2: 69.9426,
    y2: 14.9889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_1835_25046",
    x1: 33.3423,
    y1: 21.957,
    x2: 34.9375,
    y2: 21.5209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_1835_25046",
    x1: 12.9742,
    y1: 51.3099,
    x2: 14.5221,
    y2: 50.1068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_1835_25046",
    x1: 20.0396,
    y1: 86.9179,
    x2: 21.8636,
    y2: 86.1107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_1835_25046",
    x1: 50.3324,
    y1: 107.404,
    x2: 51.4172,
    y2: 107.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_1835_25046",
    x1: 85.4107,
    y1: 100.29,
    x2: 87.0058,
    y2: 99.8544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_1835_25046",
    x1: 105.22,
    y1: 69.8351,
    x2: 106.768,
    y2: 68.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_1835_25046",
    x1: 98.3735,
    y1: 34.8486,
    x2: 100.198,
    y2: 34.0414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_1835_25046",
    x1: 94.5343,
    y1: 29.8838,
    x2: 96.3406,
    y2: 29.1879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_1835_25046",
    x1: 62.6495,
    y1: 14.3359,
    x2: 63.5421,
    y2: 14.2233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_1835_25046",
    x1: 28.238,
    y1: 25.7787,
    x2: 29.9428,
    y2: 25.2434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_1835_25046",
    x1: 12.1375,
    y1: 57.4867,
    x2: 13.4399,
    y2: 56.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_1835_25046",
    x1: 23.9542,
    y1: 92.046,
    x2: 25.7606,
    y2: 91.3501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_1835_25046",
    x1: 56.6886,
    y1: 108.241,
    x2: 57.5812,
    y2: 108.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_1835_25046",
    x1: 90.4001,
    y1: 96.3588,
    x2: 92.1049,
    y2: 95.8235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_1835_25046",
    x1: 106.042,
    y1: 63.4476,
    x2: 107.344,
    y2: 62.1979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_1835_25046",
    x1: 70.3879,
    y1: 15.9509,
    x2: 71.9558,
    y2: 15.5879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_1835_25046",
    x1: 35.2345,
    y1: 21.5041,
    x2: 36.6242,
    y2: 21.2296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_1835_25046",
    x1: 13.7692,
    y1: 49.8614,
    x2: 15.7186,
    y2: 48.8429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_1835_25046",
    x1: 19.2685,
    y1: 84.9838,
    x2: 21.1177,
    y2: 83.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_1835_25046",
    x1: 48.4094,
    y1: 106.602,
    x2: 49.9773,
    y2: 106.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_1835_25046",
    x1: 83.7149,
    y1: 101.113,
    x2: 85.1047,
    y2: 100.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_1835_25046",
    x1: 104.42,
    y1: 71.8408,
    x2: 106.369,
    y2: 70.8222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_1835_25046",
    x1: 98.8779,
    y1: 36.504,
    x2: 100.727,
    y2: 35.3713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_1835_25046",
    x1: 93.0709,
    y1: 29.0353,
    x2: 94.7911,
    y2: 28.5576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_1835_25046",
    x1: 60.6099,
    y1: 14.732,
    x2: 61.8681,
    y2: 14.5167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_1835_25046",
    x1: 26.9946,
    y1: 27.2088,
    x2: 28.9453,
    y2: 26.3591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_1835_25046",
    x1: 12.4172,
    y1: 59.5867,
    x2: 14.1723,
    y2: 58.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_1835_25046",
    x1: 25.5806,
    y1: 93.3561,
    x2: 27.3009,
    y2: 92.8784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_1835_25046",
    x1: 58.4477,
    y1: 107.982,
    x2: 59.706,
    y2: 107.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_1835_25046",
    x1: 91.315,
    y1: 94.7004,
    x2: 93.2656,
    y2: 93.8506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_1835_25046",
    x1: 105.669,
    y1: 61.7478,
    x2: 107.424,
    y2: 60.5071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_1835_25046",
    x1: 72.4542,
    y1: 16.7181,
    x2: 73.9856,
    y2: 16.3746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_1835_25046",
    x1: 37.2532,
    y1: 20.6107,
    x2: 38.5364,
    y2: 20.3853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_1835_25046",
    x1: 14.5245,
    y1: 47.7894,
    x2: 16.4567,
    y2: 46.7473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_1835_25046",
    x1: 18.3083,
    y1: 82.9475,
    x2: 20.0848,
    y2: 81.7242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_1835_25046",
    x1: 46.376,
    y1: 105.848,
    x2: 47.9075,
    y2: 105.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_1835_25046",
    x1: 81.7845,
    y1: 102.09,
    x2: 83.0676,
    y2: 101.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_1835_25046",
    x1: 103.655,
    y1: 73.868,
    x2: 105.588,
    y2: 72.8258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_1835_25046",
    x1: 99.7869,
    y1: 38.4155,
    x2: 101.563,
    y2: 37.1922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_1835_25046",
    x1: 91.4028,
    y1: 27.655,
    x2: 93.0957,
    y2: 27.2101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_1835_25046",
    x1: 58.5585,
    y1: 14.9472,
    x2: 59.6128,
    y2: 14.7994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_1835_25046",
    x1: 25.5482,
    y1: 28.8707,
    x2: 27.5248,
    y2: 27.9608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_1835_25046",
    x1: 12.6032,
    y1: 61.6048,
    x2: 14.1319,
    y2: 60.2855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_1835_25046",
    x1: 27.2797,
    y1: 94.8134,
    x2: 28.9727,
    y2: 94.3685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_1835_25046",
    x1: 60.6601,
    y1: 107.8,
    x2: 61.7143,
    y2: 107.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_1835_25046",
    x1: 92.7083,
    y1: 92.9941,
    x2: 94.685,
    y2: 92.0841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_1835_25046",
    x1: 105.455,
    y1: 59.5028,
    x2: 106.983,
    y2: 58.1835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_1835_25046",
    x1: 74.784,
    y1: 17.3165,
    x2: 76.4402,
    y2: 16.9145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_1835_25046",
    x1: 39.3393,
    y1: 19.3842,
    x2: 40.707,
    y2: 19.1347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_1835_25046",
    x1: 15.1077,
    y1: 45.4806,
    x2: 17.1208,
    y2: 44.4771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_1835_25046",
    x1: 17.0161,
    y1: 80.8742,
    x2: 18.8876,
    y2: 79.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_1835_25046",
    x1: 43.9383,
    y1: 105.269,
    x2: 45.5945,
    y2: 104.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_1835_25046",
    x1: 79.6323,
    y1: 103.396,
    x2: 80.9999,
    y2: 103.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_1835_25046",
    x1: 103.059,
    y1: 76.3265,
    x2: 105.072,
    y2: 75.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_1835_25046",
    x1: 101.028,
    y1: 40.5821,
    x2: 102.899,
    y2: 39.3409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_1835_25046",
    x1: 89.7205,
    y1: 25.9351,
    x2: 91.3941,
    y2: 25.5187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_1835_25046",
    x1: 55.9376,
    y1: 14.9226,
    x2: 57.291,
    y2: 14.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_1835_25046",
    x1: 23.7515,
    y1: 30.5476,
    x2: 25.7609,
    y2: 29.5706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_1835_25046",
    x1: 12.5389,
    y1: 64.2744,
    x2: 14.4011,
    y2: 63.0175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_1835_25046",
    x1: 28.9862,
    y1: 96.6249,
    x2: 30.6597,
    y2: 96.2085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_1835_25046",
    x1: 63.047,
    y1: 107.868,
    x2: 64.4004,
    y2: 107.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_1835_25046",
    x1: 94.4409,
    y1: 91.2835,
    x2: 96.4503,
    y2: 90.3064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_1835_25046",
    x1: 105.486,
    y1: 57.1649,
    x2: 107.348,
    y2: 55.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_1835_25046",
    x1: 76.7583,
    y1: 18.2343,
    x2: 78.3794,
    y2: 17.7578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_1835_25046",
    x1: 41.6269,
    y1: 18.6223,
    x2: 42.6757,
    y2: 18.4609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_1835_25046",
    x1: 16.403,
    y1: 43.5076,
    x2: 18.185,
    y2: 42.7742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_1835_25046",
    x1: 16.4882,
    y1: 78.5358,
    x2: 17.9881,
    y2: 77.3565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_1835_25046",
    x1: 41.9595,
    y1: 103.91,
    x2: 43.5805,
    y2: 103.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_1835_25046",
    x1: 77.5918,
    y1: 103.881,
    x2: 78.6406,
    y2: 103.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_1835_25046",
    x1: 102.079,
    y1: 78.307,
    x2: 103.861,
    y2: 77.5736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_1835_25046",
    x1: 101.748,
    y1: 42.5705,
    x2: 103.248,
    y2: 41.3913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_1835_25046",
    x1: 87.8624,
    y1: 24.6757,
    x2: 89.2207,
    y2: 24.3858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_1835_25046",
    x1: 53.8064,
    y1: 15.2877,
    x2: 55.1104,
    y2: 15.0204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_1835_25046",
    x1: 22.6414,
    y1: 32.3531,
    x2: 24.3929,
    y2: 31.3605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_1835_25046",
    x1: 13.2609,
    y1: 66.3999,
    x2: 14.9709,
    y2: 65.3907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_1835_25046",
    x1: 31.1046,
    y1: 97.7086,
    x2: 32.4629,
    y2: 97.4187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_1835_25046",
    x1: 65.2048,
    y1: 107.09,
    x2: 66.5088,
    y2: 106.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_1835_25046",
    x1: 95.6746,
    y1: 89.1102,
    x2: 97.4261,
    y2: 88.1176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_1835_25046",
    x1: 105.064,
    y1: 55.0001,
    x2: 106.774,
    y2: 53.9909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_1835_25046",
    x1: 78.6918,
    y1: 19.5369,
    x2: 80.2755,
    y2: 19.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_1835_25046",
    x1: 43.6107,
    y1: 18.1636,
    x2: 44.974,
    y2: 17.8996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_1835_25046",
    x1: 17.3571,
    y1: 41.5607,
    x2: 19.3154,
    y2: 40.5494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_1835_25046",
    x1: 15.9308,
    y1: 76.6038,
    x2: 17.758,
    y2: 75.4624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_1835_25046",
    x1: 40.0922,
    y1: 103.018,
    x2: 41.6758,
    y2: 102.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_1835_25046",
    x1: 75.3607,
    y1: 104.45,
    x2: 76.724,
    y2: 104.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_1835_25046",
    x1: 100.838,
    y1: 80.1605,
    x2: 102.796,
    y2: 79.1492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_1835_25046",
    x1: 102.216,
    y1: 44.8535,
    x2: 104.043,
    y2: 43.7121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_1835_25046",
    x1: 85.8305,
    y1: 23.6331,
    x2: 87.5535,
    y2: 23.1554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_1835_25046",
    x1: 51.6604,
    y1: 16.044,
    x2: 52.9228,
    y2: 15.8265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_1835_25046",
    x1: 21.5862,
    y1: 34.4498,
    x2: 23.5416,
    y2: 33.5965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_1835_25046",
    x1: 13.7378,
    y1: 68.537,
    x2: 15.4954,
    y2: 67.3028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_1835_25046",
    x1: 32.8188,
    y1: 98.7655,
    x2: 34.5418,
    y2: 98.2879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_1835_25046",
    x1: 67.3948,
    y1: 106.662,
    x2: 68.6572,
    y2: 106.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_1835_25046",
    x1: 96.719,
    y1: 87.462,
    x2: 98.6744,
    y2: 86.6087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_1835_25046",
    x1: 104.355,
    y1: 52.8023,
    x2: 106.113,
    y2: 51.5681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_1835_25046",
    x1: 80.4455,
    y1: 20.5924,
    x2: 82.5541,
    y2: 19.9898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_1835_25046",
    x1: 45.7918,
    y1: 17.7541,
    x2: 46.877,
    y2: 17.6275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_1835_25046",
    x1: 18.1514,
    y1: 39.9001,
    x2: 20.5054,
    y2: 38.9036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_1835_25046",
    x1: 14.8705,
    y1: 74.374,
    x2: 16.4507,
    y2: 72.7352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_1835_25046",
    x1: 37.8948,
    y1: 102.263,
    x2: 40.0033,
    y2: 101.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_1835_25046",
    x1: 73.4071,
    y1: 105.627,
    x2: 74.4923,
    y2: 105.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_1835_25046",
    x1: 99.8233,
    y1: 82.4501,
    x2: 102.177,
    y2: 81.4537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_1835_25046",
    x1: 102.744,
    y1: 46.7594,
    x2: 104.324,
    y2: 45.1206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_1835_25046",
    x1: 84.0805,
    y1: 22.7414,
    x2: 85.7351,
    y2: 22.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_1835_25046",
    x1: 49.4135,
    y1: 16.6421,
    x2: 51.0478,
    y2: 16.3328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_1835_25046",
    x1: 20.0147,
    y1: 36.1795,
    x2: 22.2376,
    y2: 34.7819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_1835_25046",
    x1: 13.9069,
    y1: 70.8416,
    x2: 16.1154,
    y2: 69.4302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_1835_25046",
    x1: 34.6704,
    y1: 100.454,
    x2: 36.325,
    y2: 100.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_1835_25046",
    x1: 69.353,
    y1: 106.568,
    x2: 70.9873,
    y2: 106.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_1835_25046",
    x1: 97.7276,
    y1: 85.5885,
    x2: 99.9505,
    y2: 84.1909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_1835_25046",
    x1: 103.833,
    y1: 50.9027,
    x2: 106.041,
    y2: 49.4913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_1835_25046",
    x1: 83.0307,
    y1: 19.6305,
    x2: 86.6807,
    y2: 18.3872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_1835_25046",
    x1: 105.96,
    y1: 49.4268,
    x2: 109.64,
    y2: 48.1474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_1835_25046",
    x1: 100.996,
    y1: 86.6125,
    x2: 104.689,
    y2: 85.3007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_1835_25046",
    x1: 71.1984,
    y1: 109.586,
    x2: 74.879,
    y2: 108.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_1835_25046",
    x1: 34.0033,
    y1: 104.652,
    x2: 37.6534,
    y2: 103.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_1835_25046",
    x1: 11.0344,
    y1: 74.8249,
    x2: 14.7141,
    y2: 73.5456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_1835_25046",
    x1: 15.9743,
    y1: 37.5848,
    x2: 19.6679,
    y2: 36.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_1835_25046",
    x1: 45.7999,
    y1: 14.6606,
    x2: 49.4806,
    y2: 13.3799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_1835_25046",
    x1: 84.8566,
    y1: 16.4935,
    x2: 88.1089,
    y2: 15.3417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_1835_25046",
    x1: 109.303,
    y1: 48.3386,
    x2: 112.49,
    y2: 47.2691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_1835_25046",
    x1: 104.053,
    y1: 88.0742,
    x2: 107.272,
    y2: 86.9744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_1835_25046",
    x1: 72.2172,
    y1: 112.419,
    x2: 75.4701,
    y2: 111.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_1835_25046",
    x1: 32.4796,
    y1: 107.214,
    x2: 35.7319,
    y2: 106.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_1835_25046",
    x1: 8.11524,
    y1: 75.4489,
    x2: 11.3024,
    y2: 74.3794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_1835_25046",
    x1: 13.3339,
    y1: 35.6972,
    x2: 16.5532,
    y2: 34.5975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_1835_25046",
    x1: 45.1079,
    y1: 11.2324,
    x2: 48.3608,
    y2: 10.0596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint268_linear_1835_25046",
    x1: 86.7857,
    y1: 13.3635,
    x2: 88.7763,
    y2: 12.6765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint269_linear_1835_25046",
    x1: 112.506,
    y1: 46.8444,
    x2: 114.465,
    y2: 46.1614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint270_linear_1835_25046",
    x1: 106.976,
    y1: 88.7437,
    x2: 108.976,
    y2: 88.0428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint271_linear_1835_25046",
    x1: 73.4883,
    y1: 114.437,
    x2: 75.4454,
    y2: 113.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint272_linear_1835_25046",
    x1: 31.5923,
    y1: 108.95,
    x2: 33.583,
    y2: 108.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint273_linear_1835_25046",
    x1: 5.89434,
    y1: 75.4151,
    x2: 7.85381,
    y2: 74.7321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint274_linear_1835_25046",
    x1: 11.3904,
    y1: 33.5517,
    x2: 13.39,
    y2: 32.8507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint275_linear_1835_25046",
    x1: 44.916,
    y1: 7.82619,
    x2: 46.8731,
    y2: 7.14692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint276_linear_1835_25046",
    x1: 65.3297,
    y1: 11.8534,
    x2: 68.3273,
    y2: 10.7974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint277_linear_1835_25046",
    x1: 98.6494,
    y1: 31.1565,
    x2: 101.67,
    y2: 30.1108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint278_linear_1835_25046",
    x1: 108.646,
    y1: 68.2926,
    x2: 111.622,
    y2: 67.2706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint279_linear_1835_25046",
    x1: 89.3577,
    y1: 101.623,
    x2: 92.3865,
    y2: 100.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint280_linear_1835_25046",
    x1: 52.2164,
    y1: 111.571,
    x2: 55.214,
    y2: 110.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint281_linear_1835_25046",
    x1: 18.8877,
    y1: 92.3448,
    x2: 21.9077,
    y2: 91.2994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint282_linear_1835_25046",
    x1: 8.92909,
    y1: 55.1792,
    x2: 11.9052,
    y2: 54.1572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint283_linear_1835_25046",
    x1: 28.1703,
    y1: 21.8609,
    x2: 31.1984,
    y2: 20.8027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint284_linear_1835_25046",
    x1: 66.5315,
    y1: 8.15954,
    x2: 67.5821,
    y2: 7.90039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint285_linear_1835_25046",
    x1: 101.652,
    y1: 28.3029,
    x2: 102.85,
    y2: 27.8495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint286_linear_1835_25046",
    x1: 112.075,
    y1: 67.5115,
    x2: 113.342,
    y2: 66.8901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint287_linear_1835_25046",
    x1: 91.8867,
    y1: 102.856,
    x2: 93.0298,
    y2: 102.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint288_linear_1835_25046",
    x1: 52.6565,
    y1: 113.456,
    x2: 53.7071,
    y2: 113.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint289_linear_1835_25046",
    x1: 17.3547,
    y1: 92.9955,
    x2: 18.5535,
    y2: 92.5421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint290_linear_1835_25046",
    x1: 6.77796,
    y1: 53.637,
    x2: 8.04484,
    y2: 53.0156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint291_linear_1835_25046",
    x1: 27.1953,
    y1: 18.5595,
    x2: 28.3384,
    y2: 18.1939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMandala7);
export default __webpack_public_path__ + "static/media/mandala-7.fafb353184bf79cf3a99845d3b9584d5.svg";
export { ForwardRef as ReactComponent };